export const schemaId: string = '974';

export enum KissanEventType {
  FIRST_OPEN = 'FIRST_OPEN',
  INSTALL_REFERRER = 'INSTALL_REFERRER',
  TRACK_UTM_PARAMETERS_USING_INSTALL_REFER_INTENT = 'TRACK_UTM_PARAMETERS_USING_INSTALL_REFER_INTENT',

  SELECT_LANG = 'SELECT_LANG',
  LANGUAGE = 'LANGUAGE',
  A_PAGE_OPENS_WHERE_THE_USER_IS_ASKED_TO_SELECTED_LANGUAGE = 'A_PAGE_OPENS_WHERE_THE_USER_IS_ASKED_TO_SELECTED_LANGUAGE',

  LANG_INPUT = 'LANG_INPUT',
  USER_CLICKS_ON_THE_PREFERRED_LANGUAGE = 'USER_CLICKS_ON_THE_PREFERRED_LANGUAGE',

  LANG_INPUT_SUCCESS = 'LANG_INPUT_SUCCESS',
  LANGUAGE_SELECTED_CORRECTLY = 'LANGUAGE_SELECTED_CORRECTLY',

  USERLOGIN_PAGELOAD_SUCCESS = 'USERLOGIN_PAGELOAD_SUCCESS',
  SIGN_IN = 'SIGN_IN',
  USERONBOARDING_PROMOTION1 = 'USERONBOARDING_PROMOTION1',
  USERONBOARDING_PROMOTION1_BACKBUTTON = 'USERONBOARDING_PROMOTION1_BACKBUTTON',
  USERONBOARDING_PROMOTION1_NEXT = 'USERONBOARDING_PROMOTION1_NEXT',
  USERONBOARDING_PROMOTION1_SKIP = 'USERONBOARDING_PROMOTION1_SKIP',
  USERONBOARDING_PROMOTION2 = 'USERONBOARDING_PROMOTION2',
  USERONBOARDING_PROMOTION2_BACKBUTTON = 'USERONBOARDING_PROMOTION2_BACKBUTTON',
  USERONBOARDING_PROMOTION2_NEXT = 'USERONBOARDING_PROMOTION2_NEXT',
  USERONBOARDING_PROMOTION2_SKIP = 'USERONBOARDING_PROMOTION2_SKIP',
  USERONBOARDING_PROMOTION3 = 'USERONBOARDING_PROMOTION3',
  USERONBOARDING_PROMOTION3_BACKBUTTON = 'USERONBOARDING_PROMOTION3_BACKBUTTON',
  USERONBOARDING_PROMOTION3_NEXT = 'USERONBOARDING_PROMOTION3_NEXT',
  USERONBOARDING_PROMOTION3_SKIP = 'USERONBOARDING_PROMOTION3_SKIP',

  USER_ENTER_NUMBER = 'USER_ENTER_NUMBER',
  SIGN_IN_PROCESS_STARTS = 'SIGN_IN_PROCESS_STARTS',

  USERLOGIN_NUMBER_CLICK = 'USERLOGIN_NUMBER_CLICK',
  USER_CLICKS_ON_THE_PHONE_NUMBER_BOX = 'USER_CLICKS_ON_THE_PHONE_NUMBER_BOX',

  SIGN_IN_PROCEED_PRESSED = 'SIGN_IN_PROCEED_PRESSED',
  SIGN_IN_API_FAILED = 'SIGN_IN_API_FAILED',
  USER_MOVES_TO_OTP_PAGE = 'USER_MOVES_TO_OTP_PAGE',
  RESEND_OTP_API_FAILED = 'RESEND_OTP_API_FAILED',

  USERLOGIN_SKIP = 'USERLOGIN_SKIP',

  LOGIN_PRIVACY_POLICY_CLICKED = 'LOGIN_PRIVACY_POLICY_CLICKED',
  TO_VIEW_THE_PRIVACY_POLICY = 'TO_VIEW_THE_PRIVACY_POLICY',

  OTP_REQUESTED = 'OTP_REQUESTED',
  OTP_REQUEST_WILL_BE_SENT_FROM_THE_USERS_SIDE = 'OTP_REQUEST_WILL_BE_SENT_FROM_THE_USERS_SIDE',
  ASYNC_AUTH_API_FAILED = 'ASYNC_AUTH_API_FAILED',
  ASYNC_USER_PROFILE_DETAIL_API_FAILED = 'ASYNC_USER_PROFILE_DETAIL_API_FAILED',
  EXCHANGE_TOKEN_API_FAILED = 'EXCHANGE_TOKEN_API_FAILED',
  OTP_VERIFY_CALLBACK_SUCCESS = 'OTP_VERIFY_CALLBACK_SUCCESS',
  RECEIVED_SUCCESSFULLY = 'RECEIVED_SUCCESSFULLY',

  THREADS_API_FAILED = 'THREADS_API_FAILED',
  DISLIKE_API_FAILED = 'DISLIKE_API_FAILED',
  SIX_DIGIT_OTP_ENTERED = 'SIX_DIGIT_OTP_ENTERED',
  USER_ENTERS_SIX_DIGIT_OTP_ENTERED = 'USER_ENTERS_SIX_DIGIT_OTP_ENTERED',

  NORMAL_LOGIN_SUCCESS = 'NORMAL_LOGIN_SUCCESS',
  LOGIN_SUCCESS = 'LOGIN_SUCCESS',

  NORMAL_LOGIN_FAILURE = 'NORMAL_LOGIN_FAILURE',
  WHEN_LOGIN_FAILS_DUE_TO_OTP_ERRORS = 'WHEN_LOGIN_FAILS_DUE_TO_OTP_ERRORS',

  OTP_RESEND_OTP_CLICKED = 'OTP_RESEND_OTP_CLICKED',
  USER_CLICKS_ON_RESEND_OTP = 'USER_CLICKS_ON_RESEND_OTP',

  OTP_AUTO_DETECTED = 'OTP_AUTO_DETECTED',
  OTP_IS_AUTODETECTED_FROM_MESSAGES_AND_FILLED_UP = 'OTP_IS_AUTODETECTED_FROM_MESSAGES_AND_FILLED_UP',
  EDIT_PROFILE_API_FAILED = 'EDIT_PROFILE_API_FAILED',

  USER_PROFILE_API_FAILED = 'USER_PROFILE_API_FAILED',
  HOMEPAGE_LOAD_SUCCESS = 'HOMEPAGE_LOAD_SUCCESS',
  USER_IS_LANDED_IN_HOMEPAGE_AFTER_THE_SIGNUP = 'USER_IS_LANDED_IN_HOMEPAGE_AFTER_THE_SIGNUP',

  REELS_SCROLL_1 = 'REELS_SCROLL_1',
  IN_FEED_PAGE_REELS_ARE_PRESENT_IN_HORIZONTAL_ORDER_WHICH_NEEDS_TO_BE_SCROLLED = 'IN_FEED_PAGE_REELS_ARE_PRESENT_IN_HORIZONTAL_ORDER_WHICH_NEEDS_TO_BE_SCROLLED',
  FEED_REELS = 'FEED_REELS',

  REELS_SCROLL_PAGEVERTICAL = 'REELS_SCROLL_PAGEVERTICAL',
  THE_NUMBER_OF_PAGES_REELS_SCROLLED_BY_THE_USER_IS_SHOWN_HORIZONTALLY = 'THE_NUMBER_OF_PAGES_REELS_SCROLLED_BY_THE_USER_IS_SHOWN_HORIZONTALLY',
  THE_NUMBER_OF_PAGES_REELS_SCROLLED_BY_THE_USER_IS_SHOWN_VERTICALLS = 'THE_NUMBER_OF_PAGES_REELS_SCROLLED_BY_THE_USER_IS_SHOWN_VERTICALLS',

  REELS_SCROLL_VERTICAL_PAGE_END = 'REELS_SCROLL_VERTICAL_PAGE_END',
  IN_FEED_PAGE_REELS_ARE_PRESENT_IN_VERTICAL_ORDER_WHICH_SCROLLED_AND_REACHED_END = 'IN_FEED_PAGE_REELS_ARE_PRESENT_IN_VERTICAL_ORDER_WHICH_SCROLLED_AND_REACHED_END',

  REELS_SCROLL_VERTICAL_PAGE_STARTED = 'REELS_SCROLL_VERTICAL_PAGE_STARTED',
  VERTICAL_VIDEO_SCROLL_REACHED_FIRST_VIDEO = 'VERTICAL_VIDEO_SCROLL_REACHED_FIRST_VIDEO',

  REELS_PLAY = 'REELS_PLAY',
  WHEN_REELS_ARE_PLAYED = 'WHEN_REELS_ARE_PLAYED',

  REELS_PAUSED = 'REELS_PAUSED',
  WHEN_REELS_ARE_PAUSED = 'WHEN_REELS_ARE_PAUSED',

  REELS_ERROR = 'REELS_ERROR',
  WHEN_REELS_DONOT_PLAY_DUE_TO_SOME_REASON = 'WHEN_REELS_DONOT_PLAY_DUE_TO_SOME_REASON',

  VERTICAL_SCROLL_VIDEO = 'VERTICAL_SCROLL_VIDEO',
  WHEN_VERTICAL_SCROLL_FOR_THE_VIDEO_IS_DONE = 'WHEN_VERTICAL_SCROLL_FOR_THE_VIDEO_IS_DONE',

  FEED_VIDEO = 'FEED_VIDEO',

  BOTTOM_NAV_FEED_CLICKED = 'BOTTOM_NAV_FEED_CLICKED',
  USER_CAN_SCROLL_THROUGH_THE_DIFFERENT_SECTIONS_PAGES_FEED_DISCOVERY_HOME_ETC_THROUGH_THE_BOTTOM_NAV = 'USER_CAN_SCROLL_THROUGH_THE_DIFFERENT_SECTIONS_PAGES_FEED_DISCOVERY_HOME_ETC_THROUGH_THE_BOTTOM_NAV',
  SCREEN_NAVIGATE = 'SCREEN_NAVIGATE',

  VIDEO_ON_READY_TIME = 'VIDEO_ON_READY_TIME',
  VIDEO_READY_TO_PLAY = 'VIDEO_READY_TO_PLAY',

  VIDEO_PLAY = 'VIDEO_PLAY',
  VIDEO_IS_PLAYED = 'VIDEO_IS_PLAYED',

  VIDEO_PAUSED = 'VIDEO_PAUSED',
  VIDEO_IS_PAUSED = 'VIDEO_IS_PAUSED',

  VIDEO_BACK_PRESSED = 'VIDEO_BACK_PRESSED',

  RELATED_VIDEO_CLICK = 'RELATED_VIDEO_CLICK',
  RELATED_VIDEO_OR_RECOMMENDATIONS_OF_THE_VIDEO_IS_CLICKED_BY_THE_USER = 'RELATED_VIDEO_OR_RECOMMENDATIONS_OF_THE_VIDEO_IS_CLICKED_BY_THE_USER',

  VIDEO_ERROR = 'VIDEO_ERROR',
  VIDEO_FAILS_TO_PLAY = 'VIDEO_FAILS_TO_PLAY',

  VIDEO_PLAY_FINISH = 'VIDEO_PLAY_FINISH',
  ONCE_THE_WHOLE_VIDEO_IS_PLAYED_AND_CLOSED = 'ONCE_THE_WHOLE_VIDEO_IS_PLAYED_AND_CLOSED',

  ITEM_CLICKED = 'ITEM_CLICKED',
  FEED_ITEM = 'FEED_ITEM',
  WHEN_USER_CLICKS_ON_THE_ITEM_ON_FEED_PAGE = 'WHEN_USER_CLICKS_ON_THE_ITEM_ON_FEED_PAGE',

  ITEM_LIKED = 'ITEM_LIKED',
  ITEM_DISLIKED = 'ITEM_DISLIKED',
  WHEN_USER_CLICKS_ON_THE_ICON_LIKE_ON_FEED_PAGE = 'WHEN_USER_CLICKS_ON_THE_ICON_LIKE_ON_FEED_PAGE',

  ITEM_COMMENT = 'ITEM_COMMENT',
  WHEN_USER_CLICKS_ON_THE_ICON_COMMENT_ON_FEED_PAGE = 'WHEN_USER_CLICKS_ON_THE_ICON_COMMENT_ON_FEED_PAGE',

  ITEM_SHARED = 'ITEM_SHARED',
  WHEN_USER_CLICKS_ON_THE_ICON_SHARE_ON_FEED_PAGE = 'WHEN_USER_CLICKS_ON_THE_ICON_SHARE_ON_FEED_PAGE',

  ITEM_REPORTED = 'ITEM_REPORTED',
  WHEN_USER_CLICKS_ON_THE_ICON_REPORT_ON_FEED_PAGE = 'WHEN_USER_CLICKS_ON_THE_ICON_REPORT_ON_FEED_PAGE',

  ITEM_PROFILE_CLICKED = 'ITEM_PROFILE_CLICKED',
  WHEN_USER_CLICKS_ON_THE_PROFILE_ICON_IN_HIS_PROFILE = 'WHEN_USER_CLICKS_ON_THE_PROFILE_ICON_IN_HIS_PROFILE',

  USER_PROFILE_CLICKED = 'USER_PROFILE_CLICKED',
  PROFILE = 'PROFILE',
  WHEN_THE_NAME_OF_THE_USER_ON_THE_POST_IS_CLICKED_TO_VIEW_HIS_PROFILE = 'WHEN_THE_NAME_OF_THE_USER_ON_THE_POST_IS_CLICKED_TO_VIEW_HIS_PROFILE',

  NOTIFICATIONS_CLICKED = 'NOTIFICATIONS_CLICKED',
  USER_CLICKS_ON_THE_NOTIFICATION_ICON = 'USER_CLICKS_ON_THE_NOTIFICATION_ICON',

  PAGE_SCROLL_READ = 'PAGE_SCROLL_READ',
  ALL_PAGES = 'ALL_PAGES',

  PAGE_SCROLL_FAILS = 'PAGE_SCROLL_FAILS',
  WHEN_THE_PAGE_FAILS_TO_SCROLL_OR_LOAD = 'WHEN_THE_PAGE_FAILS_TO_SCROLL_OR_LOAD',

  BACK_PRESS = 'BACK_PRESS',
  WHEN_A_USER_CLICKS_ON_BACK_PRESS_WHAT_PAGE_DOES_EACH_OF_IT_LAND_AT = 'WHEN_A_USER_CLICKS_ON_BACK_PRESS_WHAT_PAGE_DOES_EACH_OF_IT_LAND_AT',

  APP_UNINSTALLED = 'APP_UNINSTALLED',
  PUSH_NOTIFICATION_FAILURE_BACKEND = 'PUSH_NOTIFICATION_FAILURE_BACKEND',
  WHEN_PUSH_NOTIFICATION_DELIVERY_FAILS_WITH_APP_UNINSTALLED_STATUS = 'WHEN_PUSH_NOTIFICATION_DELIVERY_FAILS_WITH_APP_UNINSTALLED_STATUS',
  WHEN_USER_CLICKS_ON_THE_ICON_DISLIKE_ON_FEED_PAGE = 'WHEN_USER_CLICKS_ON_THE_ICON_DISLIKE_ON_FEED_PAGE',
  REELS_SCROLL_VERTICAL = 'REELS_SCROLL_VERTICAL',

  CLICK_POST = 'CLICK_POST',
  CLICK_ON_POST_BUTTON_ON_TOP_RIGHT = 'CLICK_ON_POST_BUTTON_ON_TOP_RIGHT',
  POST_PAGEOPEN_SUCCESS = 'POST_PAGEOPEN_SUCCESS',
  NEXT_PAGE_OPENS_FOR_ADDING_CONTENT = 'NEXT_PAGE_OPENS_FOR_ADDING_CONTENT',
  SELECT_UPLOAD_PIC = 'SELECT_UPLOAD_PIC',
  SELECT_UPLOAD_VIDEO = 'SELECT_UPLOAD_VIDEO',
  PHOTO_UPLOAD_SUCCESS = 'PHOTO_UPLOAD_SUCCESS',
  VIDEO_UPLOAD_SUCCESS = 'VIDEO_UPLOAD_SUCCESS',
  SELECT_POST = 'SELECT_POST',
  THE_USER_CLICK_ON_POST_AT_END_OF_BOX = 'THE_USER_CLICK_ON_POST_AT_END_OF_BOX',
  SELECT_CREATEPOST = 'SELECT_CREATEPOST',
  THE_USER_CHOOSE_CREATE_POST_OPTION_AT_THE_HOMEPAGE = 'THE_USER_CHOOSE_CREATE_POST_OPTION_AT_THE_HOMEPAGE',
  NOTIFICATION_PERMISSION_GIVEN_BY_USER = 'NOTIFICATION_PERMISSION_GIVEN_BY_USER',
  NOTIFICATION_PERMISSION_DENIED_BY_USER = 'NOTIFICATION_PERMISSION_DENIED_BY_USER',
  NOTIFICATION_TRIGGER_POPUP = 'NOTIFICATION_TRIGGER_POPUP',
  NOTIFICATION_TRIGGER_ALLOW = 'NOTIFICATION_TRIGGER_ALLOW',
  NOTIFICATION_TRIGGER_DISALLOW = 'NOTIFICATION_TRIGGER_DISALLOW',
  LOCATION_PERMISSION_GIVEN_BY_USER = 'LOCATION_PERMISSION_GIVEN_BY_USER',
  LOCATION_PERMISSION_DENIED_BY_USER = 'LOCATION_PERMISSION_DENIED_BY_USER',
  MEDIA_PERMISSION_GIVEN_BY_USER = 'MEDIA_PERMISSION_GIVEN_BY_USER',
  MEDIA_PERMISSION_DENIED_BY_USER = 'MEDIA_PERMISSION_DENIED_BY_USER',
  KISAN_PUSH_VIEW = 'KISAN_PUSH_VIEW',
  NOTIFICATION_SENT = 'NOTIFICATION_SENT',
  NOTIFICATION_CLICKED = 'NOTIFICATION_CLICKED',
  NOTIFICATION_DISMISSED = 'NOTIFICATION_DISMISSED',
  FOREGROUND_NOTIFICATION_DISMISSED = 'FOREGROUND_NOTIFICATION_DISMISSED',
  FOREGROUND_NOTIFICATION_PRESSED = 'FOREGROUND_NOTIFICATION_PRESSED',
  DIS_BOTTOMNAV_CLICKED = 'DIS_BOTTOMNAV_CLICKED',
  DIS_PAGEOPEN_SUCCESS = 'DIS_PAGEOPEN_SUCCESS',
  DIS_PAGEOPEN_FAIL = 'DIS_PAGEOPEN_FAIL',
  DIS_PAGESCROLL_VERTICAL = 'DIS_PAGESCROLL_VERTICAL',
  DIS_PAGESCROLL_HORIZONTAL_CONTINUEWATCH = 'DIS_PAGESCROLL_HORIZONTAL_CONTINUEWATCH',
  DIS_CONTINUWATCH_CLICKED = 'DIS_CONTINUWATCH_CLICKED',
  DIS_CONTINUEWATCH_VIDEOPLAY_SUCCESS = 'DIS_CONTINUEWATCH_VIDEOPLAY_SUCCESS',
  DIS_CONTINUEWATCH_VIDEOPLAY_FAIL = 'DIS_CONTINUEWATCH_VIDEOPLAY_FAIL',
  DIS_PAGESCROLL_HORIZONTAL_VIDEOSONCROPS = 'DIS_PAGESCROLL_HORIZONTAL_VIDEOSONCROPS',
  DIS_PAGESCROLL_HORIZONTAL_TRENDING = 'DIS_PAGESCROLL_HORIZONTAL_TRENDING',
  DIS_PAGESCROLL_HORIZONTAL_MACHINERY = 'DIS_PAGESCROLL_HORIZONTAL_MACHINERY',
  DIS_PAGESCROLL_HORIZONTAL_ANIMALS = 'DIS_PAGESCROLL_HORIZONTAL_ANIMALS',
  DIS_PAGESCROLL_HORIZONTAL_GOVT_SCHEME = 'DIS_PAGESCROLL_HORIZONTAL_GOVT_SCHEME',
  DIS_PAGESCROLL_HORIZONTAL_POPULAR = 'DIS_PAGESCROLL_HORIZONTAL_POPULAR',
  DIS_PAGESCROLL_HORIZONTAL_EXPERTS = 'DIS_PAGESCROLL_HORIZONTAL_EXPERTS',
  DIS_VIEW_CLICK = 'DIS_VIEW_CLICK',
  DIS_VIEWALLCLICK_SUCCESS = 'DIS_VIEWALLCLICK_SUCCESS',
  DIS_PAGESCROLL_HORIZONTAL_TOPVIDEO = 'DIS_PAGESCROLL_HORIZONTAL_TOPVIDEO',
  DIS_SEARCH_CLICK = 'DIS_SEARCH_CLICK',
  DIS_SEARCH_CLICKSUCCESS = 'DIS_SEARCH_CLICKSUCCESS',
  DIS_CLICKON_VIDEOCATEGORY = 'DIS_CLICKON_VIDEOCATEGORY',
  DIS_NOTIFICATION_CLICK = 'DIS_NOTIFICATION_CLICK',
  DIS_VIDEO_CLICKED = 'DIS_VIDEO_CLICKED',
  DIS_VIDEOPLAY_SUCCESS = 'DIS_VIDEOPLAY_SUCCESS',
  BOTTOM_NAV_CLICKED_QNA = 'BOTTOM_NAV_CLICKED_QNA',
  QNA_PAGEOPEN_SUCCESS = 'QNA_PAGEOPEN_SUCCESS',
  QNA_PAGEOPEN_FAIL = 'QNA_PAGEOPEN_FAIL',
  QNA_PAGESCROLL_VERTICAL_START = 'QNA_PAGESCROLL_VERTICAL_START',
  QNA_PAGESCROLL_VERTICAL_FAIL = 'QNA_PAGESCROLL_VERTICAL_FAIL',
  QNA_FILTERCLICK_SUCCESS = 'QNA_FILTERCLICK_SUCCESS',
  QNA_FILTERCLICK_FAIL = 'QNA_FILTERCLICK_FAIL',
  QNA_ANSWERBOXOPEN_CLICK_SUCCESS = 'QNA_ANSWERBOXOPEN_CLICK_SUCCESS',
  QNA_ANSWERBOXOPEN_FAIL = 'QNA_ANSWERBOXOPEN_FAIL',
  QNA_SUBMIT_SUCCESS = 'QNA_SUBMIT_SUCCESS',
  QNA_SUBMIT_FAIL = 'QNA_SUBMIT_FAIL',
  QNA_COMMENTBOXOPEN_SUCCESS = 'QNA_COMMENTBOXOPEN_SUCCESS',
  QNA_COMMENTBOXOPEN_FAIL = 'QNA_COMMENTBOXOPEN_FAIL',
  QNA_MICCOMMENT_SUCCESS = 'QNA_MICCOMMENT_SUCCESS',
  QNA_MICCOMMENT_FAIL = 'QNA_MICCOMMENT_FAIL',
  QNA_MICANSWER_SUCCESS = 'QNA_MICANSWER_SUCCESS',
  QNA_MICANSWER_FAIL = 'QNA_MICANSWER_FAIL',
  QNA_VIEWANSWER_CLICK = 'QNA_VIEWANSWER_CLICK',
  QNA_VIEWANSWER_ITEMCLICK = 'QNA_VIEWANSWER_ITEMCLICK',
  QNA_SHARECLICK_SUCCESS = 'QNA_SHARECLICK_SUCCESS',
  QNA_SHARECLICK_FAIL = 'QNA_SHARECLICK_FAIL',
  QNA_HELPFULCLICK_SUCCESS = 'QNA_HELPFULCLICK_SUCCESS',
  QNA_NOTHELPFULCLICKS_SUCCESS = 'QNA_NOTHELPFULCLICKS_SUCCESS',
  QNA_ASKQUES_CLICK = 'QNA_ASKQUES_CLICK',
  QNA_QUESTABOPEN_SUCCESS = 'QNA_QUESTABOPEN_SUCCESS',
  QNA_QUESTABOPEN_FAIL = 'QNA_QUESTABOPEN_FAIL',
  QNA_UPLOADPIC_ITEMCLICK = 'QNA_UPLOADPIC_ITEMCLICK',
  QNA_GALLERYOPEN_SUCCESS = 'QNA_GALLERYOPEN_SUCCESS',
  QNA_GALLERYOPEN_FAIL = 'QNA_GALLERYOPEN_FAIL',
  QNA_UPLOADVIDEO_ITEMCLICK = 'QNA_UPLOADVIDEO_ITEMCLICK',
  QNA_ASKSUBMIT_SUCCESS = 'QNA_ASKSUBMIT_SUCCESS',
  QNA_ASKSUBMIT_FAIL = 'QNA_ASKSUBMIT_FAIL',
  QNA_VIEWANS1_CLICK_BOTTOMSHEET = 'QNA_VIEWANS1_CLICK_BOTTOMSHEET',
  QNA_FEEDBACK_SUBMIT = 'QNA_FEEDBACK_SUBMIT',
  QNA_MYQUESCLICK_SUCCESS = 'QNA_MYQUESCLICK_SUCCESS',
  QNA_MYQUESCLICK_FAIL = 'QNA_MYQUESCLICK_FAIL',
  QNA_SEARCH_CLICK = 'QNA_SEARCH_CLICK',
  ANONYMOUS_USER_NOT_LOGGEDIN = 'ANONYMOUS_USER_NOT_LOGGEDIN',
  QNA_ANSWERBOXOPEN_SUCCESS = 'QNA_ANSWERBOXOPEN_SUCCESS',
  QNA_ANSWER_LIKED = 'QNA_ANSWER_LIKED',
  QNA_ANSWER_DISLIKED = 'QNA_ANSWER_DISLIKED',
  DIS_ITEM_LIKE = 'DIS_ITEM_LIKE',
  DIS_ITEM_COMMENT = 'DIS_ITEM_COMMENT',
  DIS_ITEM_SHARE = 'DIS_ITEM_SHARE',
  MYQUES_PAGESCROLL_VERTICAL = 'MYQUES_PAGESCROLL_VERTICAL',
  PLAYLIST_VIDEOSCROLL_END = 'PLAYLIST_VIDEOSCROLL_END',
  SHORT_VIDEO_SCROLLED_END = 'SHORT_VIDEO_SCROLLED_END',
  SHORT_VIDEO_CLICKED = 'SHORT_VIDEO_CLICKED',
  SHORT_VIDEO_SCROLLED = 'SHORT_VIDEO_SCROLLED',
  LOGIN_INITIATE_POPUP = 'LOGIN_INITIATE_POPUP',
  FEEDPAGE_ASKQUES_CLICK = 'FEEDPAGE_ASKQUES_CLICK',
  BOTTOMSHEET_LOGIN_CLICK = 'BOTTOMSHEET_LOGIN_CLICK',
  LANGUAGE_CHANGE_CLICK = 'LANGUAGE_CHANGE_CLICK',
  VIDEO_PLAYED_MORE_THAN_FIVE_SECONDS = 'VIDEO_PLAYED_MORE_THAN_FIVE_SECONDS',
  DATA_VIEWED_MORETHAN_ONE_SECOND = 'DATA_VIEWED_MORETHAN_ONE_SECOND',
  USER_ACTION = 'USER_ACTION',
  MODERATOR_ANSWER_SUBMITTED = 'MODERATOR_ANSWER_SUBMITTED',
  HOMEPAGE_LOAD_FAILED = 'HOMEPAGE_LOAD_FAILED',
  HOMEPAGE_INITIATED_SUCCESSFULLY = 'HOMEPAGE_INITIATED_SUCCESSFULLY',
  VIDEO_PROGRESS = 'VIDEO_PROGRESS',
  PLACEHOLDER_TOPCOMPONENT_HOMEPAGE = 'PLACEHOLDER_TOPCOMPONENT_HOMEPAGE',
  QNA_USERTYPE_QUESTION = 'QNA_USERTYPE_QUESTION',
  POST_USERTYPE = 'POST_USERTYPE',
  QNA_DELETE_IMAGE_ITEMCLICK = 'QNA_DELETE_IMAGE_ITEMCLICK',
  SELF_ANSWER_VIEW = 'SELF_ANSWER_VIEW',
  QNA_READ_MORE_CLICK = 'QNA_READ_MORE_CLICK',
  QNA_READ_LESS_CLICK = 'QNA_READ_LESS_CLICK',
  TRUECALLER_POPUP = 'TRUECALLER_POPUP',
  TRUECALLER_POPUP_FAILED = 'TRUECALLER_POPUP_FAILED',
  TRUECALLER_LOADTIME = 'TRUECALLER_LOADTIME',
  TRUECALLER_APPROVED = 'TRUECALLER_APPROVED',
  TRUECALLER_DENIED = 'TRUECALLER_DENIED',
  TRUECALLER_INSTALLED = 'TRUECALLER_INSTALLED',
  TRUECALLER_API_ERROR = 'TRUECALLER_API_ERROR',
  TRUECALLER_USERPROFILE = 'TRUECALLER_USERPROFILE',
  API_ERROR = 'API_ERROR',
  VIDEO_BUFFER_TIME = 'VIDEO_BUFFER_TIME',
  REFERRAL_SHARE = 'REFERRAL_SHARE',
  REFERRAL_COPY = 'REFERRAL_COPY',
  ENTER_REFERRALCODE_CLICKED = 'ENTER_REFERRALCODE_CLICKED',
  REFERRALCODE_BOTTOMSHEET_OPEN = 'REFERRALCODE_BOTTOMSHEET_OPEN',
  REFERRALCODE_START_TYPE = 'REFERRALCODE_START_TYPE',
  REFERRALCODE_SUBMIT = 'REFERRALCODE_SUBMIT',
  REFERRAL_VERIFICATION_API_SUCCESS = 'REFERRAL_VERIFICATION_API_SUCCESS',
  REFERRAL_VERIFICATION_API_FAILURE = 'REFERRAL_VERIFICATION_API_FAILURE',
  USER_PROFILE_API_SUCCESS = 'USER_PROFILE_API_SUCCESS',
  USER_LOGOUT = 'USER_LOGOUT',
  HOME_SEARCH_CLICK = 'HOME_SEARCH_CLICK',
  TOURGUIDE_LAUNCH_SUCCESSFUL_HP = 'TOURGUIDE_LAUNCH_SUCCESSFUL_HP',
  TOURGUIDE_LAUNCH_FAILURE_HP = 'TOURGUIDE_LAUNCH_FAILURE_HP',
  TOURGUIDE_LAUNCH_SUCCESSFUL_ASKAQUESTION = 'TOURGUIDE_LAUNCH_SUCCESSFUL_ASKAQUESTION',
  TOURGUIDE_LAUNCH_FAILURE_ASKAQUESTION = 'TOURGUIDE_LAUNCH_FAILURE_ASKAQUESTION',
  TOURGUIDE_LAUNCH_SUCCESSFUL_CREATEAPOST = 'TOURGUIDE_LAUNCH_SUCCESSFUL_CREATEAPOST',
  TOURGUIDE_LAUNCH_FAILURE_CREATEAPOST = 'TOURGUIDE_LAUNCH_FAILURE_CREATEAPOST',
  TOURGUIDE_SKIP = 'TOURGUIDE_SKIP',
  TOURGUIDE_NEXT = 'TOURGUIDE_NEXT',
  TOURGUIDE_FINISH = 'TOURGUIDE_FINISH ',
  TOURGUIDE_PREVIOUS = 'TOURGUIDE_PREVIOUS',
  SHORTS_VIDEO_ON_READY_TIME = 'SHORTS_VIDEO_ON_READY_TIME',
  RELATED_VIDEO_CLICKED = 'RELATED_VIDEO_CLICKED',
  NO_NETWORK_TRY_AGAIN_CLICKED = 'NO_NETWORK_TRY_AGAIN_CLICKED',
  FEED_RELATED_VIDEO_CLICKED = 'FEED_RELATED_VIDEO_CLICKED',
  MANDI_NEWS_ICON_CLICKED = 'MANDI_NEWS_ICON_CLICKED',
  MANDI_NEWS_CLOSE_ICON_CLICKED = 'MANDI_NEWS_CLOSE_ICON_CLICKED',
  MANDI_NEWS_BACK_ICON_PRESSED = 'MANDI_NEWS_BACK_ICON_PRESSED',
  FEED_WEATHER_CARD_CLICK = 'FEED_WEATHER_CARD_CLICK',
  WEATHER_SHARE_CLICK = 'WEATHER_SHARE',
  WEATHER_PAGE_OPEN_SUCCESS = 'WEATHER_PAGE_OPEN_SUCCESS',
  WEATHER_DAY_SELECT = 'WEATHER_DAY_SELECT',
  FEED_WEATHER_BUTTON_CLICK = 'FEED_WEATHER_BUTTON_CLICK',
  WEATHER_LOCATION_POPUP = 'WEATHER_LOCATION_POPUP',

  FEED_USER_CROPSELECT = 'FEED_USER_CROPSELECT',
  PROFILE_USER_CROPSELECT = 'PROFILE_USER_CROPSELECT',
  CROP_CATEGORY_PAGEOPEN = 'CROP_CATEGORY_PAGEOPEN',
  CROP_CATEGORY_SELECT = 'CROP_CATEGORY_SELECT',
  CROP_REMOVE = 'CROP_REMOVE',
  CROP_ADDED = 'CROP_ADDED',
  DIS_VIDEO_PLAY_FINISH = 'DIS_VIDEO_PLAY_FINISH',
  DIS_VIDEO_ON_READY_TIME = 'DIS_VIDEO_ON_READY_TIME',
  QUESTION_ANSWERED_POPUP_CLICK = 'QUESTION_ANSWERED_POPUP_CLICK',
  QUESTION_ANSWERED_POPUP_CROSS = 'QUESTION_ANSWERED_POPUP_CROSS',
  ANSWER_INPROGRESS_BAR = 'ANSWER_INPROGRESS_BAR',
  AUTO_PLAY_VIDEO_ERROR = 'AUTO_PLAY_VIDEO_ERROR',
  AUTO_PLAY_VIDEO_PLAY = 'AUTO_PLAY_VIDEO_PLAY',
  AUTO_PLAY_VIDEO_IS_PLAYED = 'AUTO_PLAY_VIDEO_IS_PLAYED',
  AUTO_PLAY_VIDEO_ON_READY_TIME = 'AUTO_PLAY_VIDEO_ON_READY_TIME',
  AUTO_PLAY_VIDEO_READY_TO_PLAY = 'AUTO_PLAY_VIDEO_READY_TO_PLAY',
  AUTO_PLAY_VIDEO_PLAY_FINISH = 'AUTO_PLAY_VIDEO_PLAY_FINISH',
  AUTO_PLAY_ONCE_THE_WHOLE_VIDEO_IS_PLAYED_AND_CLOSED = 'AUTO_PLAY_ONCE_THE_WHOLE_VIDEO_IS_PLAYED_AND_CLOSED',
  NOTIFICATION_SENT_ERROR = 'NOTIFICATION_SENT_ERROR',
  AUTO_PLAY_VIDEO_BUFFER_TIME = 'AUTO_PLAY_VIDEO_BUFFER_TIME',
  HOMEPAGE_NO_DATA_FOUND = 'HOMEPAGE_NO_DATA_FOUND',
  SELECTED_CROP_BEFORE_LOGIN = 'SELECTED_CROP_BEFORE_LOGIN',
  GLOBAL_SEARCH_CLICK = 'GLOBAL_SEARCH_CLICK',
  SEARCH_SUGGESTIONS_CLICK = 'SEARCH_SUGGESTIONS_CLICK',
  SEARCH_CATEGORY_CLICK = 'SEARCH_CATEGORY_CLICK',
  SEARCH_ITEM_CLICK_SUCCESS = 'SEARCH_ITEM_CLICK_SUCCESS',
  SEARCH_ITEM_CLICK_FAILED = 'SEARCH_ITEM_CLICK_FAILED',

  PROFILE_EDIT_SELECT = 'PROFILE_EDIT_SELECT',
  PROFILE_EDIT_PAGEOPEN = 'PROFILE_EDIT_PAGEOPEN',
  PROFILE_EDIT_SAVE = 'PROFILE_EDIT_SAVE',
  PROFILE_LANG_CHANGE = 'PROFILE_LANG_CHANGE',
  PROFILE_REFER_CLICK = 'PROFILE_REFER_CLICK',
  PROFILE_T_AND_C_CLICK = 'PROFILE_T_AND_C_CLICK',
  PROFILE_PP_CLICK = 'PROFILE_PP_CLICK',
  PROFILE_SENDFEEDBACK_CLICK = 'PROFILE_SENDFEEDBACK_CLICK',
  PROFILE_CONTACTUS_CLICK = 'PROFILE_CONTACTUS_CLICK',
  PROFILE_SELF_MYPROFILE = 'PROFILE_SELF_MYPROFILE',
  PROFILE_SELF_VIDEOS = 'PROFILE_SELF_VIDEOS',
  PROFILE_SELF_QUESTIONS = 'PROFILE_SELF_QUESTIONS',
  PROFILE_SELF_ACTIVITY = 'PROFILE_SELF_ACTIVITY',
  PROFILE_OTHERS_ALL = 'PROFILE_OTHERS_ALL',
  PROFILE_OTHERS_VIDEOS = 'PROFILE_OTHERS_VIDEOS',
  PROFILE_OTHERS_QUESTIONS = 'PROFILE_OTHERS_QUESTIONS',
  PROFILE_OTHERS_ACTIVITY = 'PROFILE_OTHERS_ACTIVITY',
  PROFILE_OTHERS_ITEM_CLICK = 'PROFILE_OTHERS_ITEM_CLICK',
  PROFILE_CLICK_HOMEPAGE = 'PROFILE_CLICK_HOMEPAGE',

  FEEDPAGE_USER_FOLLOW = 'FEEDPAGE_USER_FOLLOW',
  FEEDPAGE_USER_UNFOLLOW = 'FEEDPAGE_USER_UNFOLLOW',
  PROFILE_USER_FOLLOW = 'PROFILE_USER_FOLLOW',
  FOLLOWING_USER_FOLLOW = 'FOLLOWING_USER_FOLLOW',
  FOLLOWERS_USER_FOLLOW = 'FOLLOWERS_USER_FOLLOW',
  FOLLOWING_LIST_CLICK = 'FOLLOWING_LIST_CLICK',
  FOLLOWERS_LIST_CLICK = 'FOLLOWERS_LIST_CLICK',
  FOLLOW_BACK_CLICK = 'FOLLOW_BACK_CLICK',
  USER_UNFOLLOW_CLICK = 'USER_UNFOLLOW_CLICK',
  FOLLOW_BOTTOMSHEET_OPEN = 'FOLLOW_BOTTOMSHEET_OPEN',
  QNA_USER_FOLLOW = 'QNA_USER_FOLLOW',
  QNA_USER_UNFOLLOW = 'QNA_USER_UNFOLLOW',

  ADS_STARTED = 'ADS_STARTED',
  ADS_COMPLETED = 'ADS_COMPLETED',
  ADS_LOADED = 'ADS_LOADED',
  ADS_PROGRESS = 'ADS_PROGRESS',
  ADS_PAUSED = 'ADS_PAUSED',
  ADS_FIRST_QUARTILE = 'ADS_FIRST_QUARTILE',
  ADS_MIDPOINT = 'ADS_MIDPOINT',
  ADS_THIRD_QUARTILE = 'ADS_THIRD_QUARTILE',
  VIDEO_CONTENT_PAUSE_REQUESTED = 'VIDEO_CONTENT_PAUSE_REQUESTED',
  VIDEO_CONTENT_RESUME_REQUESTED = 'VIDEO_CONTENT_RESUME_REQUESTED',
  ADS_SKIPPED = 'ADS_SKIPPED',
  ALL_ADS_COMPLETED = 'ALL_ADS_COMPLETED',
  FEED_LOGIN_CLICK = 'FEED_LOGIN_CLICK',
  FEED_LANG_INPUT = 'FEED_LANG_INPUT',
  FEED_USER_CLICKS_ON_THE_PREFERRED_LANGUAGE = 'FEED_USER_CLICKS_ON_THE_PREFERRED_LANGUAGE',
  FEED_LANG_INPUT_SUCCESS = 'FEED_LANG_INPUT_SUCCESS',
  FEED_LANGUAGE_SELECTED_CORRECTLY = 'FEED_LANGUAGE_SELECTED_CORRECTLY',
  PROFILE_CLICK_QNA = 'PROFILE_CLICK_QNA',
  AUTO_VIDEO_PLAY_VIDEO_PROGRESS = 'AUTO_VIDEO_PLAY_VIDEO_PROGRESS',
  AUTO_VIDEO_PLAY_VIDEO_PROGRESS_ONE = 'AUTO_VIDEO_PLAY_VIDEO_PROGRESS_ONE',
  QNA_SEARCH_QUESTIONSELECT = 'QNA_SEARCH_QUESTIONSELECT',
  QNA_SEARCH_NORESULT = 'QNA_SEARCH_NORESULT',
  QNA_SEARCH_SUGGESTION_CLICK = 'QNA_SEARCH_SUGGESTION_CLICK',
  QNA_SEARCH_WORD = 'QNA_SEARCH_WORD',
  QNA_SEARCH_TYPE = 'QNA_SEARCH_TYPE',
  QNA_SUGGESTION_CLICK = 'QNA_SUGGESTION_CLICK',
  QNA_ASK_CLICK = 'QNA_ASK_CLICK',
  QNA_CONTINUEASK_CLICK = 'QNA_CONTINUEASK_CLICK',
  FEED_USER_ANIMALSELECT = 'FEED_USER_ANIMALSELECT',
  PROFILE_USER_ANIMALSELECT = 'PROFILE_USER_ANIMALSELECT',
  ANIMAL_REMOVE = 'ANIMAL_REMOVE',
  ANIMAL_ADDED = 'ANIMAL_ADDED',
  SHORTS_AD_LOADED = 'SHORTS_AD_LOADED',
  SHORTS_AD_CLICKED = 'SHORTS_AD_CLICKED',
  SHORTS_AD_CLOSED = 'SHORTS_AD_CLOSED',
  SHORTS_AD_ERROR = 'SHORTS_AD_ERROR',
  FEEDPAGE_DIS_CONTINUWATCH_CLICKED = 'FEEDPAGE_DIS_CONTINUWATCH_CLICKED',
  FEEDPAGE_DIS_PAGESCROLL_HORIZONTAL_CONTINUEWATCHING = 'FEEDPAGE_DIS_PAGESCROLL_HORIZONTAL_CONTINUEWATCHING',
  FEEDPAGE_DIS_VIDEO_CLICKED = 'FEEDPAGE_DIS_VIDEO_CLICKED',
  FEEDPAGE_DIS_PAGESCROLL_HORIZONTAL_TRENDING = 'FEEDPAGE_DIS_PAGESCROLL_HORIZONTAL_TRENDING',
  FEEDPAGE_DIS_CLICKON_VIDEOCATEGORY = 'FEEDPAGE_DIS_CLICKON_VIDEOCATEGORY',
  FEEDPAGE_DIS_PAGESCROLL_HORIZONTAL_VIDEOSONCROPS = 'FEEDPAGE_DIS_PAGESCROLL_HORIZONTAL_VIDEOSONCROPS',
  FEEDPAGE_DIS_PAGESCROLL_HORIZONTAL_MACHINERY = 'FEEDPAGE_DIS_PAGESCROLL_HORIZONTAL_MACHINERY',
  FEEDPAGE_DIS_PAGESCROLL_HORIZONTAL_GOVT_SCHEME = 'FEEDPAGE_DIS_PAGESCROLL_HORIZONTAL_GOVT_SCHEME',
  FEEDPAGE_DIS_PAGESCROLL_HORIZONTAL_ANIMALS = 'FEEDPAGE_DIS_PAGESCROLL_HORIZONTAL_ANIMALS',
  FEEDPAGE_DIS_CLICKON_VIDEOMACHINERY = 'FEEDPAGE_DIS_CLICKON_VIDEOMACHINERY',
  FEEDPAGE_DIS_CLICKON_VIDEOGOVTSCEME = 'FEEDPAGE_DIS_CLICKON_VIDEOGOVTSCEME',
  FEEDPAGE_DIS_CLICKON_VIDEOCATTLE = 'FEEDPAGE_DIS_CLICKON_VIDEOCATTLE',
  AUTO_PLAY_VIDEO_PROGRESS_THIRTY_SECONDS = 'AUTO_PLAY_VIDEO_PROGRESS_THIRTY_SECONDS',
  VIDEO_VIEWED_LESS_THAN_FIVE_SECONDS = 'VIDEO_VIEWED_LESS_THAN_FIVE_SECONDS',
  AUTO_PLAY_VIDEO_PROGRESS_TWENTY_SECONDS = 'AUTO_PLAY_VIDEO_PROGRESS_TWENTY_SECONDS',
  SEARCH_RESULT_POSTITEM_CLICK = 'SEARCH_RESULT_POSTITEM_CLICK',
  SEARCH_RESULT_QNAITEM_CLICK = 'SEARCH_RESULT_QNAITEM_CLICK',
  SEARCH_RESULT_VIDEOITEM_CLICK = 'SEARCH_RESULT_VIDEOITEM_CLICK',
  NO_AUTO_SUGGESTION_FOUND = 'NO_AUTO_SUGGESTION_FOUND',
  TOURGUIDE_LAUNCH_SUCCESSFUL_FEEDUSERFOLLOW = 'TOURGUIDE_LAUNCH_SUCCESSFUL_FEEDUSERFOLLOW',

  ANSWER_RECEIVED_BOTTOMSHEET_DISPLAY = 'ANSWER_RECEIVED_BOTTOMSHEET_DISPLAY',
  ANSWER_RECEIVED_BOTTOMSHEET_CANCEL = 'ANSWER_RECEIVED_BOTTOMSHEET_CANCEL',
  ANSWER_RECEIVED_BOTTOMSHEET_VIEWANSWER = 'ANSWER_RECEIVED_BOTTOMSHEET_VIEWANSWER',
  ANSWER_RECEIVED_STICKYBANNER_DISPLAY = 'ANSWER_RECEIVED_STICKYBANNER_DISPLAY',
  ANSWER_RECEIVED_STICKYBANNER_VIEWANSWER = 'ANSWER_RECEIVED_STICKYBANNER_VIEWANSWER',

  FULLSCREEN_AUTO_LOAD = 'FULLSCREEN_AUTO_LOAD',
  FULLSCREEN_BUTTON_CLICKED = 'FULLSCREEN_BUTTON_CLICKED',
  ASPECTRATIO_CLICKED = 'ASPECTRATIO_CLICKED',
  RECOMMENDED_VIDEO_SCROLL = 'RECOMMENDED_VIDEO_SCROLL',
  TRANSCODING_ERROR = 'TRANSCODING_ERROR',
  RETURNING_USER = 'RETURNING_USER',
  FOLLOW_QNA_PAGE = 'FOLLOW_QNA_PAGE',
  FOLLOW_SHORTS_PAGE = 'FOLLOW_SHORTS_PAGE',
  FOLLOW_FEEDVIDEO = 'FOLLOW_FEEDVIDEO',
  BOTTOMNAV_PRODUCTS_CLICKED = 'BOTTOMNAV_PRODUCTS_CLICKED',
  PRODUCT_VIEWALL_CLICK = 'PRODUCT_VIEWALL_CLICK',
  PRODUCT_PAGE_SCROLL = 'PRODUCT_PAGE_SCROLL',
  PRODUCT_CLICK = 'PRODUCT_CLICK',
  VIEW_PRODUCT_CLICK = 'VIEW_PRODUCT_CLICK',
  PRODUCT_PAGEOPEN_SUCCESS = 'PRODUCT_PAGEOPEN_SUCCESS',
  PRODUCT_CATEGORY_CLICK = 'PRODUCT_CATEGORY_CLICK',
  PRODUCT_SUBCATEGORY_CLICK = 'PRODUCT_SUBCATEGORY_CLICK',
  HORIZONATAL_SCROLL_IMPRESSIONS = 'HORIZONATAL_SCROLL_IMPRESSIONS',
  IM_INTERESTED_CLICK = 'IM_INTERESTED_CLICK',
  PRODUCT_VARIANT_CHANGE = 'PRODUCT_VARIANT_CHANGE',
  MACHINERY_PAGEOPEN_SUCCESS = 'MACHINERY_PAGEOPEN_SUCCESS',
  COURSES_PAGEOPEN_SUCCESS = 'COURSES_PAGEOPEN_SUCCESS',
  CHEMICALS_PAGEOPEN_SUCCESS = 'CHEMICALS_PAGEOPEN_SUCCESS',
  PRODUCT_MYORDERS_CLICK = 'PRODUCT_MYORDERS_CLICK',
  MYORDERS_PAGEOPEN_SUCCESS = 'MYORDERS_PAGEOPEN_SUCCESS',

  COURSES_LEARNING_CLICK = 'COURSES_LEARNING_CLICK',
  PRODUCT_SHARE_CLICK = 'PRODUCT_SHARE_CLICK',
  VIEW_ALL_INSTRUCTORS = 'VIEW_ALL_INSTRUCTORS',
  PRODUCT_SUBCATEGORY_PAGEOPEN_SUCCESS = 'PRODUCT_SUBCATEGORY_PAGEOPEN_SUCCESS',
  AUTOPLAY_VIDEO_EXPAND = 'AUTOPLAY_VIDEO_EXPAND',
  AUTOPLAY_VIDEO_SHORTEN = 'AUTOPLAY_VIDEO_SHORTEN',
  COMMENT_THREADS_API_ERROR = 'COMMENT_THREADS_API_ERROR',
  AUTOPLAY_VIDEO_STATIC_BANNER_LOADED = 'AUTOPLAY_VIDEO_STATIC_BANNER_LOADED',
  AUTOPLAY_VIDEO_STATIC_BANNER_DISMISS = 'AUTOPLAY_VIDEO_STATIC_BANNER_DISMISS',
  AUTOPLAY_VIDEO_STATIC_BANNER_OPENED = 'AUTOPLAY_VIDEO_STATIC_BANNER_OPENED',
  PRODUCT_CART_CLICK = 'PRODUCT_CART_CLICK',
  CART_PAGEOPEN_SUCCESS = 'CART_PAGEOPEN_SUCCESS',
  PAY_NOW_CLICK = 'PAY_NOW_CLICK',
  BUY_NOW_CLICK = 'BUY_NOW_CLICK',
  ADD_TO_CART = 'ADD_TO_CART',
  PAYMENT_REDIRECTION_OPEN = 'PAYMENT_REDIRECTION_OPEN',
  PAYMENT_SUCCESS = 'PAYMENT_SUCCESS',
  PAYMENT_FAILED = 'PAYMENT_FAILED',
  RAZORPAY_PRELOAD_FAILED = 'RAZORPAY_PRELOAD_FAILED',
  SPEAKONMIC_CLICK = 'SPEAKONMIC_CLICK',
  SPEAKONMIC_BOTTOMSHEET_DISPLAY = 'SPEAKONMIC_BOTTOMSHEET_DISPLAY',
  MIC_STARTRECORDING_CLICK = 'MIC_STARTRECORDING_CLICK',
  MIC_STOPRECORDING_CLICK = 'MIC_STOPRECORDING_CLICK',
  SPEAKONMIC_BOTTOMSHEET_CROSS = 'SPEAKONMIC_BOTTOMSHEET_CROSS',
  MIC_TRYAGAIN = 'MIC_TRYAGAIN',
  MIC_DONETALKING = 'MIC_DONETALKING',
  MIC_SUBMIT = 'MIC_SUBMIT',
  SPEAKONMIC_ERROR_DISPLAYED = 'SPEAKONMIC_ERROR_DISPLAYED',
  AUTOPLAY_SEEK_COMPLETED = 'AUTOPLAY_SEEK_COMPLETED',
  AUTOPLAY_SEEK_STARTED = 'AUTOPLAY_SEEK_STARTED',
  HOMEFEED_TIMEOUT = 'HOMEFEED_TIMEOUT',
  PRODUCT_LEADCAPTURE = 'PRODUCT_LEADCAPTURE',
  PRODUCT_LEADCAPTURE_SUBMIT = 'PRODUCT_LEADCAPTURE_SUBMIT',
  PRODUCT_LEADCAPTURE_TYPING = 'PRODUCT_LEADCAPTURE_TYPING',
  BANNER_AD_LOAD = 'BANNER_AD_LOAD',
  BANNER_AD_OPENED = 'BANNER_AD_OPENED',
  BANNER_AD_FAILED = 'BANNER_AD_FAILED',

  PRODUCT_SEARCH_SUGGESTION_CLICK = 'PRODUCT_SEARCH_SUGGESTION_CLICK',
  PRODUCT_SEARCH_NORESULT = 'PRODUCT_SEARCH_NORESULT',

  INSTALL_REFERRER_INFO = 'INSTALL_REFERRER_INFO',
  WEB_VITALS = 'WEB_VITALS',

  REACTION_CLICK = 'REACTION_CLICK',

  PWA_BUTTON_CLICKED = 'PWA_BUTTON_CLICKED',
  PWA_INSTALL_PROMPT_ACCEPTED = 'PWA_INSTALL_PROMPT_ACCEPTED',
  PWA_INSTALL_PROMPT_REJECTED = 'PWA_INSTALL_PROMPT_REJECTED',
  PAGE_TRY_AGAIN_CLICKED = 'PAGE_TRY_AGAIN_CLICKED',
  HOMPAGEMAIN_LOAD_INITIATED = 'HOMPAGEMAIN_LOAD_INITIATED',
  HOMPAGEMAIN_LOAD_SUCCESS = 'HOMPAGEMAIN_LOAD_SUCCESS',
  HOMPAGEMAIN_LOAD_FAILED = 'HOMPAGEMAIN_LOAD_FAILED',
  ACTIVE_USER_FILTER_CLICK = 'ACTIVE_USER_FILTER_CLICK',
  ACTIVE_USER_FILTER_SELECT = 'ACTIVE_USER_FILTER_SELECT',
  DATE_FILTER_CLICK = 'DATE_FILTER_CLICK',
  DATE_FILTER_SELECT = 'DATE_FILTER_SELECT',
  CLEAR_ALL_CLICKED = 'CLEAR_ALL_CLICKED',
  SUBCATEGORY_SELECTED = 'SUBCATEGORY_SELECTED',
  SUBCATEGORY_UNSELECTED = 'SUBCATEGORY_UNSELECTED',
  DROPDOWN_CLICKED = 'DROPDOWN_CLICKED',
  NOTIFICATION_POPUP_OPEN = 'NOTIFICATION_POPUP_OPEN',
  NOTIFICATION_POPUP_CLOSE = 'NOTIFICATION_POPUP_CLOSE',
  LOCATION_POPUP_OPEN = 'LOCATION_POPUP_OPEN',
  LOCATION_POPUP_CLOSE = 'LOCATION_POPUP_CLOSE',
  HOMEPAGE_PULL_TO_REFRESH = 'HOMEPAGE_PULL_TO_REFRESH',
  HOMEPAGE_BANNER_CLICK = 'HOMEPAGE_BANNER_CLICK',
  PRODUCT_SEARCH_CLICK = 'PRODUCT_SEARCH_CLICK',
  RECOMMENDED_PRODUCT_CLICK = 'RECOMMENDED_PRODUCT_CLICK',

  RECOMMENDED_PRODUCT_SCROLL = 'RECOMMENDED_PRODUCT_SCROLL',
  FAT_FOOTER_CLICK = 'FAT_FOOTER_CLICK',
  FAT_FOOTER_VIEW = 'FAT_FOOTER_VIEW',
  SEARCH_TRENDING_VIDEO_CLICK = 'SEARCH_TRENDING_VIDEO_CLICK',
  ANSWER_SUBMIT_DIRECT_BOT = 'ANSWER_SUBMIT_DIRECT_BOT',
  ANSWER_SUBMIT_EDITED_BOT = 'ANSWER_SUBMIT_EDITED_BOT',
  COURSEDETAIL_LOAD_SUCCESS = 'COURSEDETAIL_LOAD_SUCCESS',
  PRODUCTDETAIL_LOAD_SUCCESS = 'PRODUCTDETAIL_LOAD_SUCCESS',
  PRODUCTS_BANNER_CLICK = 'PRODUCTS_BANNER_CLICK',
  QNA_ANSWER_VIEWED_MORETHAN_FIVE_SECOND = 'QNA_ANSWER_VIEWED_MORETHAN_FIVE_SECOND',
  HOME_FLOAT_ICON_SEARCH_CLICK = 'HOME_FLOAT_ICON_SEARCH_CLICK',
  APP_UPDATE_NORMAL_SUCCESS = 'APP_UPDATE_NORMAL_SUCCESS',
  APP_UPDATE_NORMAL_ERROR = 'APP_UPDATE_NORMAL_ERROR',
  APP_UPDATE_FORCE = 'APP_UPDATE_FORCE',
  AUTOPLAY_VIDEO_FAIL_BEFORE_INTERACTION = 'AUTOPLAY_VIDEO_FAIL_BEFORE_INTERACTION',
  AUTOPLAY_VIDEO_FAIL_AFTER_INTERACTION = 'AUTOPLAY_VIDEO_FAIL_AFTER_INTERACTION',
  PRODUCT_NUDGE_VIEWED_MORETHAN_ONE_SECOND = 'PRODUCT_NUDGE_VIEWED_MORETHAN_ONE_SECOND',
  AD_SLOT_LOAD_REQUEST = 'AD_SLOT_LOAD_REQUEST',
  WA_AUTOLOGIN_CLICK = 'WA_AUTOLOGIN_CLICK',
  WA_AUTOLOGIN_REDIRECTED = 'WA_AUTOLOGIN_REDIRECTED',

  CLICK_ON_WRITE_VIDEO_REVIEW = 'CLICK_ON_WRITE_VIDEO_REVIEW',
  CLICK_ON_WRITE_REVIEW = 'CLICK_ON_WRITE_REVIEW',
  WRITE_REVIEW_BOTTOMSHEET_LOAD_SUCCESS = 'WRITE_REVIEW_BOTTOMSHEET_LOAD_SUCCESS',
  PRODUCT_RATED = 'PRODUCT_RATED',
  PRODUCT_ADD_MEDIA_CLICK = 'PRODUCT_ADD_MEDIA_CLICK',
  PRODUCT_UPLOAD_IMAGE = 'PRODUCT_UPLOAD_IMAGE',
  PRODUCT_IMAGE_UPLOADED = 'PRODUCT_IMAGE_UPLOADED',
  PRODUCT_VIDEO_UPLOADED = 'PRODUCT_VIDEO_UPLOADED',
  USER_TYPING_TITLE_REVIEW = 'USER_TYPING_TITLE_REVIEW',
  USER_TYPING_DESCRIPTION_REVIEW = 'USER_TYPING_DESCRIPTION_REVIEW',
  REVIEW_SUBMITTED = 'REVIEW_SUBMITTED',
  CLICK_ON_REVIEW = 'CLICK_ON_REVIEW',
  VIEWALL_REVIEWS = 'VIEWALL_REVIEWS',
  VIEWALL_REVIEWS_LOAD_SUCCESS = 'VIEWALL_REVIEWS_LOAD_SUCCESS',
  DATA_VIEWED_MORE_THAN_ONE_SECOND = 'DATA_VIEWED_MORE_THAN_ONE_SECOND',
  WEB_WIDGET_DETAIL_LOAD = 'WEB_WIDGET_DETAIL_LOAD',
  AUTO_VIDEO_PLAY_PRODUCT_DETAIL = 'AUTO_VIDEO_PLAY_PRODUCT_DETAIL',
  CALL_ICON_CLICK = 'CALL_ICON_CLICK',
  MY_COURSES_CLICK = 'MY_COURSES_CLICK',
  COMING_SOON_CLICK = 'COMING_SOON_CLICK',
  PDF_VIEW_COURSES_CLICKED = 'PDF_VIEW_COURSES_CLICKED',
  PDF_LOADED_SUCCESSFULLY = 'PDF_LOADED_SUCCESSFULLY',
  HOMEPAGE_GAMEZOP_CLICKED = 'HOMEPAGE_GAMEZOP_CLICKED',
  RATESPAGE_LOAD_SUCCESS = 'RATESPAGE_LOAD_SUCCESS',
  RATESPAGE_CTA_CLICK = 'RATESPAGE_CTA_CLICK',
  AGRINEWSLINK_CLICK = 'AGRINEWSLINK_CLICK',
  AGRINEWS_SEARCH_CLICK = 'AGRINEWS_SEARCH_CLICK',
  AGRINEWS_SEARCH_ITEMS = 'AGRINEWS_SEARCH_ITEMS',
  AGRINEWS_LOAD_SUCCESS = 'AGRINEWS_LOAD_SUCCESS',
  AGRINEWS_DETAIL_PAGE_LOAD_SUCCESS = 'AGRINEWS_DETAIL_PAGE_LOAD_SUCCESS',
  DEVOTIONAL_LOAD_SUCCESS = 'DEVOTIONAL_LOAD_SUCCESS',
  DEVOTIONAL_DETAIL_PAGE_CLICK = 'DEVOTIONAL_DETAIL_PAGE_CLICK',
  DEVOTIONAL_SEARCH_CLICK = 'DEVOTIONAL_SEARCH_CLICK',
  DEVOTIONAL_SEARCH_ITEMS = 'DEVOTIONAL_SEARCH_ITEMS',
  DEVOTIONAL_STREAM_LOAD_SUCCESS = 'DEVOTIONAL_STREAM_LOAD_SUCCESS',
  DEVOTIONAL_STREAM_RELATED_VIDEO_CLICKED = 'DEVOTIONAL_STREAM_RELATED_VIDEO_CLICKED',
  DEVOTIONAL_SEARCH_SELECT = 'DEVOTIONAL_SEARCH_SELECT',
  AGRINEWS_OPEN_WEB_BROWSER_CLICK = 'AGRINEWS_OPEN_WEB_BROWSER_CLICK',
  QNA_BANNER_VIEWED_MORETHAN_ONE_SECOND = 'QNA_BANNER_VIEWED_MORETHAN_ONE_SECOND',
  HOMEPAGE_FEED_IMAGE_CLICKED = 'HOMEPAGE_FEED_IMAGE_CLICKED',
  AGRINEWS_AUDIO_CLICK = 'AGRINEWS_AUDIO_CLICK',
  AGRINEWS_AUDIO_PLAY = 'AGRINEWS_AUDIO_PLAY',
  AUTO_PLAY_AUDIO_PLAYONE = 'AUTO_PLAY_AUDIO_PLAYONE',
  AUTO_PLAY_AUDIO_PLAYTWENTY = 'AUTO_PLAY_AUDIO_PLAYTWENTY',
  AUTO_PLAY_AUDIO_PLAYTHIRTY = 'AUTO_PLAY_AUDIO_PLAYTHIRTY',
  AUTO_PLAY_AUDIO_PLAYPROGRESS = 'AUTO_PLAY_AUDIO_PLAYPROGRESS',
  AUDIO_PLAYBACK_COMPLETED = 'AUDIO_PLAYBACK_COMPLETED',
  AGRINEWS_SCROLLED_NEXT = 'AGRINEWS_SCROLLED_NEXT',
  AGRINEWS_AUDIO_PAUSE = 'AGRINEWS_AUDIO_PAUSE',
  DEVOTIONAL_CATEGORY_CLICK = 'DEVOTION_CATEGORY_CLICK',
  DEVOTIONAL_SUBCATEGORY_CLICK = 'DEVOTIONAL_SUBCATEGORY_CLICK',
  LIVE_CHAT_CLICK = 'LIVE_CHAT_CLICK',
  EARN_MORE_COIN_CLICK = 'EARN_MORE_COIN_CLICK',
  DEVOTIONAL_PAGE_LOAD_FAILED = 'DEVOTIONAL_PAGE_LOAD_FAILED',
  DELIVEUSERS_LOAD_SUCCESS = 'DELIVEUSERS_LOAD_SUCCESS',
  DELIVECHAT_LOAD_SUCCESS = 'DELIVECHAT_LOAD_SUCCESS',
  CATEGORY_OR_SUBCATEGORY_ACTION_SUCCESS = 'CATEGORY_OR_SUBCATEGORY_ACTION_SUCCESS',
  CHAT_TYPE_START = 'CHAT_TYPE_START',
  CHAT_TYPE_ENDS = 'CHAT_TYPE_ENDS',
  CHAT_CLICK_SUCCESS = 'CHAT_CLICK_SUCCESS',
  DECOIN_LOAD_SUCCESS = 'DECOIN_LOAD_SUCCESS',
  DEPAGE_SCROLL = 'DEPAGE_SCROLL',
  LIVE_CHAT_SCROLL_TOP = 'LIVE_CHAT_SCROLL_TOP',
  LIVE_CHAT_SCROLL_END = 'LIVE_CHAT_SCROLL_END',
  DEVOTIONAL_MOD_TAB_EXPAND = 'DEVOTIONAL_MOD_TAB_EXPAND',
  DEVOTIONAL_MOD_TAB_MINIMIZE = 'DEVOTIONAL_MOD_TAB_MINIMIZE',
  DEVOTIONAL_PARTICIPANT_CHAT_JOIN_CLICK = 'DEVOTIONAL_PARTICIPANT_CHAT_JOIN_CLICK',
  NEWS_SCROLLED_NEXT = 'NEWS_SCROLLED_NEXT',
  AGRINEWS_AUDIO_TAB_PAUSE = 'AGRINEWS_AUDIO_TAB_PAUSE',
  DEVOTIONAL_AUDIO_PLAY_ERROR = 'DEVOTIONAL_AUDIO_PLAY_ERROR',
  DEVOTIONAL_AUDIO_PLAY_SUCCESS = 'DEVOTIONAL_AUDIO_PLAY_SUCCESS',
  DEVOTIONAL_ANIMATED_LOOP = 'DEVOTIONAL_ANIMATED_LOOP',
  DEVOTIONAL_ANIMATED_END = 'DEVOTIONAL_ANIMATED_END',
  DEVOTIONAL_ANIMATED_START = 'DEVOTIONAL_ANIMATED_START',
  DEVOTIONAL_ANIMATED_ERROR = 'DEVOTIONAL_ANIMATED_ERROR',
  DEVOTIONAL_CATEGORY_CHECKED = 'DEVOTIONAL_CATEGORY_CHECKED',
  DEVOTIONAL_CATEGORY_UNCHECKED = 'DEVOTIONAL_CATEGORY_UNCHECKED',
  CHAT_PARTICIPANT_BLOCKED = 'CHAT_PARTICIPANT_BLOCKED',
  MODERATOR_LEFT_CHAT = 'MODERATOR_LEFT_CHAT',
  LIVECHAT_USER_DISCONNECTED = 'LIVECHAT_USER_DISCONNECTED',
  ITEM_SHARED_SUCCESSFULLY = 'ITEM_SHARED_SUCCESSFULLY',
  ITEM_SHARED_FAILED = 'ITEM_SHARED_FAILED',
  PRODUCT_SHARE_SUCCESS = 'PRODUCT_SHARE_SUCCESS',
  PRODUCT_SHARE_FAILED = 'PRODUCT_SHARE_FAILED',
  MODERATOR_JOINED_LIVECHAT = 'MODERATOR_JOINED_LIVECHAT',
  PLAYSTORE_DOWNLOAD_CLICK = 'PLAYSTORE_DOWNLOAD_CLICK',
  PODCAST_PLAY="PODCAST_PLAY",
  PODCAST_PAUSE="PODCAST_PAUSE",
  PODCAST_COMPLETED="PODCAST_COMPLETED"
}

export const KISSAN_EVENT_SCHEMA_DETAIL: any = {
  SELECT_LANG: {
    customEventSchemaId: KissanEventType.SELECT_LANG,
    customEventSchemaVersion: 1,
    eventType: 'SelectLang',
    feature: KissanEventType.LANGUAGE,
    comment: KissanEventType.A_PAGE_OPENS_WHERE_THE_USER_IS_ASKED_TO_SELECTED_LANGUAGE,
  },
  LANG_INPUT: {
    customEventSchemaId: KissanEventType.LANG_INPUT,
    customEventSchemaVersion: 1,
    eventType: 'LangInput',
    feature: KissanEventType.LANGUAGE,
    comment: KissanEventType.USER_CLICKS_ON_THE_PREFERRED_LANGUAGE,
  },
  LANG_INPUT_SUCCESS: {
    customEventSchemaId: KissanEventType.LANG_INPUT_SUCCESS,
    customEventSchemaVersion: 1,
    eventType: 'LangInputSuccess',
    feature: KissanEventType.LANGUAGE,
    comment: KissanEventType.LANGUAGE_SELECTED_CORRECTLY,
  },
  USERLOGIN_PAGELOAD_SUCCESS: {
    customEventSchemaId: KissanEventType.USERLOGIN_PAGELOAD_SUCCESS,
    customEventSchemaVersion: 1,
    eventType: ' UserLoginPageLoadSuccess',
    feature: KissanEventType.SIGN_IN,
    comment: KissanEventType.SIGN_IN_PROCESS_STARTS,
  },
  USERONBOARDING_PROMOTION1: {
    customEventSchemaId: KissanEventType.USERONBOARDING_PROMOTION1,
    customEventSchemaVersion: 1,
    eventType: 'UserOnboardingPromotion1',
    feature: KissanEventType.SIGN_IN,
  },
  USERONBOARDING_PROMOTION1_BACKBUTTON: {
    customEventSchemaId: KissanEventType.USERONBOARDING_PROMOTION1_BACKBUTTON,
    customEventSchemaVersion: 1,
    eventType: 'UserOnboardingPromotion1BackButton',
    feature: KissanEventType.SIGN_IN,
  },
  USERONBOARDING_PROMOTION1_NEXT: {
    customEventSchemaId: KissanEventType.USERONBOARDING_PROMOTION1_NEXT,
    customEventSchemaVersion: 1,
    eventType: 'UserOnboardingPromotion1Next',
    feature: KissanEventType.SIGN_IN,
  },
  USERONBOARDING_PROMOTION1_SKIP: {
    customEventSchemaId: KissanEventType.USERONBOARDING_PROMOTION1_SKIP,
    customEventSchemaVersion: 1,
    eventType: 'UserOnboardingPromotion1Skip',
    feature: KissanEventType.SIGN_IN,
  },
  USERONBOARDING_PROMOTION2: {
    customEventSchemaId: KissanEventType.USERONBOARDING_PROMOTION2,
    customEventSchemaVersion: 1,
    eventType: 'UserOnboardingPromotion2',
    feature: KissanEventType.SIGN_IN,
  },
  USERONBOARDING_PROMOTION2_BACKBUTTON: {
    customEventSchemaId: KissanEventType.USERONBOARDING_PROMOTION2_BACKBUTTON,
    customEventSchemaVersion: 1,
    eventType: 'UserOnboardingPromotion2BackButton',
    feature: KissanEventType.SIGN_IN,
  },
  USERONBOARDING_PROMOTION2_NEXT: {
    customEventSchemaId: KissanEventType.USERONBOARDING_PROMOTION2_NEXT,
    customEventSchemaVersion: 1,
    eventType: 'UserOnboardingPromotion2Next',
    feature: KissanEventType.SIGN_IN,
  },
  USERONBOARDING_PROMOTION2_SKIP: {
    customEventSchemaId: KissanEventType.USERONBOARDING_PROMOTION2_SKIP,
    customEventSchemaVersion: 1,
    eventType: 'UserOnboardingPromotion2Skip',
    feature: KissanEventType.SIGN_IN,
  },
  USERONBOARDING_PROMOTION3: {
    customEventSchemaId: KissanEventType.USERONBOARDING_PROMOTION3,
    customEventSchemaVersion: 1,
    eventType: 'UserOnboardingPromotion3',
    feature: KissanEventType.SIGN_IN,
  },
  USERONBOARDING_PROMOTION3_BACKBUTTON: {
    customEventSchemaId: KissanEventType.USERONBOARDING_PROMOTION3_BACKBUTTON,
    customEventSchemaVersion: 1,
    eventType: 'UserOnboardingPromotion3BackButton',
    feature: KissanEventType.SIGN_IN,
  },
  USERONBOARDING_PROMOTION3_NEXT: {
    customEventSchemaId: KissanEventType.USERONBOARDING_PROMOTION3_NEXT,
    customEventSchemaVersion: 1,
    eventType: 'UserOnboardingPromotion3Next',
    feature: KissanEventType.SIGN_IN,
  },
  USERONBOARDING_PROMOTION3_SKIP: {
    customEventSchemaId: KissanEventType.USERONBOARDING_PROMOTION3_SKIP,
    customEventSchemaVersion: 1,
    eventType: 'UserOnboardingPromotion3Skip',
    feature: KissanEventType.SIGN_IN,
  },
  USER_ENTER_NUMBER: {
    customEventSchemaId: KissanEventType.USER_ENTER_NUMBER,
    customEventSchemaVersion: 1,
    eventType: 'UserEnterNumber',
    feature: KissanEventType.SIGN_IN,
    comment: KissanEventType.SIGN_IN_PROCESS_STARTS,
  },

  USERLOGIN_NUMBER_CLICK: {
    customEventSchemaId: KissanEventType.USERLOGIN_NUMBER_CLICK,
    customEventSchemaVersion: 1,
    eventType: 'UserLoginNumberClick',
    feature: KissanEventType.SIGN_IN,
    comment: KissanEventType.USER_CLICKS_ON_THE_PHONE_NUMBER_BOX,
  },

  USERLOGIN_SKIP: {
    customEventSchemaId: KissanEventType.USERLOGIN_SKIP,
    customEventSchemaVersion: 1,
    eventType: 'UserLoginSkip',
    feature: KissanEventType.SIGN_IN,
  },

  SIGN_IN_PROCEED_PRESSED: {
    customEventSchemaId: KissanEventType.SIGN_IN_PROCEED_PRESSED,
    customEventSchemaVersion: 1,
    eventType: 'SignInProceedPressed',
    feature: KissanEventType.SIGN_IN,
    comment: KissanEventType.USER_MOVES_TO_OTP_PAGE,
  },
  SIGN_IN_API_FAILED: {
    customEventSchemaId: KissanEventType.SIGN_IN_API_FAILED,
    customEventSchemaVersion: 1,
    eventType: 'SignInProceedPressed',
    feature: KissanEventType.SIGN_IN,
    comment: KissanEventType.SIGN_IN_API_FAILED,
  },

  RESEND_OTP_API_FAILED: {
    customEventSchemaId: KissanEventType.RESEND_OTP_API_FAILED,
    customEventSchemaVersion: 1,
    eventType: 'ResendOtpApiFailed',
    feature: KissanEventType.SIGN_IN,
    comment: KissanEventType.RESEND_OTP_API_FAILED,
  },

  LOGIN_PRIVACY_POLICY_CLICKED: {
    customEventSchemaId: KissanEventType.LOGIN_PRIVACY_POLICY_CLICKED,
    customEventSchemaVersion: 1,
    eventType: 'LoginPrivacyPolicyClicked',
    feature: KissanEventType.SIGN_IN,
    comment: KissanEventType.TO_VIEW_THE_PRIVACY_POLICY,
  },

  OTP_REQUESTED: {
    customEventSchemaId: KissanEventType.OTP_REQUESTED,
    customEventSchemaVersion: 1,
    eventType: 'OTPRequested',
    feature: KissanEventType.SIGN_IN,
    comment: KissanEventType.OTP_REQUEST_WILL_BE_SENT_FROM_THE_USERS_SIDE,
  },
  ASYNC_AUTH_API_FAILED: {
    customEventSchemaId: KissanEventType.ASYNC_AUTH_API_FAILED,
    customEventSchemaVersion: 1,
    eventType: 'AsyncAuthApiFailed',
    feature: KissanEventType.SIGN_IN,
    comment: KissanEventType.ASYNC_AUTH_API_FAILED,
  },
  ASYNC_USER_PROFILE_DETAIL_API_FAILED: {
    customEventSchemaId: KissanEventType.ASYNC_USER_PROFILE_DETAIL_API_FAILED,
    customEventSchemaVersion: 1,
    eventType: 'AsyncUserProfileDetailApiFailed',
    feature: KissanEventType.SIGN_IN,
    comment: KissanEventType.ASYNC_USER_PROFILE_DETAIL_API_FAILED,
  },
  EXCHANGE_TOKEN_API_FAILED: {
    customEventSchemaId: KissanEventType.EXCHANGE_TOKEN_API_FAILED,
    customEventSchemaVersion: 1,
    eventType: 'ExchangeTokenApiFailed',
    feature: KissanEventType.SIGN_IN,
    comment: KissanEventType.EXCHANGE_TOKEN_API_FAILED,
  },
  USER_PROFILE_API_FAILED: {
    customEventSchemaId: KissanEventType.USER_PROFILE_API_FAILED,
    customEventSchemaVersion: 1,
    eventType: 'UserProfileApiFailed',
    comment: KissanEventType.USER_PROFILE_API_FAILED,
  },
  EDIT_PROFILE_API_FAILED: {
    customEventSchemaId: KissanEventType.EDIT_PROFILE_API_FAILED,
    customEventSchemaVersion: 1,
    eventType: 'EditProfileApiFailed',
    comment: KissanEventType.EDIT_PROFILE_API_FAILED,
  },
  THREADS_API_FAILED: {
    customEventSchemaId: KissanEventType.THREADS_API_FAILED,
    customEventSchemaVersion: 1,
    eventType: 'ThreadsApiFailed',
    comment: KissanEventType.THREADS_API_FAILED,
  },
  DISLIKE_API_FAILED: {
    customEventSchemaId: KissanEventType.DISLIKE_API_FAILED,
    customEventSchemaVersion: 1,
    eventType: 'DislikeApiFailed',
    comment: KissanEventType.DISLIKE_API_FAILED,
  },

  OTP_VERIFY_CALLBACK_SUCCESS: {
    customEventSchemaId: KissanEventType.OTP_VERIFY_CALLBACK_SUCCESS,
    customEventSchemaVersion: 1,
    eventType: 'OTPVerifyCallbackSuccess',
    feature: KissanEventType.SIGN_IN,
    comment: KissanEventType.RECEIVED_SUCCESSFULLY,
  },

  SIX_DIGIT_OTP_ENTERED: {
    customEventSchemaId: KissanEventType.SIX_DIGIT_OTP_ENTERED,
    customEventSchemaVersion: 1,
    eventType: 'CorrectOTP',
    feature: KissanEventType.SIGN_IN,
    comment: KissanEventType.USER_ENTERS_SIX_DIGIT_OTP_ENTERED,
  },

  NORMAL_LOGIN_SUCCESS: {
    customEventSchemaId: KissanEventType.NORMAL_LOGIN_SUCCESS,
    customEventSchemaVersion: 1,
    eventType: 'NormalLoginSuccess',
    feature: KissanEventType.SIGN_IN,
    comment: KissanEventType.LOGIN_SUCCESS,
  },

  NORMAL_LOGIN_FAILURE: {
    customEventSchemaId: KissanEventType.NORMAL_LOGIN_FAILURE,
    customEventSchemaVersion: 1,
    eventType: 'NormalLoginFailure',
    feature: KissanEventType.SIGN_IN,
    comment: KissanEventType.WHEN_LOGIN_FAILS_DUE_TO_OTP_ERRORS,
  },

  OTP_RESEND_OTP_CLICKED: {
    customEventSchemaId: KissanEventType.OTP_RESEND_OTP_CLICKED,
    customEventSchemaVersion: 1,
    eventType: 'OTPResendOTPClicked',
    feature: KissanEventType.SIGN_IN,
    comment: KissanEventType.USER_CLICKS_ON_RESEND_OTP,
  },

  OTP_AUTO_DETECTED: {
    customEventSchemaId: KissanEventType.OTP_AUTO_DETECTED,
    customEventSchemaVersion: 1,
    eventType: 'OTPAutoDetected',
    feature: KissanEventType.SIGN_IN,
    comment: KissanEventType.OTP_IS_AUTODETECTED_FROM_MESSAGES_AND_FILLED_UP,
  },
  HOMEPAGE_LOAD_SUCCESS: {
    customEventSchemaId: KissanEventType.HOMEPAGE_LOAD_SUCCESS,
    customEventSchemaVersion: 1,
    eventType: 'HomepageLoadSuccess',
    feature: KissanEventType.SIGN_IN,
    comment: KissanEventType.USER_IS_LANDED_IN_HOMEPAGE_AFTER_THE_SIGNUP,
  },
  REELS_SCROLL_1: {
    customEventSchemaId: KissanEventType.REELS_SCROLL_1,
    customEventSchemaVersion: 1,
    eventType: 'ReelsScroll1',
    feature: KissanEventType.FEED_REELS,
    comment:
      KissanEventType.IN_FEED_PAGE_REELS_ARE_PRESENT_IN_HORIZONTAL_ORDER_WHICH_NEEDS_TO_BE_SCROLLED,
  },
  REELS_SCROLL_PAGEVERTICAL: {
    customEventSchemaId: KissanEventType.REELS_SCROLL_PAGEVERTICAL,
    customEventSchemaVersion: 1,
    eventType: 'ReelsScrollPagevertical',
    feature: KissanEventType.FEED_REELS,
    comment: KissanEventType.THE_NUMBER_OF_PAGES_REELS_SCROLLED_BY_THE_USER_IS_SHOWN_HORIZONTALLY,
    comment1: KissanEventType.THE_NUMBER_OF_PAGES_REELS_SCROLLED_BY_THE_USER_IS_SHOWN_VERTICALLS,
  },
  REELS_SCROLL_VERTICAL_PAGE_END: {
    customEventSchemaId: KissanEventType.REELS_SCROLL_VERTICAL_PAGE_END,
    customEventSchemaVersion: 1,
    eventType: 'ReelsScrollVertical',
    feature: KissanEventType.FEED_REELS,
    comment:
      KissanEventType.IN_FEED_PAGE_REELS_ARE_PRESENT_IN_HORIZONTAL_ORDER_WHICH_NEEDS_TO_BE_SCROLLED,
  },
  REELS_SCROLL_VERTICAL_PAGE_STARTED: {
    customEventSchemaId: KissanEventType.REELS_SCROLL_VERTICAL_PAGE_STARTED,
    customEventSchemaVersion: 1,
    eventType: 'ReelsScrollVertical',
    feature: KissanEventType.FEED_REELS,
    comment:
      KissanEventType.IN_FEED_PAGE_REELS_ARE_PRESENT_IN_HORIZONTAL_ORDER_WHICH_NEEDS_TO_BE_SCROLLED,
  },

  REELS_PLAY: {
    customEventSchemaId: KissanEventType.REELS_PLAY,
    customEventSchemaVersion: 1,
    eventType: 'ReelsPlay',
    feature: KissanEventType.FEED_REELS,
    comment: KissanEventType.WHEN_REELS_ARE_PLAYED,
  },

  REELS_PAUSED: {
    customEventSchemaId: KissanEventType.REELS_PAUSED,
    customEventSchemaVersion: 1,
    eventType: 'ReelsPaused',
    feature: KissanEventType.FEED_REELS,
    comment: KissanEventType.WHEN_REELS_ARE_PAUSED,
  },

  REELS_ERROR: {
    customEventSchemaId: KissanEventType.REELS_ERROR,
    customEventSchemaVersion: 1,
    eventType: 'ReelsError',
    feature: KissanEventType.FEED_REELS,
    comment: KissanEventType.WHEN_REELS_DONOT_PLAY_DUE_TO_SOME_REASON,
  },
  VERTICAL_SCROLL_VIDEO: {
    customEventSchemaId: KissanEventType.VERTICAL_SCROLL_VIDEO,
    customEventSchemaVersion: 1,
    eventType: 'VerticalVideoScroll',
    feature: KissanEventType.FEED_VIDEO,
    comment: KissanEventType.WHEN_VERTICAL_SCROLL_FOR_THE_VIDEO_IS_DONE,
  },

  BOTTOM_NAV_FEED_CLICKED: {
    customEventSchemaId: KissanEventType.BOTTOM_NAV_FEED_CLICKED,
    customEventSchemaVersion: 1,
    eventType: 'BottomNavFeedClicked',
    feature: KissanEventType.SCREEN_NAVIGATE,
    comment:
      KissanEventType.USER_CAN_SCROLL_THROUGH_THE_DIFFERENT_SECTIONS_PAGES_FEED_DISCOVERY_HOME_ETC_THROUGH_THE_BOTTOM_NAV,
  },
  VIDEO_ON_READY_TIME: {
    customEventSchemaId: KissanEventType.VIDEO_ON_READY_TIME,
    customEventSchemaVersion: 1,
    eventType: 'VideoOnReadyTime',
    feature: KissanEventType.FEED_VIDEO,
    comment: KissanEventType.VIDEO_READY_TO_PLAY,
  },
  VIDEO_PLAY: {
    customEventSchemaId: KissanEventType.VIDEO_PLAY,
    customEventSchemaVersion: 1,
    eventType: 'VideoPlay',
    feature: KissanEventType.FEED_VIDEO,
    comment: KissanEventType.VIDEO_IS_PLAYED,
  },
  VIDEO_PAUSED: {
    customEventSchemaId: KissanEventType.VIDEO_PAUSED,
    customEventSchemaVersion: 1,
    eventType: 'VideoPaused',
    feature: KissanEventType.FEED_VIDEO,
    comment: KissanEventType.VIDEO_IS_PAUSED,
  },
  VIDEO_BACK_PRESSED: {
    customEventSchemaId: KissanEventType.VIDEO_BACK_PRESSED,
    customEventSchemaVersion: 1,
    eventType: 'VideoBackPressed',
    feature: KissanEventType.FEED_VIDEO,
    comment: KissanEventType.VIDEO_BACK_PRESSED,
  },
  RELATED_VIDEO_CLICK: {
    customEventSchemaId: KissanEventType.RELATED_VIDEO_CLICK,
    customEventSchemaVersion: 1,
    eventType: 'RelatedVideoClicked',
    feature: KissanEventType.FEED_VIDEO,
    comment: KissanEventType.RELATED_VIDEO_OR_RECOMMENDATIONS_OF_THE_VIDEO_IS_CLICKED_BY_THE_USER,
  },
  VIDEO_ERROR: {
    customEventSchemaId: KissanEventType.VIDEO_ERROR,
    customEventSchemaVersion: 1,
    eventType: 'VideoError',
    feature: KissanEventType.FEED_VIDEO,
    comment: KissanEventType.VIDEO_FAILS_TO_PLAY,
  },
  VIDEO_PLAY_FINISH: {
    customEventSchemaId: KissanEventType.VIDEO_PLAY_FINISH,
    customEventSchemaVersion: 1,
    eventType: 'VideoPlayFinish',
    feature: KissanEventType.FEED_VIDEO,
    comment: KissanEventType.ONCE_THE_WHOLE_VIDEO_IS_PLAYED_AND_CLOSED,
  },
  ITEM_CLICKED: {
    customEventSchemaId: KissanEventType.ITEM_CLICKED,
    customEventSchemaVersion: 1,
    eventType: 'ItemClicked',
    feature: KissanEventType.FEED_ITEM,
    comment: KissanEventType.WHEN_USER_CLICKS_ON_THE_ITEM_ON_FEED_PAGE,
  },
  ITEM_LIKED: {
    customEventSchemaId: KissanEventType.ITEM_LIKED,
    customEventSchemaVersion: 1,
    eventType: 'ItemLiked',
    feature: KissanEventType.FEED_ITEM,
    comment: KissanEventType.WHEN_USER_CLICKS_ON_THE_ICON_LIKE_ON_FEED_PAGE,
  },

  ITEM_DISLIKED: {
    customEventSchemaId: KissanEventType.ITEM_DISLIKED,
    customEventSchemaVersion: 1,
    eventType: 'ItemDisliked',
    feature: KissanEventType.FEED_ITEM,
    comment: KissanEventType.WHEN_USER_CLICKS_ON_THE_ICON_DISLIKE_ON_FEED_PAGE,
  },

  ITEM_COMMENT: {
    customEventSchemaId: KissanEventType.ITEM_COMMENT,
    customEventSchemaVersion: 1,
    eventType: 'ItemComment',
    feature: KissanEventType.FEED_ITEM,
    comment: KissanEventType.WHEN_USER_CLICKS_ON_THE_ICON_COMMENT_ON_FEED_PAGE,
  },
  ITEM_SHARED: {
    customEventSchemaId: KissanEventType.ITEM_SHARED,
    customEventSchemaVersion: 1,
    eventType: 'ItemShared',
    feature: KissanEventType.FEED_ITEM,
    comment: KissanEventType.WHEN_USER_CLICKS_ON_THE_ICON_SHARE_ON_FEED_PAGE,
  },
  ITEM_REPORTED: {
    customEventSchemaId: KissanEventType.ITEM_REPORTED,
    customEventSchemaVersion: 1,
    eventType: 'ItemReported',
    feature: KissanEventType.FEED_ITEM,
    comment: KissanEventType.WHEN_USER_CLICKS_ON_THE_ICON_REPORT_ON_FEED_PAGE,
  },
  ITEM_PROFILE_CLICKED: {
    customEventSchemaId: KissanEventType.ITEM_PROFILE_CLICKED,
    customEventSchemaVersion: 1,
    eventType: 'ItemProfileClicked',
    feature: KissanEventType.FEED_ITEM,
    comment: KissanEventType.WHEN_USER_CLICKS_ON_THE_PROFILE_ICON_IN_HIS_PROFILE,
  },
  USER_PROFILE_CLICKED: {
    customEventSchemaId: KissanEventType.USER_PROFILE_CLICKED,
    customEventSchemaVersion: 1,
    eventType: 'UserProfileClicked',
    feature: KissanEventType.PROFILE,
    comment: KissanEventType.WHEN_THE_NAME_OF_THE_USER_ON_THE_POST_IS_CLICKED_TO_VIEW_HIS_PROFILE,
  },
  NOTIFICATIONS_CLICKED: {
    customEventSchemaId: KissanEventType.NOTIFICATIONS_CLICKED,
    customEventSchemaVersion: 1,
    eventType: 'NotificationsClicked',
    feature: KissanEventType.PROFILE,
    comment: KissanEventType.USER_CLICKS_ON_THE_NOTIFICATION_ICON,
  },
  PAGE_SCROLL_READ: {
    customEventSchemaId: KissanEventType.PAGE_SCROLL_READ,
    customEventSchemaVersion: 1,
    eventType: 'PageScrollRead',
    feature: KissanEventType.ALL_PAGES,
  },

  BACK_PRESS: {
    customEventSchemaId: KissanEventType.BACK_PRESS,
    customEventSchemaVersion: 1,
    eventType: 'BackPress',
    feature: KissanEventType.ALL_PAGES,
    comment: KissanEventType.WHEN_A_USER_CLICKS_ON_BACK_PRESS_WHAT_PAGE_DOES_EACH_OF_IT_LAND_AT,
  },
  APP_UNINSTALLED: {
    customEventSchemaId: KissanEventType.APP_UNINSTALLED,
    customEventSchemaVersion: 1,
    eventType: 'AppUninstalled',
    feature: KissanEventType.PUSH_NOTIFICATION_FAILURE_BACKEND,
    comment: KissanEventType.WHEN_PUSH_NOTIFICATION_DELIVERY_FAILS_WITH_APP_UNINSTALLED_STATUS,
  },
  CLICK_POST: {
    customEventSchemaId: KissanEventType.CLICK_POST,
    customEventSchemaVersion: 1,
    eventType: 'ClickPost',
    comment: KissanEventType.CLICK_ON_POST_BUTTON_ON_TOP_RIGHT,
  },
  POST_PAGEOPEN_SUCCESS: {
    customEventSchemaId: KissanEventType.POST_PAGEOPEN_SUCCESS,
    customEventSchemaVersion: 1,
    eventType: 'PostPageOpenSuccess',
    comment: KissanEventType.NEXT_PAGE_OPENS_FOR_ADDING_CONTENT,
  },
  SELECT_UPLOAD_PIC: {
    customEventSchemaId: KissanEventType.SELECT_UPLOAD_PIC,
    customEventSchemaVersion: 1,
    eventType: 'SelectUploadPic',
    comment: KissanEventType.SELECT_UPLOAD_PIC,
  },
  SELECT_UPLOAD_VIDEO: {
    customEventSchemaId: KissanEventType.SELECT_UPLOAD_VIDEO,
    customEventSchemaVersion: 1,
    eventType: 'SelectUploadVideo',
    comment: KissanEventType.SELECT_UPLOAD_VIDEO,
  },
  PHOTO_UPLOAD_SUCCESS: {
    customEventSchemaId: KissanEventType.PHOTO_UPLOAD_SUCCESS,
    customEventSchemaVersion: 1,
    eventType: 'SelectUploadSuccess',
    comment: KissanEventType.PHOTO_UPLOAD_SUCCESS,
  },
  VIDEO_UPLOAD_SUCCESS: {
    customEventSchemaId: KissanEventType.VIDEO_UPLOAD_SUCCESS,
    customEventSchemaVersion: 1,
    eventType: 'VideoUploadSuccess',
    comment: KissanEventType.VIDEO_UPLOAD_SUCCESS,
  },
  SELECT_POST: {
    customEventSchemaId: KissanEventType.SELECT_POST,
    customEventSchemaVersion: 1,
    eventType: 'SelectPost',
    comment: KissanEventType.SELECT_POST,
  },
  SELECT_CREATEPOST: {
    customEventSchemaId: KissanEventType.SELECT_CREATEPOST,
    customEventSchemaVersion: 1,
    eventType: 'SelectCreatePost',
    comment: KissanEventType.SELECT_CREATEPOST,
  },

  NOTIFICATION_PERMISSION_GIVEN_BY_USER: {
    customEventSchemaId: KissanEventType.NOTIFICATION_PERMISSION_GIVEN_BY_USER,
    customEventSchemaVersion: 1,
    eventType: 'NotificationPermissionGivenByUser',
    comment: KissanEventType.NOTIFICATION_PERMISSION_GIVEN_BY_USER,
  },

  NOTIFICATION_PERMISSION_DENIED_BY_USER: {
    customEventSchemaId: KissanEventType.NOTIFICATION_PERMISSION_DENIED_BY_USER,
    customEventSchemaVersion: 1,
    eventType: 'NotificationPermissionDeniedByUser',
    comment: KissanEventType.NOTIFICATION_PERMISSION_DENIED_BY_USER,
  },

  NOTIFICATION_TRIGGER_POPUP: {
    customEventSchemaId: KissanEventType.NOTIFICATION_TRIGGER_POPUP,
    customEventSchemaVersion: 1,
    eventType: 'NotificationPopupShown',
    comment: KissanEventType.NOTIFICATION_TRIGGER_POPUP,
  },

  NOTIFICATION_TRIGGER_ALLOW: {
    customEventSchemaId: KissanEventType.NOTIFICATION_TRIGGER_ALLOW,
    customEventSchemaVersion: 1,
    eventType: 'NotificationPopupShown',
    comment: KissanEventType.NOTIFICATION_TRIGGER_ALLOW,
  },

  NOTIFICATION_TRIGGER_DISALLOW: {
    customEventSchemaId: KissanEventType.NOTIFICATION_TRIGGER_DISALLOW,
    customEventSchemaVersion: 1,
    eventType: 'NotificationPopupShown',
    comment: KissanEventType.NOTIFICATION_TRIGGER_DISALLOW,
  },

  LOCATION_PERMISSION_GIVEN_BY_USER: {
    customEventSchemaId: KissanEventType.LOCATION_PERMISSION_GIVEN_BY_USER,
    customEventSchemaVersion: 1,
    eventType: 'LocationPermissionGivenByUser',
    comment: KissanEventType.LOCATION_PERMISSION_GIVEN_BY_USER,
  },
  LOCATION_PERMISSION_DENIED_BY_USER: {
    customEventSchemaId: KissanEventType.LOCATION_PERMISSION_DENIED_BY_USER,
    customEventSchemaVersion: 1,
    eventType: 'LocationPermissionDeniedByUser',
    comment: KissanEventType.LOCATION_PERMISSION_DENIED_BY_USER,
  },

  MEDIA_PERMISSION_GIVEN_BY_USER: {
    customEventSchemaId: KissanEventType.MEDIA_PERMISSION_GIVEN_BY_USER,
    customEventSchemaVersion: 1,
    eventType: 'MediaPermissionGivenByUser',
    comment: KissanEventType.MEDIA_PERMISSION_GIVEN_BY_USER,
  },
  MEDIA_PERMISSION_DENIED_BY_USER: {
    customEventSchemaId: KissanEventType.MEDIA_PERMISSION_DENIED_BY_USER,
    customEventSchemaVersion: 1,
    eventType: 'MediaPermissionDeniedByUser',
    comment: KissanEventType.MEDIA_PERMISSION_DENIED_BY_USER,
  },
  KISAN_PUSH_VIEW: {
    customEventSchemaId: KissanEventType.KISAN_PUSH_VIEW,
    customEventSchemaVersion: 1,
    eventType: 'KisanPushView',
    comment: KissanEventType.KISAN_PUSH_VIEW,
  },
  NOTIFICATION_SENT: {
    customEventSchemaId: KissanEventType.NOTIFICATION_SENT,
    customEventSchemaVersion: 1,
    eventType: 'NotificationSent',
    comment: KissanEventType.NOTIFICATION_SENT,
  },
  NOTIFICATION_CLICKED: {
    customEventSchemaId: KissanEventType.NOTIFICATION_CLICKED,
    customEventSchemaVersion: 1,
    eventType: 'NotificationClicked',
    comment: KissanEventType.NOTIFICATION_CLICKED,
  },
  NOTIFICATION_DISMISSED: {
    customEventSchemaId: KissanEventType.NOTIFICATION_DISMISSED,
    customEventSchemaVersion: 1,
    eventType: 'NotificationDismissed',
    comment: KissanEventType.NOTIFICATION_DISMISSED,
  },
  FOREGROUND_NOTIFICATION_DISMISSED: {
    customEventSchemaId: KissanEventType.FOREGROUND_NOTIFICATION_DISMISSED,
    customEventSchemaVersion: 1,
    eventType: 'ForegroundNotificationDismissed',
    comment: KissanEventType.FOREGROUND_NOTIFICATION_DISMISSED,
  },
  FOREGROUND_NOTIFICATION_PRESSED: {
    customEventSchemaId: KissanEventType.FOREGROUND_NOTIFICATION_PRESSED,
    customEventSchemaVersion: 1,
    eventType: 'ForegroundNotificationPressed',
    comment: KissanEventType.FOREGROUND_NOTIFICATION_PRESSED,
  },

  DIS_BOTTOMNAV_CLICKED: {
    customEventSchemaId: KissanEventType.DIS_BOTTOMNAV_CLICKED,
    customEventSchemaVersion: 1,
    eventType: 'DisBottomnavClicked',
    comment: KissanEventType.DIS_BOTTOMNAV_CLICKED,
  },
  DIS_PAGEOPEN_SUCCESS: {
    customEventSchemaId: KissanEventType.DIS_PAGEOPEN_SUCCESS,
    customEventSchemaVersion: 1,
    eventType: 'DisPageopenSuccess',
    comment: KissanEventType.DIS_PAGEOPEN_SUCCESS,
  },
  DIS_PAGEOPEN_FAIL: {
    customEventSchemaId: KissanEventType.DIS_PAGEOPEN_FAIL,
    customEventSchemaVersion: 1,
    eventType: 'DisPageopenFail',
    comment: KissanEventType.DIS_PAGEOPEN_FAIL,
  },
  DIS_PAGESCROLL_VERTICAL: {
    customEventSchemaId: KissanEventType.DIS_PAGESCROLL_VERTICAL,
    customEventSchemaVersion: 1,
    eventType: 'DisPagescrollVertical',
    comment: KissanEventType.DIS_PAGESCROLL_VERTICAL,
  },
  DIS_PAGESCROLL_HORIZONTAL_CONTINUEWATCH: {
    customEventSchemaId: KissanEventType.DIS_PAGESCROLL_HORIZONTAL_CONTINUEWATCH,
    customEventSchemaVersion: 1,
    eventType: 'DisPagescrollHorizontalContinuewatch',
    comment: KissanEventType.DIS_PAGESCROLL_HORIZONTAL_CONTINUEWATCH,
  },
  DIS_CONTINUWATCH_CLICKED: {
    customEventSchemaId: KissanEventType.DIS_CONTINUWATCH_CLICKED,
    customEventSchemaVersion: 1,
    eventType: 'DisContinuwatchClicked',
    comment: KissanEventType.DIS_CONTINUWATCH_CLICKED,
  },
  DIS_CONTINUEWATCH_VIDEOPLAY_SUCCESS: {
    customEventSchemaId: KissanEventType.DIS_CONTINUEWATCH_VIDEOPLAY_SUCCESS,
    customEventSchemaVersion: 1,
    eventType: 'DisContinuewatchVideoplaySuccess',
    comment: KissanEventType.DIS_CONTINUEWATCH_VIDEOPLAY_SUCCESS,
  },
  DIS_CONTINUEWATCH_VIDEOPLAY_FAIL: {
    customEventSchemaId: KissanEventType.DIS_CONTINUEWATCH_VIDEOPLAY_FAIL,
    customEventSchemaVersion: 1,
    eventType: 'DisContinuewatchVideoplayFail',
    comment: KissanEventType.DIS_CONTINUEWATCH_VIDEOPLAY_FAIL,
  },
  DIS_PAGESCROLL_HORIZONTAL_VIDEOSONCROPS: {
    customEventSchemaId: KissanEventType.DIS_PAGESCROLL_HORIZONTAL_VIDEOSONCROPS,
    customEventSchemaVersion: 1,
    eventType: 'DisPagescrollHorizontalVideosonCrops',
    comment: KissanEventType.DIS_PAGESCROLL_HORIZONTAL_VIDEOSONCROPS,
  },
  DIS_PAGESCROLL_HORIZONTAL_TRENDING: {
    customEventSchemaId: KissanEventType.DIS_PAGESCROLL_HORIZONTAL_TRENDING,
    customEventSchemaVersion: 1,
    eventType: 'DisPagescrollHorizontalTrending',
    comment: KissanEventType.DIS_PAGESCROLL_HORIZONTAL_TRENDING,
  },
  DIS_PAGESCROLL_HORIZONTAL_POPULAR: {
    customEventSchemaId: KissanEventType.DIS_PAGESCROLL_HORIZONTAL_POPULAR,
    customEventSchemaVersion: 1,
    eventType: 'DisPagescrollHorizontalPopular',
    comment: KissanEventType.DIS_PAGESCROLL_HORIZONTAL_POPULAR,
  },
  DIS_PAGESCROLL_HORIZONTAL_EXPERTS: {
    customEventSchemaId: KissanEventType.DIS_PAGESCROLL_HORIZONTAL_EXPERTS,
    customEventSchemaVersion: 1,
    eventType: 'DisPagescrollHorizontalExperts',
    comment: KissanEventType.DIS_PAGESCROLL_HORIZONTAL_EXPERTS,
  },
  DIS_VIEW_CLICK: {
    customEventSchemaId: KissanEventType.DIS_VIEW_CLICK,
    customEventSchemaVersion: 1,
    eventType: 'DisViewClick',
    comment: KissanEventType.DIS_VIEW_CLICK,
  },
  DIS_VIEWALLCLICK_SUCCESS: {
    customEventSchemaId: KissanEventType.DIS_VIEWALLCLICK_SUCCESS,
    customEventSchemaVersion: 1,
    eventType: 'DisViewallclickSucess',
    comment: KissanEventType.DIS_VIEWALLCLICK_SUCCESS,
  },
  DIS_PAGESCROLL_HORIZONTAL_TOPVIDEO: {
    customEventSchemaId: KissanEventType.DIS_PAGESCROLL_HORIZONTAL_TOPVIDEO,
    customEventSchemaVersion: 1,
    eventType: 'DisPagescrollHorizontalTopvideo',
    comment: KissanEventType.DIS_PAGESCROLL_HORIZONTAL_TOPVIDEO,
  },
  DIS_SEARCH_CLICK: {
    customEventSchemaId: KissanEventType.DIS_SEARCH_CLICK,
    customEventSchemaVersion: 1,
    eventType: 'DisSearchClick',
    comment: KissanEventType.DIS_SEARCH_CLICK,
  },
  DIS_SEARCH_CLICKSUCCESS: {
    customEventSchemaId: KissanEventType.DIS_SEARCH_CLICKSUCCESS,
    customEventSchemaVersion: 1,
    eventType: 'DisSearchClicksuccess',
    comment: KissanEventType.DIS_SEARCH_CLICKSUCCESS,
  },
  DIS_CLICKON_VIDEOCATEGORY: {
    customEventSchemaId: KissanEventType.DIS_CLICKON_VIDEOCATEGORY,
    customEventSchemaVersion: 1,
    eventType: 'DisClickonVideocategory',
    comment: KissanEventType.DIS_CLICKON_VIDEOCATEGORY,
  },
  DIS_NOTIFICATION_CLICK: {
    customEventSchemaId: KissanEventType.DIS_NOTIFICATION_CLICK,
    customEventSchemaVersion: 1,
    eventType: 'DisNotificationClick',
    comment: KissanEventType.DIS_NOTIFICATION_CLICK,
  },

  DIS_PAGESCROLL_HORIZONTAL_MACHINERY: {
    customEventSchemaId: KissanEventType.DIS_PAGESCROLL_HORIZONTAL_MACHINERY,
    customEventSchemaVersion: 1,
    eventType: 'DisPagescrollHorizontalMachinery',
    comment: KissanEventType.DIS_PAGESCROLL_HORIZONTAL_MACHINERY,
  },

  DIS_PAGESCROLL_HORIZONTAL_ANIMALS: {
    customEventSchemaId: KissanEventType.DIS_PAGESCROLL_HORIZONTAL_ANIMALS,
    customEventSchemaVersion: 1,
    eventType: 'DisPagescrollHorizontalAnimals',
    comment: KissanEventType.DIS_PAGESCROLL_HORIZONTAL_ANIMALS,
  },

  DIS_PAGESCROLL_HORIZONTAL_GOVT_SCHEME: {
    customEventSchemaId: KissanEventType.DIS_PAGESCROLL_HORIZONTAL_GOVT_SCHEME,
    customEventSchemaVersion: 1,
    eventType: 'DisPagescrollHorizontalGovtScheme',
    comment: KissanEventType.DIS_PAGESCROLL_HORIZONTAL_GOVT_SCHEME,
  },
  DIS_VIDEO_CLICKED: {
    customEventSchemaId: KissanEventType.DIS_VIDEO_CLICKED,
    customEventSchemaVersion: 1,
    eventType: 'DisVideoClicked',
    comment: KissanEventType.DIS_VIDEO_CLICKED,
  },
  DIS_VIDEOPLAY_SUCCESS: {
    customEventSchemaId: KissanEventType.DIS_VIDEOPLAY_SUCCESS,
    customEventSchemaVersion: 1,
    eventType: 'DidVideoplaySuccess',
    comment: KissanEventType.DIS_VIDEOPLAY_SUCCESS,
  },
  BOTTOM_NAV_CLICKED_QNA: {
    customEventSchemaId: KissanEventType.BOTTOM_NAV_CLICKED_QNA,
    customEventSchemaVersion: 1,
    eventType: 'BottomNavClickedQna',
    comment: KissanEventType.BOTTOM_NAV_CLICKED_QNA,
  },

  QNA_PAGEOPEN_SUCCESS: {
    customEventSchemaId: KissanEventType.QNA_PAGEOPEN_SUCCESS,
    customEventSchemaVersion: 1,
    eventType: 'QnaPageOpenSuccess',
    comment: KissanEventType.QNA_PAGEOPEN_SUCCESS,
  },

  QNA_PAGEOPEN_FAIL: {
    customEventSchemaId: KissanEventType.QNA_PAGEOPEN_FAIL,
    customEventSchemaVersion: 1,
    eventType: 'QnaPageOpenFail',
    comment: KissanEventType.QNA_PAGEOPEN_FAIL,
  },

  QNA_PAGESCROLL_VERTICAL_START: {
    customEventSchemaId: KissanEventType.QNA_PAGESCROLL_VERTICAL_START,
    customEventSchemaVersion: 1,
    eventType: 'QnaPageScrollVerticalStart',
    comment: KissanEventType.QNA_PAGESCROLL_VERTICAL_START,
  },

  QNA_PAGESCROLL_VERTICAL_FAIL: {
    customEventSchemaId: KissanEventType.QNA_PAGESCROLL_VERTICAL_FAIL,
    customEventSchemaVersion: 1,
    eventType: 'QnaPageScrollVerticalFail',
    comment: KissanEventType.QNA_PAGESCROLL_VERTICAL_FAIL,
  },

  QNA_FILTERCLICK_SUCCESS: {
    customEventSchemaId: KissanEventType.QNA_FILTERCLICK_SUCCESS,
    customEventSchemaVersion: 1,
    eventType: 'QnaFilterClickSuccess',
    comment: KissanEventType.QNA_FILTERCLICK_SUCCESS,
  },

  QNA_FILTERCLICK_FAIL: {
    customEventSchemaId: KissanEventType.QNA_FILTERCLICK_FAIL,
    customEventSchemaVersion: 1,
    eventType: 'QnaFilterClickFail',
    comment: KissanEventType.QNA_FILTERCLICK_FAIL,
  },

  QNA_ANSWERBOXOPEN_CLICK_SUCCESS: {
    customEventSchemaId: KissanEventType.QNA_ANSWERBOXOPEN_CLICK_SUCCESS,
    customEventSchemaVersion: 1,
    eventType: 'QnaAnswerBoxOpenClickSuccess',
    comment: KissanEventType.QNA_ANSWERBOXOPEN_CLICK_SUCCESS,
  },

  QNA_ANSWERBOXOPEN_FAIL: {
    customEventSchemaId: KissanEventType.QNA_ANSWERBOXOPEN_FAIL,
    customEventSchemaVersion: 1,
    eventType: 'QnaAnswerBoxOpenFail',
    comment: KissanEventType.QNA_ANSWERBOXOPEN_FAIL,
  },

  QNA_SUBMIT_SUCCESS: {
    customEventSchemaId: KissanEventType.QNA_SUBMIT_SUCCESS,
    customEventSchemaVersion: 1,
    eventType: 'QnaSubmitSuccess',
    comment: KissanEventType.QNA_SUBMIT_SUCCESS,
  },

  QNA_SUBMIT_FAIL: {
    customEventSchemaId: KissanEventType.QNA_SUBMIT_FAIL,
    customEventSchemaVersion: 1,
    eventType: 'QnaSubmitFail',
    comment: KissanEventType.QNA_SUBMIT_FAIL,
  },

  QNA_COMMENTBOXOPEN_SUCCESS: {
    customEventSchemaId: KissanEventType.QNA_COMMENTBOXOPEN_SUCCESS,
    customEventSchemaVersion: 1,
    eventType: 'QnaCommentBoxOpenSuccess',
    comment: KissanEventType.QNA_COMMENTBOXOPEN_SUCCESS,
  },

  QNA_COMMENTBOXOPEN_FAIL: {
    customEventSchemaId: KissanEventType.QNA_COMMENTBOXOPEN_FAIL,
    customEventSchemaVersion: 1,
    eventType: 'QnaCommentBoxOpenFail',
    comment: KissanEventType.QNA_COMMENTBOXOPEN_FAIL,
  },

  QNA_MICCOMMENT_SUCCESS: {
    customEventSchemaId: KissanEventType.QNA_MICCOMMENT_SUCCESS,
    customEventSchemaVersion: 1,
    eventType: 'QnaMicCommentSuccess',
    comment: KissanEventType.QNA_MICCOMMENT_SUCCESS,
  },

  QNA_MICCOMMENT_FAIL: {
    customEventSchemaId: KissanEventType.QNA_MICCOMMENT_FAIL,
    customEventSchemaVersion: 1,
    eventType: 'QnaMicCommentFail',
    comment: KissanEventType.QNA_MICCOMMENT_FAIL,
  },

  QNA_MICANSWER_SUCCESS: {
    customEventSchemaId: KissanEventType.QNA_MICANSWER_SUCCESS,
    customEventSchemaVersion: 1,
    eventType: 'QnaMicAnswerSuccess',
    comment: KissanEventType.QNA_MICANSWER_SUCCESS,
  },

  QNA_MICANSWER_FAIL: {
    customEventSchemaId: KissanEventType.QNA_MICANSWER_FAIL,
    customEventSchemaVersion: 1,
    eventType: 'QnaMicAnswerFail',
    comment: KissanEventType.QNA_MICANSWER_FAIL,
  },

  QNA_VIEWANSWER_CLICK: {
    customEventSchemaId: KissanEventType.QNA_VIEWANSWER_CLICK,
    customEventSchemaVersion: 1,
    eventType: 'QnaViewAnswerClick',
    comment: KissanEventType.QNA_VIEWANSWER_CLICK,
  },

  QNA_VIEWANSWER_ITEMCLICK: {
    customEventSchemaId: KissanEventType.QNA_VIEWANSWER_ITEMCLICK,
    customEventSchemaVersion: 1,
    eventType: 'QnaViewAnswerItemClick',
    comment: KissanEventType.QNA_VIEWANSWER_ITEMCLICK,
  },

  QNA_SHARECLICK_SUCCESS: {
    customEventSchemaId: KissanEventType.QNA_SHARECLICK_SUCCESS,
    customEventSchemaVersion: 1,
    eventType: 'QnaShareClickSuccess',
    comment: KissanEventType.QNA_SHARECLICK_SUCCESS,
  },

  QNA_SHARECLICK_FAIL: {
    customEventSchemaId: KissanEventType.QNA_SHARECLICK_FAIL,
    customEventSchemaVersion: 1,
    eventType: 'QnaShareClickFail',
    comment: KissanEventType.QNA_SHARECLICK_FAIL,
  },

  QNA_HELPFULCLICK_SUCCESS: {
    customEventSchemaId: KissanEventType.QNA_HELPFULCLICK_SUCCESS,
    customEventSchemaVersion: 1,
    eventType: 'QnaHelpfulClickSuccess',
    comment: KissanEventType.QNA_HELPFULCLICK_SUCCESS,
  },

  QNA_NOTHELPFULCLICKS_SUCCESS: {
    customEventSchemaId: KissanEventType.QNA_NOTHELPFULCLICKS_SUCCESS,
    customEventSchemaVersion: 1,
    eventType: 'QnaNotHelpfulClickSuccess',
    comment: KissanEventType.QNA_NOTHELPFULCLICKS_SUCCESS,
  },

  QNA_ASKQUES_CLICK: {
    customEventSchemaId: KissanEventType.QNA_ASKQUES_CLICK,
    customEventSchemaVersion: 1,
    eventType: 'QnaAskQuesClick',
    comment: KissanEventType.QNA_ASKQUES_CLICK,
  },

  QNA_QUESTABOPEN_SUCCESS: {
    customEventSchemaId: KissanEventType.QNA_QUESTABOPEN_SUCCESS,
    customEventSchemaVersion: 1,
    eventType: 'QnaQuestaOpenSuccess',
    comment: KissanEventType.QNA_QUESTABOPEN_SUCCESS,
  },

  QNA_QUESTABOPEN_FAIL: {
    customEventSchemaId: KissanEventType.QNA_QUESTABOPEN_FAIL,
    customEventSchemaVersion: 1,
    eventType: 'QnaQuestaOpenFail',
    comment: KissanEventType.QNA_QUESTABOPEN_FAIL,
  },
  QNA_UPLOADPIC_ITEMCLICK: {
    customEventSchemaId: KissanEventType.QNA_UPLOADPIC_ITEMCLICK,
    customEventSchemaVersion: 1,
    eventType: 'QnaUploadPicItemClick',
    comment: KissanEventType.QNA_UPLOADPIC_ITEMCLICK,
  },

  QNA_GALLERYOPEN_SUCCESS: {
    customEventSchemaId: KissanEventType.QNA_GALLERYOPEN_SUCCESS,
    customEventSchemaVersion: 1,
    eventType: 'QnaGalleryOpenSuccess',
    comment: KissanEventType.QNA_GALLERYOPEN_SUCCESS,
  },

  QNA_GALLERYOPEN_FAIL: {
    customEventSchemaId: KissanEventType.QNA_GALLERYOPEN_FAIL,
    customEventSchemaVersion: 1,
    eventType: 'QnaGalleryOpenFail',
    comment: KissanEventType.QNA_GALLERYOPEN_FAIL,
  },

  QNA_UPLOADVIDEO_ITEMCLICK: {
    customEventSchemaId: KissanEventType.QNA_UPLOADVIDEO_ITEMCLICK,
    customEventSchemaVersion: 1,
    eventType: 'QnaUploadVideoItemClick',
    comment: KissanEventType.QNA_UPLOADVIDEO_ITEMCLICK,
  },

  QNA_ASKSUBMIT_SUCCESS: {
    customEventSchemaId: KissanEventType.QNA_ASKSUBMIT_SUCCESS,
    customEventSchemaVersion: 1,
    eventType: 'QnaAskSubmitSuccess',
    comment: KissanEventType.QNA_ASKSUBMIT_SUCCESS,
  },

  QNA_ASKSUBMIT_FAIL: {
    customEventSchemaId: KissanEventType.QNA_ASKSUBMIT_FAIL,
    customEventSchemaVersion: 1,
    eventType: 'QnaAskSubmitFail',
    comment: KissanEventType.QNA_ASKSUBMIT_FAIL,
  },

  QNA_VIEWANS1_CLICK_BOTTOMSHEET: {
    customEventSchemaId: KissanEventType.QNA_VIEWANS1_CLICK_BOTTOMSHEET,
    customEventSchemaVersion: 1,
    eventType: 'QnaViewAns1ClickBottomSheet',
    comment: KissanEventType.QNA_VIEWANS1_CLICK_BOTTOMSHEET,
  },

  QNA_FEEDBACK_SUBMIT: {
    customEventSchemaId: KissanEventType.QNA_FEEDBACK_SUBMIT,
    customEventSchemaVersion: 1,
    eventType: 'QnaFeedBackSubmit',
    comment: KissanEventType.QNA_FEEDBACK_SUBMIT,
  },

  QNA_MYQUESCLICK_SUCCESS: {
    customEventSchemaId: KissanEventType.QNA_MYQUESCLICK_SUCCESS,
    customEventSchemaVersion: 1,
    eventType: 'QnaMyQuesClickSuccess',
    comment: KissanEventType.QNA_MYQUESCLICK_SUCCESS,
  },

  QNA_MYQUESCLICK_FAIL: {
    customEventSchemaId: KissanEventType.QNA_MYQUESCLICK_FAIL,
    customEventSchemaVersion: 1,
    eventType: 'QnaMyQuesClickFail',
    comment: KissanEventType.QNA_MYQUESCLICK_FAIL,
  },
  QNA_SEARCH_CLICK: {
    customEventSchemaId: KissanEventType.QNA_SEARCH_CLICK,
    customEventSchemaVersion: 1,
    eventType: 'QnaSearchClick',
    comment: KissanEventType.QNA_SEARCH_CLICK,
  },

  ANONYMOUS_USER_NOT_LOGGEDIN: {
    customEventSchemaId: KissanEventType.ANONYMOUS_USER_NOT_LOGGEDIN,
    customEventSchemaVersion: 1,
    eventType: 'AnonymousUserNotLoggedIn',
    comment: KissanEventType.ANONYMOUS_USER_NOT_LOGGEDIN,
  },
  QNA_ANSWERBOXOPEN_SUCCESS: {
    customEventSchemaId: KissanEventType.QNA_ANSWERBOXOPEN_SUCCESS,
    customEventSchemaVersion: 1,
    eventType: 'QnaAnswerBoxOpenSuccess',
    comment: KissanEventType.QNA_ANSWERBOXOPEN_SUCCESS,
  },
  QNA_ANSWER_LIKED: {
    customEventSchemaId: KissanEventType.QNA_ANSWER_LIKED,
    customEventSchemaVersion: 1,
    eventType: 'QnaAnswerLiked',
    comment: KissanEventType.QNA_ANSWER_LIKED,
  },
  QNA_ANSWER_DISLIKED: {
    customEventSchemaId: KissanEventType.QNA_ANSWER_DISLIKED,
    customEventSchemaVersion: 1,
    eventType: 'QnaAnswerDisLiked',
    comment: KissanEventType.QNA_ANSWER_DISLIKED,
  },
  DIS_ITEM_LIKE: {
    customEventSchemaId: KissanEventType.DIS_ITEM_LIKE,
    customEventSchemaVersion: 1,
    eventType: 'DisItemLike',
    comment: KissanEventType.DIS_ITEM_LIKE,
  },
  DIS_ITEM_COMMENT: {
    customEventSchemaId: KissanEventType.DIS_ITEM_COMMENT,
    customEventSchemaVersion: 1,
    eventType: 'DisItemComment',
    comment: KissanEventType.DIS_ITEM_COMMENT,
  },
  DIS_ITEM_SHARE: {
    customEventSchemaId: KissanEventType.DIS_ITEM_SHARE,
    customEventSchemaVersion: 1,
    eventType: 'DisItemShare',
    comment: KissanEventType.DIS_ITEM_SHARE,
  },
  MYQUES_PAGESCROLL_VERTICAL: {
    customEventSchemaId: KissanEventType.MYQUES_PAGESCROLL_VERTICAL,
    customEventSchemaVersion: 1,
    eventType: 'MyQuesPageScrollVertical',
    comment: KissanEventType.MYQUES_PAGESCROLL_VERTICAL,
  },
  PLAYLIST_VIDEOSCROLL_END: {
    customEventSchemaId: KissanEventType.PLAYLIST_VIDEOSCROLL_END,
    customEventSchemaVersion: 1,
    eventType: 'PlayListVideoScrollEnd',
    comment: KissanEventType.PLAYLIST_VIDEOSCROLL_END,
  },
  SHORT_VIDEO_SCROLLED_END: {
    customEventSchemaId: KissanEventType.SHORT_VIDEO_SCROLLED_END,
    customEventSchemaVersion: 1,
    eventType: 'ShortVideoScrollEnd',
    comment: KissanEventType.SHORT_VIDEO_SCROLLED_END,
  },
  SHORT_VIDEO_CLICKED: {
    customEventSchemaId: KissanEventType.SHORT_VIDEO_CLICKED,
    customEventSchemaVersion: 1,
    eventType: 'ShortVideoClicked',
    comment: KissanEventType.SHORT_VIDEO_CLICKED,
  },
  SHORT_VIDEO_SCROLLED: {
    customEventSchemaId: KissanEventType.SHORT_VIDEO_SCROLLED,
    customEventSchemaVersion: 1,
    eventType: 'ShortVideoScrolled',
    comment: KissanEventType.SHORT_VIDEO_SCROLLED,
  },

  LOGIN_INITIATE_POPUP: {
    customEventSchemaId: KissanEventType.LOGIN_INITIATE_POPUP,
    customEventSchemaVersion: 1,
    eventType: 'LoginInitiatePopup',
    comment: KissanEventType.LOGIN_INITIATE_POPUP,
  },
  FEEDPAGE_ASKQUES_CLICK: {
    customEventSchemaId: KissanEventType.FEEDPAGE_ASKQUES_CLICK,
    customEventSchemaVersion: 1,
    eventType: 'FeedPageAskQuesClick',
    comment: KissanEventType.FEEDPAGE_ASKQUES_CLICK,
  },

  BOTTOMSHEET_LOGIN_CLICK: {
    customEventSchemaId: KissanEventType.BOTTOMSHEET_LOGIN_CLICK,
    customEventSchemaVersion: 1,
    eventType: 'BottomSheetLoginClick',
    comment: KissanEventType.BOTTOMSHEET_LOGIN_CLICK,
  },
  LANGUAGE_CHANGE_CLICK: {
    customEventSchemaId: KissanEventType.LANGUAGE_CHANGE_CLICK,
    customEventSchemaVersion: 1,
    eventType: 'LanguageChangeClick',
    comment: KissanEventType.LANGUAGE_CHANGE_CLICK,
  },
  VIDEO_PLAYED_MORE_THAN_FIVE_SECONDS: {
    customEventSchemaId: KissanEventType.VIDEO_PLAYED_MORE_THAN_FIVE_SECONDS,
    customEventSchemaVersion: 1,
    eventType: 'VideoPlayedMoreThanFiveSeconds',
    comment: KissanEventType.VIDEO_PLAYED_MORE_THAN_FIVE_SECONDS,
  },
  DATA_VIEWED_MORETHAN_ONE_SECOND: {
    customEventSchemaId: KissanEventType.DATA_VIEWED_MORETHAN_ONE_SECOND,
    customEventSchemaVersion: 1,
    eventType: 'DataViewedMoreThanOneSecond',
    comment: KissanEventType.DATA_VIEWED_MORETHAN_ONE_SECOND,
  },
  USER_ACTION: {
    customEventSchemaId: KissanEventType.USER_ACTION,
    customEventSchemaVersion: 1,
    eventType: 'UserAction',
    comment: KissanEventType.USER_ACTION,
  },
  MODERATOR_ANSWER_SUBMITTED: {
    customEventSchemaId: KissanEventType.MODERATOR_ANSWER_SUBMITTED,
    customEventSchemaVersion: 1,
    eventType: 'ModeratorAnswerSubmitted',
    comment: KissanEventType.MODERATOR_ANSWER_SUBMITTED,
  },
  HOMEPAGE_LOAD_FAILED: {
    customEventSchemaId: KissanEventType.HOMEPAGE_LOAD_FAILED,
    customEventSchemaVersion: 1,
    eventType: 'HomePageLoadFailed',
    comment: KissanEventType.HOMEPAGE_LOAD_FAILED,
  },
  HOMEPAGE_INITIATED_SUCCESSFULLY: {
    customEventSchemaId: KissanEventType.HOMEPAGE_INITIATED_SUCCESSFULLY,
    customEventSchemaVersion: 1,
    eventType: 'HomePageInitiatedSuccessfully',
    comment: KissanEventType.HOMEPAGE_INITIATED_SUCCESSFULLY,
  },
  VIDEO_PROGRESS: {
    customEventSchemaId: KissanEventType.VIDEO_PROGRESS,
    customEventSchemaVersion: 1,
    eventType: 'VideoProgess',
    comment: KissanEventType.VIDEO_PROGRESS,
  },
  PLACEHOLDER_TOPCOMPONENT_HOMEPAGE: {
    customEventSchemaId: KissanEventType.PLACEHOLDER_TOPCOMPONENT_HOMEPAGE,
    customEventSchemaVersion: 1,
    eventType: 'PlaceholderTopCommentHomePage',
    comment: KissanEventType.PLACEHOLDER_TOPCOMPONENT_HOMEPAGE,
  },
  QNA_USERTYPE_QUESTION: {
    customEventSchemaId: KissanEventType.QNA_USERTYPE_QUESTION,
    customEventSchemaVersion: 1,
    eventType: 'QnaUserTypeQuestion',
    comment: KissanEventType.QNA_USERTYPE_QUESTION,
  },
  POST_USERTYPE: {
    customEventSchemaId: KissanEventType.POST_USERTYPE,
    customEventSchemaVersion: 1,
    eventType: 'PostUserType',
    comment: KissanEventType.POST_USERTYPE,
  },
  QNA_DELETE_IMAGE_ITEMCLICK: {
    customEventSchemaId: KissanEventType.QNA_DELETE_IMAGE_ITEMCLICK,
    customEventSchemaVersion: 1,
    eventType: 'QnaDeleteImageItemClick',
    comment: KissanEventType.QNA_DELETE_IMAGE_ITEMCLICK,
  },
  SELF_ANSWER_VIEW: {
    customEventSchemaId: KissanEventType.SELF_ANSWER_VIEW,
    customEventSchemaVersion: 1,
    eventType: 'SelfAnswerView',
    comment: KissanEventType.SELF_ANSWER_VIEW,
  },
  QNA_READ_MORE_CLICK: {
    customEventSchemaId: KissanEventType.QNA_READ_MORE_CLICK,
    customEventSchemaVersion: 1,
    eventType: 'QnaReadMoreClick',
    comment: KissanEventType.QNA_READ_MORE_CLICK,
  },
  QNA_READ_LESS_CLICK: {
    customEventSchemaId: KissanEventType.QNA_READ_LESS_CLICK,
    customEventSchemaVersion: 1,
    eventType: 'QnaReadLessClick',
    comment: KissanEventType.QNA_READ_LESS_CLICK,
  },
  TRUECALLER_POPUP: {
    customEventSchemaId: KissanEventType.TRUECALLER_POPUP,
    customEventSchemaVersion: 1,
    eventType: 'TrueCallerPopup',
    comment: KissanEventType.TRUECALLER_POPUP,
  },
  TRUECALLER_POPUP_FAILED: {
    customEventSchemaId: KissanEventType.TRUECALLER_POPUP_FAILED,
    customEventSchemaVersion: 1,
    eventType: 'TrueCallerPopupFailed',
    comment: KissanEventType.TRUECALLER_POPUP_FAILED,
  },
  TRUECALLER_LOADTIME: {
    customEventSchemaId: KissanEventType.TRUECALLER_LOADTIME,
    customEventSchemaVersion: 1,
    eventType: 'TrueCallerLoadTime',
    comment: KissanEventType.TRUECALLER_LOADTIME,
  },
  TRUECALLER_APPROVED: {
    customEventSchemaId: KissanEventType.TRUECALLER_APPROVED,
    customEventSchemaVersion: 1,
    eventType: 'TrueCallerApproved',
    comment: KissanEventType.TRUECALLER_APPROVED,
  },
  TRUECALLER_DENIED: {
    customEventSchemaId: KissanEventType.TRUECALLER_DENIED,
    customEventSchemaVersion: 1,
    eventType: 'TrueCallerDenied',
    comment: KissanEventType.TRUECALLER_DENIED,
  },
  TRUECALLER_INSTALLED: {
    customEventSchemaId: KissanEventType.TRUECALLER_INSTALLED,
    customEventSchemaVersion: 1,
    eventType: 'TrueCallerInstalled',
    comment: KissanEventType.TRUECALLER_INSTALLED,
  },
  TRUECALLER_API_ERROR: {
    customEventSchemaId: KissanEventType.TRUECALLER_API_ERROR,
    customEventSchemaVersion: 1,
    eventType: 'TrueCallerApiError',
    comment: KissanEventType.TRUECALLER_API_ERROR,
  },
  TRUECALLER_USERPROFILE: {
    customEventSchemaId: KissanEventType.TRUECALLER_USERPROFILE,
    customEventSchemaVersion: 1,
    eventType: 'TrueCallerUserProfile',
    comment: KissanEventType.TRUECALLER_USERPROFILE,
  },
  API_ERROR: {
    customEventSchemaId: KissanEventType.API_ERROR,
    customEventSchemaVersion: 1,
    eventType: 'ApiError',
    comment: KissanEventType.API_ERROR,
  },
  VIDEO_BUFFER_TIME: {
    customEventSchemaId: KissanEventType.VIDEO_BUFFER_TIME,
    customEventSchemaVersion: 1,
    eventType: 'VideoBufferTime',
    comment: KissanEventType.VIDEO_BUFFER_TIME,
  },
  REFERRAL_SHARE: {
    customEventSchemaId: KissanEventType.REFERRAL_SHARE,
    customEventSchemaVersion: 1,
    eventType: 'ReferralShare',
    comment: KissanEventType.REFERRAL_SHARE,
  },
  REFERRAL_COPY: {
    customEventSchemaId: KissanEventType.REFERRAL_COPY,
    customEventSchemaVersion: 1,
    eventType: 'ReferralCopy',
    comment: KissanEventType.REFERRAL_COPY,
  },
  ENTER_REFERRALCODE_CLICKED: {
    customEventSchemaId: KissanEventType.ENTER_REFERRALCODE_CLICKED,
    customEventSchemaVersion: 1,
    eventType: 'EnterReferralCodeClicked',
    comment: KissanEventType.ENTER_REFERRALCODE_CLICKED,
  },
  REFERRALCODE_BOTTOMSHEET_OPEN: {
    customEventSchemaId: KissanEventType.REFERRALCODE_BOTTOMSHEET_OPEN,
    customEventSchemaVersion: 1,
    eventType: 'ReferralCodeBottomSheetOpen',
    comment: KissanEventType.REFERRALCODE_BOTTOMSHEET_OPEN,
  },
  REFERRALCODE_START_TYPE: {
    customEventSchemaId: KissanEventType.REFERRALCODE_START_TYPE,
    customEventSchemaVersion: 1,
    eventType: 'ReferralCodeStartType',
    comment: KissanEventType.REFERRALCODE_START_TYPE,
  },
  REFERRALCODE_SUBMIT: {
    customEventSchemaId: KissanEventType.REFERRALCODE_SUBMIT,
    customEventSchemaVersion: 1,
    eventType: 'ReferralCodeSubmit',
    comment: KissanEventType.REFERRALCODE_SUBMIT,
  },

  REFERRAL_VERIFICATION_API_FAILURE: {
    customEventSchemaId: KissanEventType.REFERRAL_VERIFICATION_API_FAILURE,
    customEventSchemaVersion: 1,
    eventType: 'ReferralCodeVerificationAPIFailure',
    comment: KissanEventType.REFERRAL_VERIFICATION_API_FAILURE,
  },
  REFERRAL_VERIFICATION_API_SUCCESS: {
    customEventSchemaId: KissanEventType.REFERRAL_VERIFICATION_API_SUCCESS,
    customEventSchemaVersion: 1,
    eventType: 'ReferralCodeVerificationAPISuccess',
    comment: KissanEventType.REFERRAL_VERIFICATION_API_SUCCESS,
  },
  USER_PROFILE_API_SUCCESS: {
    customEventSchemaId: KissanEventType.USER_PROFILE_API_SUCCESS,
    customEventSchemaVersion: 1,
    eventType: 'UserProfileApiSuccess',
    comment: KissanEventType.USER_PROFILE_API_SUCCESS,
  },
  HOME_SEARCH_CLICK: {
    customEventSchemaId: KissanEventType.HOME_SEARCH_CLICK,
    customEventSchemaVersion: 1,
    eventType: 'HomeSearchClick',
    comment: KissanEventType.HOME_SEARCH_CLICK,
  },

  USER_LOGOUT: {
    customEventSchemaId: KissanEventType.USER_LOGOUT,
    customEventSchemaVersion: 1,
    eventType: 'UserLogout',
    comment: KissanEventType.USER_LOGOUT,
  },

  TOURGUIDE_LAUNCH_SUCCESSFUL_HP: {
    customEventSchemaId: KissanEventType.TOURGUIDE_LAUNCH_SUCCESSFUL_HP,
    customEventSchemaVersion: 1,
    eventType: 'TourGuideLaunchSuccessfulHP',
    comment: KissanEventType.TOURGUIDE_LAUNCH_SUCCESSFUL_HP,
  },

  TOURGUIDE_LAUNCH_FAILURE_HP: {
    customEventSchemaId: KissanEventType.TOURGUIDE_LAUNCH_FAILURE_HP,
    customEventSchemaVersion: 1,
    eventType: 'TourGuideLaunchFailureHP',
    comment: KissanEventType.TOURGUIDE_LAUNCH_FAILURE_HP,
  },
  TOURGUIDE_LAUNCH_SUCCESSFUL_ASKAQUESTION: {
    customEventSchemaId: KissanEventType.TOURGUIDE_LAUNCH_SUCCESSFUL_ASKAQUESTION,
    customEventSchemaVersion: 1,
    eventType: 'TourGuideLaunchSuccessfulAskAQuestion',
    comment: KissanEventType.TOURGUIDE_LAUNCH_SUCCESSFUL_ASKAQUESTION,
  },

  TOURGUIDE_LAUNCH_FAILURE_ASKAQUESTION: {
    customEventSchemaId: KissanEventType.TOURGUIDE_LAUNCH_FAILURE_ASKAQUESTION,
    customEventSchemaVersion: 1,
    eventType: 'TourGuideLaunchFailureAskAQuestion',
    comment: KissanEventType.TOURGUIDE_LAUNCH_FAILURE_ASKAQUESTION,
  },

  TOURGUIDE_LAUNCH_SUCCESSFUL_CREATEAPOST: {
    customEventSchemaId: KissanEventType.TOURGUIDE_LAUNCH_SUCCESSFUL_CREATEAPOST,
    customEventSchemaVersion: 1,
    eventType: 'TourGuideLaunchSuccessfulCreateAPost',
    comment: KissanEventType.TOURGUIDE_LAUNCH_SUCCESSFUL_CREATEAPOST,
  },

  TOURGUIDE_LAUNCH_FAILURE_CREATEAPOST: {
    customEventSchemaId: KissanEventType.TOURGUIDE_LAUNCH_FAILURE_CREATEAPOST,
    customEventSchemaVersion: 1,
    eventType: 'TourGuideLaunchFailureCreateAPost',
    comment: KissanEventType.TOURGUIDE_LAUNCH_FAILURE_CREATEAPOST,
  },

  TOURGUIDE_SKIP: {
    customEventSchemaId: KissanEventType.TOURGUIDE_SKIP,
    customEventSchemaVersion: 1,
    eventType: 'TourGuideSkip',
    comment: KissanEventType.TOURGUIDE_SKIP,
  },

  TOURGUIDE_NEXT: {
    customEventSchemaId: KissanEventType.TOURGUIDE_NEXT,
    customEventSchemaVersion: 1,
    eventType: 'TourGuideNext',
    comment: KissanEventType.TOURGUIDE_NEXT,
  },

  TOURGUIDE_FINISH: {
    customEventSchemaId: KissanEventType.TOURGUIDE_FINISH,
    customEventSchemaVersion: 1,
    eventType: 'TOURGUIDE_LAUNCH_SUCCESSFULHP',
    comment: KissanEventType.TOURGUIDE_FINISH,
  },

  TOURGUIDE_PREVIOUS: {
    customEventSchemaId: KissanEventType.TOURGUIDE_PREVIOUS,
    customEventSchemaVersion: 1,
    eventType: 'TourGuidePrevious',
    comment: KissanEventType.TOURGUIDE_PREVIOUS,
  },
  SHORTS_VIDEO_ON_READY_TIME: {
    customEventSchemaId: KissanEventType.SHORTS_VIDEO_ON_READY_TIME,
    customEventSchemaVersion: 1,
    eventType: 'ShortsVideoOnReadyTime',
    comment: KissanEventType.SHORTS_VIDEO_ON_READY_TIME,
  },
  RELATED_VIDEO_CLICKED: {
    customEventSchemaId: KissanEventType.RELATED_VIDEO_CLICKED,
    customEventSchemaVersion: 1,
    eventType: 'RelatedVideoClicked',
    comment: KissanEventType.RELATED_VIDEO_CLICKED,
  },
  NO_NETWORK_TRY_AGAIN_CLICKED: {
    customEventSchemaId: KissanEventType.NO_NETWORK_TRY_AGAIN_CLICKED,
    customEventSchemaVersion: 1,
    eventType: 'NoNetworkTryAgainClicked',
    comment: KissanEventType.NO_NETWORK_TRY_AGAIN_CLICKED,
  },
  FEED_RELATED_VIDEO_CLICKED: {
    customEventSchemaId: KissanEventType.FEED_RELATED_VIDEO_CLICKED,
    customEventSchemaVersion: 1,
    eventType: 'FeedRelatedVideoClicked',
    comment: KissanEventType.FEED_RELATED_VIDEO_CLICKED,
  },
  MANDI_NEWS_ICON_CLICKED: {
    customEventSchemaId: KissanEventType.MANDI_NEWS_ICON_CLICKED,
    customEventSchemaVersion: 1,
    eventType: 'MandiNewsIconClicked',
    comment: KissanEventType.MANDI_NEWS_ICON_CLICKED,
  },

  MANDI_NEWS_CLOSE_ICON_CLICKED: {
    customEventSchemaId: KissanEventType.MANDI_NEWS_CLOSE_ICON_CLICKED,
    customEventSchemaVersion: 1,
    eventType: 'MandiNewsCloseIconClicked',
    comment: KissanEventType.MANDI_NEWS_CLOSE_ICON_CLICKED,
  },
  MANDI_NEWS_BACK_ICON_PRESSED: {
    customEventSchemaId: KissanEventType.MANDI_NEWS_BACK_ICON_PRESSED,
    customEventSchemaVersion: 1,
    eventType: 'MandiNewsBackIconPressed',
    comment: KissanEventType.MANDI_NEWS_BACK_ICON_PRESSED,
  },
  FEED_WEATHER_CARD_CLICK: {
    customEventSchemaId: KissanEventType.FEED_WEATHER_CARD_CLICK,
    customEventSchemaVersion: 1,
    eventType: 'FeedWeatherCardClicked',
    comment: KissanEventType.FEED_WEATHER_CARD_CLICK,
  },
  WEATHER_SHARE_CLICK: {
    customEventSchemaId: KissanEventType.WEATHER_SHARE_CLICK,
    customEventSchemaVersion: 1,
    eventType: 'WeatherShareClicked',
    comment: KissanEventType.WEATHER_SHARE_CLICK,
  },
  WEATHER_PAGE_OPEN_SUCCESS: {
    customEventSchemaId: KissanEventType.WEATHER_PAGE_OPEN_SUCCESS,
    customEventSchemaVersion: 1,
    eventType: 'WeatherPageOpenSuccess',
    comment: KissanEventType.WEATHER_PAGE_OPEN_SUCCESS,
  },
  WEATHER_DAY_SELECT: {
    customEventSchemaId: KissanEventType.WEATHER_DAY_SELECT,
    customEventSchemaVersion: 1,
    eventType: 'WeatherDaySelected',
    comment: KissanEventType.WEATHER_DAY_SELECT,
  },
  FEED_WEATHER_BUTTON_CLICK: {
    customEventSchemaId: KissanEventType.FEED_WEATHER_BUTTON_CLICK,
    customEventSchemaVersion: 1,
    eventType: 'FeedWeatherButtonClicked',
    comment: KissanEventType.FEED_WEATHER_BUTTON_CLICK,
  },
  WEATHER_LOCATION_POPUP: {
    customEventSchemaId: KissanEventType.WEATHER_LOCATION_POPUP,
    customEventSchemaVersion: 1,
    eventType: 'WeatherLocationPopUp',
    comment: KissanEventType.WEATHER_LOCATION_POPUP,
  },
  DIS_VIDEO_PLAY_FINISH: {
    customEventSchemaId: KissanEventType.DIS_VIDEO_PLAY_FINISH,
    customEventSchemaVersion: 1,
    eventType: 'DisVideoPlayFinish',
    comment: KissanEventType.DIS_VIDEO_PLAY_FINISH,
  },
  DIS_VIDEO_ON_READY_TIME: {
    customEventSchemaId: KissanEventType.DIS_VIDEO_ON_READY_TIME,
    customEventSchemaVersion: 1,
    eventType: 'DisVideoOnReadyTime',
    comment: KissanEventType.DIS_VIDEO_ON_READY_TIME,
  },

  FEED_USER_CROPSELECT: {
    customEventSchemaId: KissanEventType.FEED_USER_CROPSELECT,
    customEventSchemaVersion: 1,
    eventType: 'FeedUserCropSelect',
    comment: KissanEventType.FEED_USER_CROPSELECT,
  },
  PROFILE_USER_CROPSELECT: {
    customEventSchemaId: KissanEventType.PROFILE_USER_CROPSELECT,
    customEventSchemaVersion: 1,
    eventType: 'ProfileUserCropSelect',
    comment: KissanEventType.PROFILE_USER_CROPSELECT,
  },
  CROP_CATEGORY_PAGEOPEN: {
    customEventSchemaId: KissanEventType.CROP_CATEGORY_PAGEOPEN,
    customEventSchemaVersion: 1,
    eventType: 'CropCategoryPageOpen',
    comment: KissanEventType.CROP_CATEGORY_PAGEOPEN,
  },
  CROP_CATEGORY_SELECT: {
    customEventSchemaId: KissanEventType.CROP_CATEGORY_SELECT,
    customEventSchemaVersion: 1,
    eventType: 'CropCategorySelect',
    comment: KissanEventType.CROP_CATEGORY_SELECT,
  },
  CROP_REMOVE: {
    customEventSchemaId: KissanEventType.CROP_REMOVE,
    customEventSchemaVersion: 1,
    eventType: 'CropRemove',
    comment: KissanEventType.CROP_REMOVE,
  },
  CROP_ADDED: {
    customEventSchemaId: KissanEventType.CROP_ADDED,
    customEventSchemaVersion: 1,
    eventType: 'CropAdded',
    comment: KissanEventType.CROP_ADDED,
  },

  QUESTION_ANSWERED_POPUP_CLICK: {
    customEventSchemaId: KissanEventType.QUESTION_ANSWERED_POPUP_CLICK,
    customEventSchemaVersion: 1,
    eventType: 'QuestionAnsweredPopupclicked',
    comment: KissanEventType.QUESTION_ANSWERED_POPUP_CLICK,
  },
  QUESTION_ANSWERED_POPUP_CROSS: {
    customEventSchemaId: KissanEventType.QUESTION_ANSWERED_POPUP_CROSS,
    customEventSchemaVersion: 1,
    eventType: 'QuestionAnsweredPopupcross',
    comment: KissanEventType.QUESTION_ANSWERED_POPUP_CROSS,
  },
  ANSWER_INPROGRESS_BAR: {
    customEventSchemaId: KissanEventType.ANSWER_INPROGRESS_BAR,
    customEventSchemaVersion: 1,
    eventType: 'AnswerInprogressBar',
    comment: KissanEventType.ANSWER_INPROGRESS_BAR,
  },
  AUTO_PLAY_VIDEO_ERROR: {
    customEventSchemaId: KissanEventType.AUTO_PLAY_VIDEO_ERROR,
    customEventSchemaVersion: 1,
    eventType: 'AutoPlayVideoError',
    feature: KissanEventType.FEED_VIDEO,
    comment: KissanEventType.VIDEO_FAILS_TO_PLAY,
  },
  AUTO_PLAY_VIDEO_PLAY: {
    customEventSchemaId: KissanEventType.AUTO_PLAY_VIDEO_PLAY,
    customEventSchemaVersion: 1,
    eventType: 'AutoPlayVideoPlay',
    feature: KissanEventType.FEED_VIDEO,
    comment: KissanEventType.AUTO_PLAY_VIDEO_IS_PLAYED,
  },
  AUTO_PLAY_VIDEO_ON_READY_TIME: {
    customEventSchemaId: KissanEventType.AUTO_PLAY_VIDEO_ON_READY_TIME,
    customEventSchemaVersion: 1,
    eventType: 'AutoPlayVideoOnReadyTime',
    feature: KissanEventType.FEED_VIDEO,
    comment: KissanEventType.AUTO_PLAY_VIDEO_READY_TO_PLAY,
  },
  AUTO_PLAY_VIDEO_PLAY_FINISH: {
    customEventSchemaId: KissanEventType.AUTO_PLAY_VIDEO_PLAY_FINISH,
    customEventSchemaVersion: 1,
    eventType: 'AutoPlayVideoPlayFinish',
    feature: KissanEventType.FEED_VIDEO,
    comment: KissanEventType.AUTO_PLAY_ONCE_THE_WHOLE_VIDEO_IS_PLAYED_AND_CLOSED,
  },
  NOTIFICATION_SENT_ERROR: {
    customEventSchemaId: KissanEventType.NOTIFICATION_SENT_ERROR,
    customEventSchemaVersion: 1,
    eventType: 'NotificationSentError',
    feature: KissanEventType.NOTIFICATION_SENT_ERROR,
  },
  AUTO_PLAY_VIDEO_BUFFER_TIME: {
    customEventSchemaId: KissanEventType.AUTO_PLAY_VIDEO_BUFFER_TIME,
    customEventSchemaVersion: 1,
    eventType: 'AutoPlayVideoBufferTime',
    comment: KissanEventType.AUTO_PLAY_VIDEO_BUFFER_TIME,
  },
  HOMEPAGE_NO_DATA_FOUND: {
    customEventSchemaId: KissanEventType.HOMEPAGE_NO_DATA_FOUND,
    customEventSchemaVersion: 1,
    eventType: 'HomepageNoDataFound',
    feature: KissanEventType.HOMEPAGE_NO_DATA_FOUND,
  },
  SELECTED_CROP_BEFORE_LOGIN: {
    customEventSchemaId: KissanEventType.SELECTED_CROP_BEFORE_LOGIN,
    customEventSchemaVersion: 1,
    eventType: 'SelectedCropBeforeLogin',
    feature: KissanEventType.SELECTED_CROP_BEFORE_LOGIN,
  },
  GLOBAL_SEARCH_CLICK: {
    customEventSchemaId: KissanEventType.GLOBAL_SEARCH_CLICK,
    customEventSchemaVersion: 1,
    eventType: 'GlobalSearchClick',
    feature: KissanEventType.GLOBAL_SEARCH_CLICK,
  },
  SEARCH_SUGGESTIONS_CLICK: {
    customEventSchemaId: KissanEventType.SEARCH_SUGGESTIONS_CLICK,
    customEventSchemaVersion: 1,
    eventType: 'SearchSuggestionsClick',
    feature: KissanEventType.SEARCH_SUGGESTIONS_CLICK,
  },
  SEARCH_CATEGORY_CLICK: {
    customEventSchemaId: KissanEventType.SEARCH_CATEGORY_CLICK,
    customEventSchemaVersion: 1,
    eventType: 'SearchCategoryClick',
    feature: KissanEventType.SEARCH_CATEGORY_CLICK,
  },
  SEARCH_ITEM_CLICK_SUCCESS: {
    customEventSchemaId: KissanEventType.SEARCH_ITEM_CLICK_SUCCESS,
    customEventSchemaVersion: 1,
    eventType: 'SearchCategoryClick',
    feature: KissanEventType.SEARCH_ITEM_CLICK_SUCCESS,
  },
  SEARCH_ITEM_CLICK_FAILED: {
    customEventSchemaId: KissanEventType.SEARCH_ITEM_CLICK_FAILED,
    customEventSchemaVersion: 1,
    eventType: 'SearchItemClickFailed',
    feature: KissanEventType.SEARCH_ITEM_CLICK_FAILED,
  },
  ADS_STARTED: {
    customEventSchemaId: KissanEventType.ADS_STARTED,
    customEventSchemaVersion: 1,
    eventType: 'AdsStarted',
    feature: KissanEventType.ADS_STARTED,
  },
  ADS_COMPLETED: {
    customEventSchemaId: KissanEventType.ADS_COMPLETED,
    customEventSchemaVersion: 1,
    eventType: 'AdsCompleted',
    feature: KissanEventType.ADS_COMPLETED,
  },

  PROFILE_EDIT_SELECT: {
    customEventSchemaId: KissanEventType.PROFILE_EDIT_SELECT,
    customEventSchemaVersion: 1,
    eventType: 'ProfileEditSelect',
    feature: KissanEventType.PROFILE_EDIT_SELECT,
  },
  PROFILE_EDIT_PAGEOPEN: {
    customEventSchemaId: KissanEventType.PROFILE_EDIT_PAGEOPEN,
    customEventSchemaVersion: 1,
    eventType: 'ProfileEditPageOpen',
    feature: KissanEventType.PROFILE_EDIT_PAGEOPEN,
  },
  PROFILE_EDIT_SAVE: {
    customEventSchemaId: KissanEventType.PROFILE_EDIT_SAVE,
    customEventSchemaVersion: 1,
    eventType: 'ProfileEditSave',
    feature: KissanEventType.PROFILE_EDIT_SAVE,
  },
  PROFILE_LANG_CHANGE: {
    customEventSchemaId: KissanEventType.PROFILE_LANG_CHANGE,
    customEventSchemaVersion: 1,
    eventType: 'ProfileLangChange',
    feature: KissanEventType.PROFILE_LANG_CHANGE,
  },
  PROFILE_REFER_CLICK: {
    customEventSchemaId: KissanEventType.PROFILE_REFER_CLICK,
    customEventSchemaVersion: 1,
    eventType: 'ProfileReferClick',
    feature: KissanEventType.PROFILE_REFER_CLICK,
  },

  PROFILE_T_AND_C_CLICK: {
    customEventSchemaId: KissanEventType.PROFILE_T_AND_C_CLICK,
    customEventSchemaVersion: 1,
    eventType: 'ProfileTermsAndConditionsClick',
    feature: KissanEventType.PROFILE_T_AND_C_CLICK,
  },
  PROFILE_PP_CLICK: {
    customEventSchemaId: KissanEventType.PROFILE_PP_CLICK,
    customEventSchemaVersion: 1,
    eventType: 'ProfilePrivacyPolicyClick',
    feature: KissanEventType.PROFILE_PP_CLICK,
  },
  PROFILE_SENDFEEDBACK_CLICK: {
    customEventSchemaId: KissanEventType.PROFILE_SENDFEEDBACK_CLICK,
    customEventSchemaVersion: 1,
    eventType: 'ProfileSendFeedbackClick',
    feature: KissanEventType.PROFILE_SENDFEEDBACK_CLICK,
  },
  PROFILE_CONTACTUS_CLICK: {
    customEventSchemaId: KissanEventType.PROFILE_CONTACTUS_CLICK,
    customEventSchemaVersion: 1,
    eventType: 'ProfileContactUsClick',
    feature: KissanEventType.PROFILE_CONTACTUS_CLICK,
  },
  PROFILE_SELF_MYPROFILE: {
    customEventSchemaId: KissanEventType.PROFILE_SELF_MYPROFILE,
    customEventSchemaVersion: 1,
    eventType: 'ProfileSelfMyProfile',
    feature: KissanEventType.PROFILE_SELF_MYPROFILE,
  },
  PROFILE_SELF_VIDEOS: {
    customEventSchemaId: KissanEventType.PROFILE_SELF_VIDEOS,
    customEventSchemaVersion: 1,
    eventType: 'ProfileSelfVideos',
    feature: KissanEventType.PROFILE_SELF_VIDEOS,
  },
  PROFILE_SELF_QUESTIONS: {
    customEventSchemaId: KissanEventType.PROFILE_SELF_QUESTIONS,
    customEventSchemaVersion: 1,
    eventType: 'ProfileSelfQuestions',
    feature: KissanEventType.PROFILE_SELF_QUESTIONS,
  },
  PROFILE_SELF_ACTIVITY: {
    customEventSchemaId: KissanEventType.PROFILE_SELF_ACTIVITY,
    customEventSchemaVersion: 1,
    eventType: 'ProfileSelfActivity',
    feature: KissanEventType.PROFILE_SELF_ACTIVITY,
  },
  PROFILE_OTHERS_ALL: {
    customEventSchemaId: KissanEventType.PROFILE_OTHERS_ALL,
    customEventSchemaVersion: 1,
    eventType: 'ProfileOthersAll',
    feature: KissanEventType.PROFILE_OTHERS_ALL,
  },
  PROFILE_OTHERS_VIDEOS: {
    customEventSchemaId: KissanEventType.PROFILE_OTHERS_VIDEOS,
    customEventSchemaVersion: 1,
    eventType: 'ProfileOthersVideos',
    feature: KissanEventType.PROFILE_OTHERS_VIDEOS,
  },
  PROFILE_OTHERS_QUESTIONS: {
    customEventSchemaId: KissanEventType.PROFILE_OTHERS_QUESTIONS,
    customEventSchemaVersion: 1,
    eventType: 'ProfileOthersQuestions',
    feature: KissanEventType.PROFILE_OTHERS_QUESTIONS,
  },
  PROFILE_OTHERS_ACTIVITY: {
    customEventSchemaId: KissanEventType.PROFILE_OTHERS_ACTIVITY,
    customEventSchemaVersion: 1,
    eventType: 'ProfileOthersActivity',
    feature: KissanEventType.PROFILE_OTHERS_ACTIVITY,
  },
  PROFILE_OTHERS_ITEM_CLICK: {
    customEventSchemaId: KissanEventType.PROFILE_OTHERS_ITEM_CLICK,
    customEventSchemaVersion: 1,
    eventType: 'ProfileOthersItemClick',
    feature: KissanEventType.PROFILE_OTHERS_ITEM_CLICK,
  },
  PROFILE_CLICK_HOMEPAGE: {
    customEventSchemaId: KissanEventType.PROFILE_CLICK_HOMEPAGE,
    customEventSchemaVersion: 1,
    eventType: 'ProfileClickHomepage',
    feature: KissanEventType.PROFILE_CLICK_HOMEPAGE,
  },
  FEEDPAGE_USER_FOLLOW: {
    customEventSchemaId: KissanEventType.FEEDPAGE_USER_FOLLOW,
    customEventSchemaVersion: 1,
    eventType: 'FeedPageUserFollow',
    feature: KissanEventType.FEEDPAGE_USER_FOLLOW,
  },
  PROFILE_USER_FOLLOW: {
    customEventSchemaId: KissanEventType.PROFILE_USER_FOLLOW,
    customEventSchemaVersion: 1,
    eventType: 'ProfileUserFollow',
    feature: KissanEventType.PROFILE_USER_FOLLOW,
  },
  FOLLOWING_USER_FOLLOW: {
    customEventSchemaId: KissanEventType.FOLLOWING_USER_FOLLOW,
    customEventSchemaVersion: 1,
    eventType: 'FollowingUserFollow',
    feature: KissanEventType.FOLLOWING_USER_FOLLOW,
  },
  FOLLOWERS_USER_FOLLOW: {
    customEventSchemaId: KissanEventType.FOLLOWERS_USER_FOLLOW,
    customEventSchemaVersion: 1,
    eventType: 'FollowersUserFollow',
    feature: KissanEventType.FOLLOWERS_USER_FOLLOW,
  },
  FOLLOWING_LIST_CLICK: {
    customEventSchemaId: KissanEventType.FOLLOWING_LIST_CLICK,
    customEventSchemaVersion: 1,
    eventType: 'FollowingListClick',
    feature: KissanEventType.FOLLOWING_LIST_CLICK,
  },
  FOLLOWERS_LIST_CLICK: {
    customEventSchemaId: KissanEventType.FOLLOWERS_LIST_CLICK,
    customEventSchemaVersion: 1,
    eventType: 'FollowersListClick',
    feature: KissanEventType.FOLLOWERS_LIST_CLICK,
  },
  FOLLOW_BACK_CLICK: {
    customEventSchemaId: KissanEventType.FOLLOW_BACK_CLICK,
    customEventSchemaVersion: 1,
    eventType: 'FollowBackClick',
    feature: KissanEventType.FOLLOW_BACK_CLICK,
  },
  USER_UNFOLLOW_CLICK: {
    customEventSchemaId: KissanEventType.USER_UNFOLLOW_CLICK,
    customEventSchemaVersion: 1,
    eventType: 'UserUnfollowClick',
    feature: KissanEventType.USER_UNFOLLOW_CLICK,
  },
  FOLLOW_BOTTOMSHEET_OPEN: {
    customEventSchemaId: KissanEventType.FOLLOW_BOTTOMSHEET_OPEN,
    customEventSchemaVersion: 1,
    eventType: 'FollowBottomSheetOpen',
    feature: KissanEventType.FOLLOW_BOTTOMSHEET_OPEN,
  },
  ADS_LOADED: {
    customEventSchemaId: KissanEventType.ADS_LOADED,
    customEventSchemaVersion: 1,
    eventType: 'AdsLoaded',
    feature: KissanEventType.ADS_LOADED,
  },
  ADS_PAUSED: {
    customEventSchemaId: KissanEventType.ADS_PAUSED,
    customEventSchemaVersion: 1,
    eventType: 'AdsPaused',
    feature: KissanEventType.ADS_PAUSED,
  },
  ADS_FIRST_QUARTILE: {
    customEventSchemaId: KissanEventType.ADS_FIRST_QUARTILE,
    customEventSchemaVersion: 1,
    eventType: 'AdsFirstQuartile',
    feature: KissanEventType.ADS_FIRST_QUARTILE,
  },
  ADS_MIDPOINT: {
    customEventSchemaId: KissanEventType.ADS_MIDPOINT,
    customEventSchemaVersion: 1,
    eventType: 'AdsMidpoint',
    feature: KissanEventType.ADS_MIDPOINT,
  },
  ADS_THIRD_QUARTILE: {
    customEventSchemaId: KissanEventType.ADS_THIRD_QUARTILE,
    customEventSchemaVersion: 1,
    eventType: 'AdsThirdQuartile',
    feature: KissanEventType.ADS_THIRD_QUARTILE,
  },
  VIDEO_CONTENT_PAUSE_REQUESTED: {
    customEventSchemaId: KissanEventType.VIDEO_CONTENT_PAUSE_REQUESTED,
    customEventSchemaVersion: 1,
    eventType: 'VideoContentPauseRequested',
    feature: KissanEventType.VIDEO_CONTENT_PAUSE_REQUESTED,
  },
  VIDEO_CONTENT_RESUME_REQUESTED: {
    customEventSchemaId: KissanEventType.VIDEO_CONTENT_RESUME_REQUESTED,
    customEventSchemaVersion: 1,
    eventType: 'VideoContentResumeRequested',
    feature: KissanEventType.VIDEO_CONTENT_RESUME_REQUESTED,
  },
  ADS_SKIPPED: {
    customEventSchemaId: KissanEventType.ADS_SKIPPED,
    customEventSchemaVersion: 1,
    eventType: 'AdsSkipped',
    feature: KissanEventType.ADS_SKIPPED,
  },
  ADS_PROGRESS: {
    customEventSchemaId: KissanEventType.ADS_PROGRESS,
    customEventSchemaVersion: 1,
    eventType: 'AdsProgress',
    feature: KissanEventType.ADS_PROGRESS,
  },
  ALL_ADS_COMPLETED: {
    customEventSchemaId: KissanEventType.ALL_ADS_COMPLETED,
    customEventSchemaVersion: 1,
    eventType: 'AllAdsCompleted',
    feature: KissanEventType.ALL_ADS_COMPLETED,
  },
  FEED_LOGIN_CLICK: {
    customEventSchemaId: KissanEventType.FEED_LOGIN_CLICK,
    customEventSchemaVersion: 1,
    eventType: 'FeedLoginClick',
    feature: KissanEventType.FEED_LOGIN_CLICK,
  },
  FEED_LANG_INPUT: {
    customEventSchemaId: KissanEventType.FEED_LANG_INPUT,
    customEventSchemaVersion: 1,
    eventType: 'FeedLangInput',
    feature: KissanEventType.LANGUAGE,
    comment: KissanEventType.FEED_USER_CLICKS_ON_THE_PREFERRED_LANGUAGE,
  },
  FEED_LANG_INPUT_SUCCESS: {
    customEventSchemaId: KissanEventType.FEED_LANG_INPUT_SUCCESS,
    customEventSchemaVersion: 1,
    eventType: 'LangInputSuccess',
    feature: KissanEventType.LANGUAGE,
    comment: KissanEventType.FEED_LANGUAGE_SELECTED_CORRECTLY,
  },
  PROFILE_CLICK_QNA: {
    customEventSchemaId: KissanEventType.PROFILE_CLICK_QNA,
    customEventSchemaVersion: 1,
    eventType: 'ProfileClickQna',
    feature: KissanEventType.PROFILE_CLICK_QNA,
  },
  AUTO_VIDEO_PLAY_VIDEO_PROGRESS: {
    customEventSchemaId: KissanEventType.AUTO_VIDEO_PLAY_VIDEO_PROGRESS,
    customEventSchemaVersion: 1,
    eventType: 'AutoVideoPlayVideoProgess',
    comment: KissanEventType.AUTO_VIDEO_PLAY_VIDEO_PROGRESS,
  },
  AUTO_VIDEO_PLAY_VIDEO_PROGRESS_ONE: {
    customEventSchemaId: KissanEventType.AUTO_VIDEO_PLAY_VIDEO_PROGRESS_ONE,
    customEventSchemaVersion: 1,
    eventType: 'AutoVideoPlayVideoProgessOne',
    comment: KissanEventType.AUTO_VIDEO_PLAY_VIDEO_PROGRESS_ONE,
  },

  QNA_USER_FOLLOW: {
    customEventSchemaId: KissanEventType.QNA_USER_FOLLOW,
    customEventSchemaVersion: 1,
    eventType: 'QnaUserFollow',
    feature: KissanEventType.QNA_USER_FOLLOW,
  },

  QNA_USER_UNFOLLOW: {
    customEventSchemaId: KissanEventType.QNA_USER_UNFOLLOW,
    customEventSchemaVersion: 1,
    eventType: 'QnaUserUnfollow',
    feature: KissanEventType.QNA_USER_UNFOLLOW,
  },

  FEEDPAGE_USER_UNFOLLOW: {
    customEventSchemaId: KissanEventType.FEEDPAGE_USER_UNFOLLOW,
    customEventSchemaVersion: 1,
    eventType: 'FeedPageUserUnollow',
    feature: KissanEventType.FEEDPAGE_USER_UNFOLLOW,
  },
  QNA_SEARCH_QUESTIONSELECT: {
    customEventSchemaId: KissanEventType.QNA_SEARCH_QUESTIONSELECT,
    customEventSchemaVersion: 1,
    eventType: 'QnasearchQuestionSelect',
    feature: KissanEventType.QNA_SEARCH_QUESTIONSELECT,
  },
  QNA_SEARCH_NORESULT: {
    customEventSchemaId: KissanEventType.QNA_SEARCH_NORESULT,
    customEventSchemaVersion: 1,
    eventType: 'QnasearchNoResult',
    feature: KissanEventType.QNA_SEARCH_NORESULT,
  },
  QNA_SEARCH_SUGGESTION_CLICK: {
    customEventSchemaId: KissanEventType.QNA_SEARCH_SUGGESTION_CLICK,
    customEventSchemaVersion: 1,
    eventType: 'QnasearcSuggestionClick',
    feature: KissanEventType.QNA_SEARCH_SUGGESTION_CLICK,
  },
  QNA_SEARCH_WORD: {
    customEventSchemaId: KissanEventType.QNA_SEARCH_WORD,
    customEventSchemaVersion: 1,
    eventType: 'QnaSearchWord',
    comment: KissanEventType.QNA_SEARCH_WORD,
  },
  SHORTS_AD_LOADED: {
    customEventSchemaId: KissanEventType.SHORTS_AD_LOADED,
    customEventSchemaVersion: 1,
    eventType: 'ShortsAdLoaded',
    feature: KissanEventType.SHORTS_AD_LOADED,
  },
  SHORTS_AD_CLICKED: {
    customEventSchemaId: KissanEventType.SHORTS_AD_CLICKED,
    customEventSchemaVersion: 1,
    eventType: 'ShortsAdClicked',
    feature: KissanEventType.SHORTS_AD_CLICKED,
  },
  SHORTS_AD_CLOSED: {
    customEventSchemaId: KissanEventType.SHORTS_AD_CLOSED,
    customEventSchemaVersion: 1,
    eventType: 'ShortsAdClosed',
    feature: KissanEventType.SHORTS_AD_CLOSED,
  },
  SHORTS_AD_ERROR: {
    customEventSchemaId: KissanEventType.SHORTS_AD_ERROR,
    customEventSchemaVersion: 1,
    eventType: 'ShortsAdError',
    feature: KissanEventType.SHORTS_AD_ERROR,
  },
  QNA_SEARCH_TYPE: {
    customEventSchemaId: KissanEventType.QNA_SEARCH_TYPE,
    customEventSchemaVersion: 1,
    eventType: 'QnaSearchType',
    comment: KissanEventType.QNA_SEARCH_TYPE,
  },
  QNA_SUGGESTION_CLICK: {
    customEventSchemaId: KissanEventType.QNA_SUGGESTION_CLICK,
    customEventSchemaVersion: 1,
    eventType: 'QnaSuggestionClick',
    comment: KissanEventType.QNA_SUGGESTION_CLICK,
  },
  QNA_ASK_CLICK: {
    customEventSchemaId: KissanEventType.QNA_ASK_CLICK,
    customEventSchemaVersion: 1,
    eventType: 'QnaAskClick',
    comment: KissanEventType.QNA_ASK_CLICK,
  },
  QNA_CONTINUEASK_CLICK: {
    customEventSchemaId: KissanEventType.QNA_CONTINUEASK_CLICK,
    customEventSchemaVersion: 1,
    eventType: 'QnaContinueAskClick',
    comment: KissanEventType.QNA_CONTINUEASK_CLICK,
  },

  FEED_USER_ANIMALSELECT: {
    customEventSchemaId: KissanEventType.FEED_USER_ANIMALSELECT,
    customEventSchemaVersion: 1,
    eventType: 'FeedUserAnimalSelect',
    feature: KissanEventType.FEED_USER_ANIMALSELECT,
  },

  PROFILE_USER_ANIMALSELECT: {
    customEventSchemaId: KissanEventType.PROFILE_USER_ANIMALSELECT,
    customEventSchemaVersion: 1,
    eventType: 'ProfileUserAnimalSelect',
    feature: KissanEventType.PROFILE_USER_ANIMALSELECT,
  },

  ANIMAL_REMOVE: {
    customEventSchemaId: KissanEventType.ANIMAL_REMOVE,
    customEventSchemaVersion: 1,
    eventType: 'AnimalRemove',
    feature: KissanEventType.ANIMAL_REMOVE,
  },

  ANIMAL_ADDED: {
    customEventSchemaId: KissanEventType.ANIMAL_ADDED,
    customEventSchemaVersion: 1,
    eventType: 'AnimalAdded',
    feature: KissanEventType.ANIMAL_ADDED,
  },
  FEEDPAGE_DIS_CONTINUWATCH_CLICKED: {
    customEventSchemaId: KissanEventType.FEEDPAGE_DIS_CONTINUWATCH_CLICKED,
    customEventSchemaVersion: 1,
    eventType: 'FeedPageDisContinuwatchClicked',
    comment: KissanEventType.FEEDPAGE_DIS_CONTINUWATCH_CLICKED,
  },
  FEEDPAGE_DIS_VIDEO_CLICKED: {
    customEventSchemaId: KissanEventType.FEEDPAGE_DIS_VIDEO_CLICKED,
    customEventSchemaVersion: 1,
    eventType: 'FeedPageDisVideoClicked',
    comment: KissanEventType.FEEDPAGE_DIS_VIDEO_CLICKED,
  },
  FEEDPAGE_DIS_PAGESCROLL_HORIZONTAL_TRENDING: {
    customEventSchemaId: KissanEventType.FEEDPAGE_DIS_PAGESCROLL_HORIZONTAL_TRENDING,
    customEventSchemaVersion: 1,
    eventType: 'FeedPageDisPagescrollHorizontalTrending',
    comment: KissanEventType.FEEDPAGE_DIS_PAGESCROLL_HORIZONTAL_TRENDING,
  },
  FEEDPAGE_DIS_PAGESCROLL_HORIZONTAL_CONTINUEWATCHING: {
    customEventSchemaId: KissanEventType.FEEDPAGE_DIS_PAGESCROLL_HORIZONTAL_CONTINUEWATCHING,
    customEventSchemaVersion: 1,
    eventType: 'FeedPageDisPagescrollHorizontalContinuewatch',
    comment: KissanEventType.FEEDPAGE_DIS_PAGESCROLL_HORIZONTAL_CONTINUEWATCHING,
  },
  FEEDPAGE_DIS_CLICKON_VIDEOCATEGORY: {
    customEventSchemaId: KissanEventType.FEEDPAGE_DIS_CLICKON_VIDEOCATEGORY,
    customEventSchemaVersion: 1,
    eventType: 'FeedPageDisClickonVideocategory',
    comment: KissanEventType.FEEDPAGE_DIS_CLICKON_VIDEOCATEGORY,
  },
  FEEDPAGE_DIS_PAGESCROLL_HORIZONTAL_VIDEOSONCROPS: {
    customEventSchemaId: KissanEventType.FEEDPAGE_DIS_PAGESCROLL_HORIZONTAL_VIDEOSONCROPS,
    customEventSchemaVersion: 1,
    eventType: 'FeedPageDisPagescrollHorizontalVideosonCrops',
    comment: KissanEventType.FEEDPAGE_DIS_PAGESCROLL_HORIZONTAL_VIDEOSONCROPS,
  },
  FEEDPAGE_DIS_PAGESCROLL_HORIZONTAL_MACHINERY: {
    customEventSchemaId: KissanEventType.FEEDPAGE_DIS_PAGESCROLL_HORIZONTAL_MACHINERY,
    customEventSchemaVersion: 1,
    eventType: 'FeedPageDisPagescrollHorizontalMachinery',
    comment: KissanEventType.FEEDPAGE_DIS_PAGESCROLL_HORIZONTAL_MACHINERY,
  },
  FEEDPAGE_DIS_PAGESCROLL_HORIZONTAL_GOVT_SCHEME: {
    customEventSchemaId: KissanEventType.FEEDPAGE_DIS_PAGESCROLL_HORIZONTAL_GOVT_SCHEME,
    customEventSchemaVersion: 1,
    eventType: 'FeedPageDisPagescrollHorizontalGovtScheme',
    comment: KissanEventType.FEEDPAGE_DIS_PAGESCROLL_HORIZONTAL_GOVT_SCHEME,
  },
  FEEDPAGE_DIS_PAGESCROLL_HORIZONTAL_ANIMALS: {
    customEventSchemaId: KissanEventType.FEEDPAGE_DIS_PAGESCROLL_HORIZONTAL_ANIMALS,
    customEventSchemaVersion: 1,
    eventType: 'FeedPageDisPagescrollHorizontalAnimals',
    comment: KissanEventType.FEEDPAGE_DIS_PAGESCROLL_HORIZONTAL_ANIMALS,
  },
  FEEDPAGE_DIS_CLICKON_VIDEOMACHINERY: {
    customEventSchemaId: KissanEventType.FEEDPAGE_DIS_CLICKON_VIDEOMACHINERY,
    customEventSchemaVersion: 1,
    eventType: 'FeedPageDisClickonVideoMachinery',
    comment: KissanEventType.FEEDPAGE_DIS_CLICKON_VIDEOMACHINERY,
  },
  FEEDPAGE_DIS_CLICKON_VIDEOGOVTSCEME: {
    customEventSchemaId: KissanEventType.FEEDPAGE_DIS_CLICKON_VIDEOGOVTSCEME,
    customEventSchemaVersion: 1,
    eventType: 'FeedPageDisClickonVideoGovtScehme',
    comment: KissanEventType.FEEDPAGE_DIS_CLICKON_VIDEOGOVTSCEME,
  },
  FEEDPAGE_DIS_CLICKON_VIDEOCATTLE: {
    customEventSchemaId: KissanEventType.FEEDPAGE_DIS_CLICKON_VIDEOCATTLE,
    customEventSchemaVersion: 1,
    eventType: 'FeedPageDisClickonVideoCattle',
    comment: KissanEventType.FEEDPAGE_DIS_CLICKON_VIDEOCATTLE,
  },
  AUTO_PLAY_VIDEO_PROGRESS_THIRTY_SECONDS: {
    customEventSchemaId: KissanEventType.AUTO_PLAY_VIDEO_PROGRESS_THIRTY_SECONDS,
    customEventSchemaVersion: 1,
    eventType: 'AutoPlayVideoProgressThirtySeconds',
    feature: KissanEventType.AUTO_PLAY_VIDEO_PROGRESS_THIRTY_SECONDS,
  },
  VIDEO_VIEWED_LESS_THAN_FIVE_SECONDS: {
    customEventSchemaId: KissanEventType.VIDEO_VIEWED_LESS_THAN_FIVE_SECONDS,
    customEventSchemaVersion: 1,
    eventType: 'VideoViewdLessThanFiveSeconds',
    feature: KissanEventType.VIDEO_VIEWED_LESS_THAN_FIVE_SECONDS,
  },
  AUTO_PLAY_VIDEO_PROGRESS_TWENTY_SECONDS: {
    customEventSchemaId: KissanEventType.AUTO_PLAY_VIDEO_PROGRESS_TWENTY_SECONDS,
    customEventSchemaVersion: 1,
    eventType: 'AutoPlayVideoProgressTwentySeconds',
    feature: KissanEventType.AUTO_PLAY_VIDEO_PROGRESS_TWENTY_SECONDS,
  },
  SEARCH_RESULT_POSTITEM_CLICK: {
    customEventSchemaId: KissanEventType.SEARCH_RESULT_POSTITEM_CLICK,
    customEventSchemaVersion: 1,
    eventType: 'SearchResultPostItemClick',
    feature: KissanEventType.SEARCH_RESULT_POSTITEM_CLICK,
  },
  SEARCH_RESULT_QNAITEM_CLICK: {
    customEventSchemaId: KissanEventType.SEARCH_RESULT_QNAITEM_CLICK,
    customEventSchemaVersion: 1,
    eventType: 'SearchResultQnaItemClick',
    feature: KissanEventType.SEARCH_RESULT_QNAITEM_CLICK,
  },
  SEARCH_RESULT_VIDEOITEM_CLICK: {
    customEventSchemaId: KissanEventType.SEARCH_RESULT_VIDEOITEM_CLICK,
    customEventSchemaVersion: 1,
    eventType: 'SearchResultVideoItemClick',
    feature: KissanEventType.SEARCH_RESULT_VIDEOITEM_CLICK,
  },
  NO_AUTO_SUGGESTION_FOUND: {
    customEventSchemaId: KissanEventType.NO_AUTO_SUGGESTION_FOUND,
    customEventSchemaVersion: 1,
    eventType: 'NoAutoSuggestionFound',
    feature: KissanEventType.NO_AUTO_SUGGESTION_FOUND,
  },
  TOURGUIDE_LAUNCH_SUCCESSFUL_FEEDUSERFOLLOW: {
    customEventSchemaId: KissanEventType.TOURGUIDE_LAUNCH_SUCCESSFUL_FEEDUSERFOLLOW,
    customEventSchemaVersion: 1,
    eventType: 'TourGuideLaunchSuccessfulFeedUserFollow',
    comment: KissanEventType.TOURGUIDE_LAUNCH_SUCCESSFUL_FEEDUSERFOLLOW,
  },
  ANSWER_RECEIVED_BOTTOMSHEET_DISPLAY: {
    customEventSchemaId: KissanEventType.ANSWER_RECEIVED_BOTTOMSHEET_DISPLAY,
    customEventSchemaVersion: 1,
    eventType: 'AnswerReceivedBottomSheetDisplay',
    comment: KissanEventType.ANSWER_RECEIVED_BOTTOMSHEET_DISPLAY,
  },
  ANSWER_RECEIVED_BOTTOMSHEET_CANCEL: {
    customEventSchemaId: KissanEventType.ANSWER_RECEIVED_BOTTOMSHEET_CANCEL,
    customEventSchemaVersion: 1,
    eventType: 'AnswerReceivedBottomSheetCancel',
    comment: KissanEventType.ANSWER_RECEIVED_BOTTOMSHEET_CANCEL,
  },
  ANSWER_RECEIVED_BOTTOMSHEET_VIEWANSWER: {
    customEventSchemaId: KissanEventType.ANSWER_RECEIVED_BOTTOMSHEET_VIEWANSWER,
    customEventSchemaVersion: 1,
    eventType: 'AnswerReceivedBottomSheetViewAnswer',
    comment: KissanEventType.ANSWER_RECEIVED_BOTTOMSHEET_VIEWANSWER,
  },
  ANSWER_RECEIVED_STICKYBANNER_DISPLAY: {
    customEventSchemaId: KissanEventType.ANSWER_RECEIVED_STICKYBANNER_DISPLAY,
    customEventSchemaVersion: 1,
    eventType: 'AnswerReceivedStickyBannerDisplay',
    comment: KissanEventType.ANSWER_RECEIVED_STICKYBANNER_DISPLAY,
  },
  ANSWER_RECEIVED_STICKYBANNER_VIEWANSWER: {
    customEventSchemaId: KissanEventType.ANSWER_RECEIVED_STICKYBANNER_VIEWANSWER,
    customEventSchemaVersion: 1,
    eventType: 'AnswerReceivedStickyBannerViewAnswer',
    comment: KissanEventType.ANSWER_RECEIVED_STICKYBANNER_VIEWANSWER,
  },
  FULLSCREEN_AUTO_LOAD: {
    customEventSchemaId: KissanEventType.FULLSCREEN_AUTO_LOAD,
    customEventSchemaVersion: 1,
    eventType: 'FullScreenAutoLoad',
    comment: KissanEventType.FULLSCREEN_AUTO_LOAD,
  },
  FULLSCREEN_BUTTON_CLICKED: {
    customEventSchemaId: KissanEventType.FULLSCREEN_BUTTON_CLICKED,
    customEventSchemaVersion: 1,
    eventType: 'FullScreenbuttonclicked',
    comment: KissanEventType.FULLSCREEN_BUTTON_CLICKED,
  },

  ASPECTRATIO_CLICKED: {
    customEventSchemaId: KissanEventType.ASPECTRATIO_CLICKED,
    customEventSchemaVersion: 1,
    eventType: 'AspectRatioClicked',
    comment: KissanEventType.ASPECTRATIO_CLICKED,
  },
  RECOMMENDED_VIDEO_SCROLL: {
    customEventSchemaId: KissanEventType.RECOMMENDED_VIDEO_SCROLL,
    customEventSchemaVersion: 1,
    eventType: 'RecommendedVideoScroll',
    comment: KissanEventType.RECOMMENDED_VIDEO_SCROLL,
  },
  TRANSCODING_ERROR: {
    customEventSchemaId: KissanEventType.TRANSCODING_ERROR,
    customEventSchemaVersion: 1,
    eventType: 'TranscodingError',
    comment: KissanEventType.TRANSCODING_ERROR,
  },
  RETURNING_USER: {
    customEventSchemaId: KissanEventType.RETURNING_USER,
    customEventSchemaVersion: 1,
    eventType: 'ReturningUser',
    comment: KissanEventType.RETURNING_USER,
  },
  FOLLOW_QNA_PAGE: {
    customEventSchemaId: KissanEventType.FOLLOW_QNA_PAGE,
    customEventSchemaVersion: 1,
    eventType: 'FollowQnaPage',
    comment: KissanEventType.FOLLOW_QNA_PAGE,
  },

  FOLLOW_SHORTS_PAGE: {
    customEventSchemaId: KissanEventType.FOLLOW_SHORTS_PAGE,
    customEventSchemaVersion: 1,
    eventType: 'FollowShortsPage',
    comment: KissanEventType.FOLLOW_SHORTS_PAGE,
  },

  FOLLOW_FEEDVIDEO: {
    customEventSchemaId: KissanEventType.FOLLOW_FEEDVIDEO,
    customEventSchemaVersion: 1,
    eventType: 'FollowFeedVideo',
    comment: KissanEventType.FOLLOW_FEEDVIDEO,
  },

  BOTTOMNAV_PRODUCTS_CLICKED: {
    customEventSchemaId: KissanEventType.BOTTOMNAV_PRODUCTS_CLICKED,
    customEventSchemaVersion: 1,
    eventType: 'BottomNavProductsClicked',
    feature: KissanEventType.BOTTOMNAV_PRODUCTS_CLICKED,
  },
  PRODUCT_VIEWALL_CLICK: {
    customEventSchemaId: KissanEventType.PRODUCT_VIEWALL_CLICK,
    customEventSchemaVersion: 1,
    eventType: 'ProductViewAllClick',
    comment: KissanEventType.PRODUCT_VIEWALL_CLICK,
  },
  PRODUCT_PAGE_SCROLL: {
    customEventSchemaId: KissanEventType.PRODUCT_PAGE_SCROLL,
    customEventSchemaVersion: 1,
    eventType: 'ProductPageScroll',
    comment: KissanEventType.PRODUCT_PAGE_SCROLL,
  },
  PRODUCT_CLICK: {
    customEventSchemaId: KissanEventType.PRODUCT_CLICK,
    customEventSchemaVersion: 1,
    eventType: 'ProductClick',
    comment: KissanEventType.PRODUCT_CLICK,
  },
  VIEW_PRODUCT_CLICK: {
    customEventSchemaId: KissanEventType.VIEW_PRODUCT_CLICK,
    customEventSchemaVersion: 1,
    eventType: 'ViewProductClick',
    comment: KissanEventType.VIEW_PRODUCT_CLICK,
  },
  PRODUCT_PAGEOPEN_SUCCESS: {
    customEventSchemaId: KissanEventType.PRODUCT_PAGEOPEN_SUCCESS,
    customEventSchemaVersion: 1,
    eventType: 'ProductPageOpenSuccess',
    comment: KissanEventType.PRODUCT_PAGEOPEN_SUCCESS,
  },
  PRODUCT_CATEGORY_CLICK: {
    customEventSchemaId: KissanEventType.PRODUCT_CATEGORY_CLICK,
    customEventSchemaVersion: 1,
    eventType: 'ProductCategoryClick',
    comment: KissanEventType.PRODUCT_CATEGORY_CLICK,
  },
  PRODUCT_SUBCATEGORY_CLICK: {
    customEventSchemaId: KissanEventType.PRODUCT_SUBCATEGORY_CLICK,
    customEventSchemaVersion: 1,
    eventType: 'ProductSubcategoryClick',
    comment: KissanEventType.PRODUCT_SUBCATEGORY_CLICK,
  },
  HORIZONATAL_SCROLL_IMPRESSIONS: {
    customEventSchemaId: KissanEventType.HORIZONATAL_SCROLL_IMPRESSIONS,
    customEventSchemaVersion: 1,
    eventType: 'HorizontalScrollImpressions',
    comment: KissanEventType.HORIZONATAL_SCROLL_IMPRESSIONS,
  },
  IM_INTERESTED_CLICK: {
    customEventSchemaId: KissanEventType.IM_INTERESTED_CLICK,
    customEventSchemaVersion: 1,
    eventType: 'ImInterestedClick',
    comment: KissanEventType.IM_INTERESTED_CLICK,
  },

  PRODUCT_VARIANT_CHANGE: {
    customEventSchemaId: KissanEventType.PRODUCT_VARIANT_CHANGE,
    customEventSchemaVersion: 1,
    eventType: 'ProductVariantChange',
    comment: KissanEventType.PRODUCT_VARIANT_CHANGE,
  },

  MACHINERY_PAGEOPEN_SUCCESS: {
    customEventSchemaId: KissanEventType.MACHINERY_PAGEOPEN_SUCCESS,
    customEventSchemaVersion: 1,
    eventType: 'MachineryPageOpenSuccess',
    comment: KissanEventType.MACHINERY_PAGEOPEN_SUCCESS,
  },

  CHEMICALS_PAGEOPEN_SUCCESS: {
    customEventSchemaId: KissanEventType.CHEMICALS_PAGEOPEN_SUCCESS,
    customEventSchemaVersion: 1,
    eventType: 'ChemicalsPageOpenSuccess',
    comment: KissanEventType.CHEMICALS_PAGEOPEN_SUCCESS,
  },

  COURSES_PAGEOPEN_SUCCESS: {
    customEventSchemaId: KissanEventType.COURSES_PAGEOPEN_SUCCESS,
    customEventSchemaVersion: 1,
    eventType: 'CoursesPageOpenSuccess',
    comment: KissanEventType.COURSES_PAGEOPEN_SUCCESS,
  },

  PRODUCT_MYORDERS_CLICK: {
    customEventSchemaId: KissanEventType.PRODUCT_MYORDERS_CLICK,
    customEventSchemaVersion: 1,
    eventType: 'ProductMyOrdersClick',
    comment: KissanEventType.PRODUCT_MYORDERS_CLICK,
  },

  MYORDERS_PAGEOPEN_SUCCESS: {
    customEventSchemaId: KissanEventType.MYORDERS_PAGEOPEN_SUCCESS,
    customEventSchemaVersion: 1,
    eventType: 'MyordersPageOpenSuccess',
    comment: KissanEventType.MYORDERS_PAGEOPEN_SUCCESS,
  },

  COURSES_LEARNING_CLICK: {
    customEventSchemaId: KissanEventType.COURSES_LEARNING_CLICK,
    customEventSchemaVersion: 1,
    eventType: 'CoursesLearningClick',
    comment: KissanEventType.COURSES_LEARNING_CLICK,
  },

  PRODUCT_SHARE_CLICK: {
    customEventSchemaId: KissanEventType.PRODUCT_SHARE_CLICK,
    customEventSchemaVersion: 1,
    eventType: 'ProductShareClick',
    comment: KissanEventType.PRODUCT_SHARE_CLICK,
  },

  VIEW_ALL_INSTRUCTORS: {
    customEventSchemaId: KissanEventType.VIEW_ALL_INSTRUCTORS,
    customEventSchemaVersion: 1,
    eventType: 'ViewAllInstructors',
    comment: KissanEventType.VIEW_ALL_INSTRUCTORS,
  },

  PRODUCT_SUBCATEGORY_PAGEOPEN_SUCCESS: {
    customEventSchemaId: KissanEventType.PRODUCT_SUBCATEGORY_PAGEOPEN_SUCCESS,
    customEventSchemaVersion: 1,
    eventType: 'ProductSubcategoryPageOpenSuccess',
    comment: KissanEventType.PRODUCT_SUBCATEGORY_PAGEOPEN_SUCCESS,
  },

  AUTOPLAY_VIDEO_EXPAND: {
    customEventSchemaId: KissanEventType.AUTOPLAY_VIDEO_EXPAND,
    customEventSchemaVersion: 1,
    eventType: 'autoPlayVideoExpand',
    comment: KissanEventType.AUTOPLAY_VIDEO_EXPAND,
  },
  AUTOPLAY_VIDEO_SHORTEN: {
    customEventSchemaId: KissanEventType.AUTOPLAY_VIDEO_SHORTEN,
    customEventSchemaVersion: 1,
    eventType: 'autoPlayVideoShorten',
    comment: KissanEventType.AUTOPLAY_VIDEO_SHORTEN,
  },

  COMMENT_THREADS_API_ERROR: {
    customEventSchemaId: KissanEventType.COMMENT_THREADS_API_ERROR,
    customEventSchemaVersion: 1,
    eventType: 'commentThreadsApiError',
    comment: KissanEventType.COMMENT_THREADS_API_ERROR,
  },
  AUTOPLAY_VIDEO_STATIC_BANNER_LOADED: {
    customEventSchemaId: KissanEventType.AUTOPLAY_VIDEO_STATIC_BANNER_LOADED,
    customEventSchemaVersion: 1,
    eventType: 'AutoPlayVideoStaticBannerLoaded',
    comment: KissanEventType.AUTOPLAY_VIDEO_STATIC_BANNER_LOADED,
  },
  AUTOPLAY_VIDEO_STATIC_BANNER_DISMISS: {
    customEventSchemaId: KissanEventType.AUTOPLAY_VIDEO_STATIC_BANNER_DISMISS,
    customEventSchemaVersion: 1,
    eventType: 'AutoPlayVideoStaticBannerDismiss',
    comment: KissanEventType.AUTOPLAY_VIDEO_STATIC_BANNER_DISMISS,
  },
  AUTOPLAY_VIDEO_STATIC_BANNER_OPENED: {
    customEventSchemaId: KissanEventType.AUTOPLAY_VIDEO_STATIC_BANNER_OPENED,
    customEventSchemaVersion: 1,
    eventType: 'AutoPlayVideoStaticBannerOpened',
    comment: KissanEventType.AUTOPLAY_VIDEO_STATIC_BANNER_OPENED,
  },
  PRODUCT_CART_CLICK: {
    customEventSchemaId: KissanEventType.PRODUCT_CART_CLICK,
    customEventSchemaVersion: 1,
    eventType: 'productCartClick',
    comment: KissanEventType.PRODUCT_CART_CLICK,
  },
  CART_PAGEOPEN_SUCCESS: {
    customEventSchemaId: KissanEventType.CART_PAGEOPEN_SUCCESS,
    customEventSchemaVersion: 1,
    eventType: 'cartPageOpenSuccess',
    comment: KissanEventType.CART_PAGEOPEN_SUCCESS,
  },
  PAY_NOW_CLICK: {
    customEventSchemaId: KissanEventType.PAY_NOW_CLICK,
    customEventSchemaVersion: 1,
    eventType: 'payNowClick',
    comment: KissanEventType.PAY_NOW_CLICK,
  },
  BUY_NOW_CLICK: {
    customEventSchemaId: KissanEventType.BUY_NOW_CLICK,
    customEventSchemaVersion: 1,
    eventType: 'buyNowClick',
    comment: KissanEventType.BUY_NOW_CLICK,
  },
  ADD_TO_CART: {
    customEventSchemaId: KissanEventType.ADD_TO_CART,
    customEventSchemaVersion: 1,
    eventType: 'addToCart',
    comment: KissanEventType.ADD_TO_CART,
  },
  PAYMENT_REDIRECTION_OPEN: {
    customEventSchemaId: KissanEventType.PAYMENT_REDIRECTION_OPEN,
    customEventSchemaVersion: 1,
    eventType: 'paymentRedirectionOpen',
    comment: KissanEventType.PAYMENT_REDIRECTION_OPEN,
  },
  PAYMENT_SUCCESS: {
    customEventSchemaId: KissanEventType.PAYMENT_SUCCESS,
    customEventSchemaVersion: 1,
    eventType: 'paymentSuccess',
    comment: KissanEventType.PAYMENT_SUCCESS,
  },
  PAYMENT_FAILED: {
    customEventSchemaId: KissanEventType.PAYMENT_FAILED,
    customEventSchemaVersion: 1,
    eventType: 'paymentFailed',
    comment: KissanEventType.PAYMENT_FAILED,
  },
  RAZORPAY_PRELOAD_FAILED: {
    customEventSchemaId: KissanEventType.RAZORPAY_PRELOAD_FAILED,
    customEventSchemaVersion: 1,
    eventType: 'RazorpayPreloadFailed',
    feature: KissanEventType.PAYMENT_FAILED,
    comment: KissanEventType.RAZORPAY_PRELOAD_FAILED,
  },
  SPEAKONMIC_CLICK: {
    customEventSchemaId: KissanEventType.SPEAKONMIC_CLICK,
    customEventSchemaVersion: 1,
    eventType: 'SpeakOnMicClick',
    comment: KissanEventType.SPEAKONMIC_CLICK,
  },
  SPEAKONMIC_BOTTOMSHEET_DISPLAY: {
    customEventSchemaId: KissanEventType.SPEAKONMIC_BOTTOMSHEET_DISPLAY,
    customEventSchemaVersion: 1,
    eventType: 'SpeakOnMicBottomSheetDisplay',
    comment: KissanEventType.SPEAKONMIC_BOTTOMSHEET_DISPLAY,
  },
  MIC_STARTRECORDING_CLICK: {
    customEventSchemaId: KissanEventType.MIC_STARTRECORDING_CLICK,
    customEventSchemaVersion: 1,
    eventType: 'MicStartRecordingClick',
    comment: KissanEventType.MIC_STARTRECORDING_CLICK,
  },
  MIC_STOPRECORDING_CLICK: {
    customEventSchemaId: KissanEventType.MIC_STOPRECORDING_CLICK,
    customEventSchemaVersion: 1,
    eventType: 'MicStopRecordingClick',
    comment: KissanEventType.MIC_STOPRECORDING_CLICK,
  },
  SPEAKONMIC_BOTTOMSHEET_CROSS: {
    customEventSchemaId: KissanEventType.SPEAKONMIC_BOTTOMSHEET_CROSS,
    customEventSchemaVersion: 1,
    eventType: 'SpeakOnMicBottomSheetCross',
    comment: KissanEventType.SPEAKONMIC_BOTTOMSHEET_CROSS,
  },
  MIC_TRYAGAIN: {
    customEventSchemaId: KissanEventType.MIC_TRYAGAIN,
    customEventSchemaVersion: 1,
    eventType: 'MicTryAgain',
    comment: KissanEventType.MIC_TRYAGAIN,
  },
  MIC_DONETALKING: {
    customEventSchemaId: KissanEventType.MIC_DONETALKING,
    customEventSchemaVersion: 1,
    eventType: 'MicDoneTalking',
    comment: KissanEventType.MIC_DONETALKING,
  },
  MIC_SUBMIT: {
    customEventSchemaId: KissanEventType.MIC_SUBMIT,
    customEventSchemaVersion: 1,
    eventType: 'MicSubmit',
    comment: KissanEventType.MIC_SUBMIT,
  },
  SPEAKONMIC_ERROR_DISPLAYED: {
    customEventSchemaId: KissanEventType.SPEAKONMIC_ERROR_DISPLAYED,
    customEventSchemaVersion: 1,
    eventType: 'SpeakonmicErrorDisplayed',
    comment: KissanEventType.SPEAKONMIC_ERROR_DISPLAYED,
  },
  AUTOPLAY_SEEK_COMPLETED: {
    customEventSchemaId: KissanEventType.AUTOPLAY_SEEK_COMPLETED,
    customEventSchemaVersion: 1,
    eventType: 'AutoPlaySeekCompleted',
    comment: KissanEventType.AUTOPLAY_SEEK_COMPLETED,
  },
  AUTOPLAY_SEEK_STARTED: {
    customEventSchemaId: KissanEventType.AUTOPLAY_SEEK_STARTED,
    customEventSchemaVersion: 1,
    eventType: 'AutoPlaySeekStarted',
    comment: KissanEventType.AUTOPLAY_SEEK_STARTED,
  },
  HOMEFEED_TIMEOUT: {
    customEventSchemaId: KissanEventType.HOMEFEED_TIMEOUT,
    customEventSchemaVersion: 1,
    eventType: 'HomeFeedtimeout',
    comment: KissanEventType.HOMEFEED_TIMEOUT,
  },
  PRODUCT_LEADCAPTURE: {
    customEventSchemaId: KissanEventType.PRODUCT_LEADCAPTURE,
    customEventSchemaVersion: 1,
    eventType: 'ProductLeadCapture',
    comment: KissanEventType.PRODUCT_LEADCAPTURE,
  },
  PRODUCT_LEADCAPTURE_SUBMIT: {
    customEventSchemaId: KissanEventType.PRODUCT_LEADCAPTURE_SUBMIT,
    customEventSchemaVersion: 1,
    eventType: 'ProductLeadCaptureSubmit',
    comment: KissanEventType.PRODUCT_LEADCAPTURE_SUBMIT,
  },
  PRODUCT_LEADCAPTURE_TYPING: {
    customEventSchemaId: KissanEventType.PRODUCT_LEADCAPTURE_TYPING,
    customEventSchemaVersion: 1,
    eventType: 'ProductLeadCaptureTyping',
    comment: KissanEventType.PRODUCT_LEADCAPTURE_TYPING,
  },
  BANNER_AD_LOAD: {
    customEventSchemaId: KissanEventType.BANNER_AD_LOAD,
    customEventSchemaVersion: 1,
    eventType: 'BannerAdLoad',
    comment: KissanEventType.BANNER_AD_LOAD,
  },
  BANNER_AD_OPENED: {
    customEventSchemaId: KissanEventType.BANNER_AD_OPENED,
    customEventSchemaVersion: 1,
    eventType: 'BannerAdOpened',
    comment: KissanEventType.BANNER_AD_OPENED,
  },
  BANNER_AD_FAILED: {
    customEventSchemaId: KissanEventType.BANNER_AD_FAILED,
    customEventSchemaVersion: 1,
    eventType: 'BannerAdFailed',
    comment: KissanEventType.BANNER_AD_FAILED,
  },
  PRODUCT_SEARCH_SUGGESTION_CLICK: {
    customEventSchemaId: KissanEventType.PRODUCT_SEARCH_SUGGESTION_CLICK,
    customEventSchemaVersion: 1,
    eventType: 'ProductsearcSuggestionClick',
    feature: KissanEventType.PRODUCT_SEARCH_SUGGESTION_CLICK,
  },
  PRODUCT_SEARCH_NORESULT: {
    customEventSchemaId: KissanEventType.PRODUCT_SEARCH_NORESULT,
    customEventSchemaVersion: 1,
    eventType: 'ProductsearchNoResult',
    feature: KissanEventType.PRODUCT_SEARCH_NORESULT,
  },
  REACTION_CLICK: {
    customEventSchemaId: KissanEventType.REACTION_CLICK,
    customEventSchemaVersion: 1,
    eventType: 'ReactionClick',
    comment: KissanEventType.REACTION_CLICK,
  },
  PWA_BUTTON_CLICKED: {
    customEventSchemaId: KissanEventType.PWA_BUTTON_CLICKED,
    customEventSchemaVersion: 1,
    eventType: 'PwaButtonClicked',
    comment: KissanEventType.PWA_BUTTON_CLICKED,
  },
  PWA_INSTALL_PROMPT_ACCEPTED: {
    customEventSchemaId: KissanEventType.PWA_INSTALL_PROMPT_ACCEPTED,
    customEventSchemaVersion: 1,
    eventType: 'PwaInstallPromptAccepted',
    comment: KissanEventType.PWA_INSTALL_PROMPT_ACCEPTED,
  },
  PWA_INSTALL_PROMPT_REJECTED: {
    customEventSchemaId: KissanEventType.PWA_INSTALL_PROMPT_REJECTED,
    customEventSchemaVersion: 1,
    eventType: 'PwaInstallPromptRejected',
    comment: KissanEventType.PWA_INSTALL_PROMPT_REJECTED,
  },
  PAGE_TRY_AGAIN_CLICKED: {
    customEventSchemaId: KissanEventType.PAGE_TRY_AGAIN_CLICKED,
    customEventSchemaVersion: 1,
    eventType: 'PageTryAgainClicked',
    comment: KissanEventType.PAGE_TRY_AGAIN_CLICKED,
  },
  HOMPAGEMAIN_LOAD_INITIATED: {
    customEventSchemaId: KissanEventType.HOMPAGEMAIN_LOAD_INITIATED,
    customEventSchemaVersion: 1,
    eventType: 'HomePageMainLoadInitiated',
    comment: KissanEventType.HOMPAGEMAIN_LOAD_INITIATED,
  },
  HOMPAGEMAIN_LOAD_SUCCESS: {
    customEventSchemaId: KissanEventType.HOMPAGEMAIN_LOAD_SUCCESS,
    customEventSchemaVersion: 1,
    eventType: 'HomePageMainLoadSuccess',
    comment: KissanEventType.HOMPAGEMAIN_LOAD_SUCCESS,
  },
  HOMPAGEMAIN_LOAD_FAILED: {
    customEventSchemaId: KissanEventType.HOMPAGEMAIN_LOAD_FAILED,
    customEventSchemaVersion: 1,
    eventType: 'HomePageMainLoadFailed',
    comment: KissanEventType.HOMPAGEMAIN_LOAD_FAILED,
  },
  ACTIVE_USER_FILTER_CLICK: {
    customEventSchemaId: KissanEventType.ACTIVE_USER_FILTER_CLICK,
    customEventSchemaVersion: 1,
    eventType: 'ActiveUserFilterClick',
    comment: KissanEventType.ACTIVE_USER_FILTER_CLICK,
  },
  ACTIVE_USER_FILTER_SELECT: {
    customEventSchemaId: KissanEventType.ACTIVE_USER_FILTER_SELECT,
    customEventSchemaVersion: 1,
    eventType: 'ActiveUserFilterSelect',
    comment: KissanEventType.ACTIVE_USER_FILTER_SELECT,
  },
  DATE_FILTER_CLICK: {
    customEventSchemaId: KissanEventType.DATE_FILTER_CLICK,
    customEventSchemaVersion: 1,
    eventType: 'DateFilterClick',
    comment: KissanEventType.DATE_FILTER_CLICK,
  },
  DATE_FILTER_SELECT: {
    customEventSchemaId: KissanEventType.DATE_FILTER_SELECT,
    customEventSchemaVersion: 1,
    eventType: 'DateFilterSelect',
    comment: KissanEventType.DATE_FILTER_SELECT,
  },
  CLEAR_ALL_CLICKED: {
    customEventSchemaId: KissanEventType.CLEAR_ALL_CLICKED,
    customEventSchemaVersion: 1,
    eventType: 'ClearAllClicked',
    comment: KissanEventType.CLEAR_ALL_CLICKED,
  },
  SUBCATEGORY_SELECTED: {
    customEventSchemaId: KissanEventType.SUBCATEGORY_SELECTED,
    customEventSchemaVersion: 1,
    eventType: 'SubcategorySelected',
    comment: KissanEventType.SUBCATEGORY_SELECTED,
  },
  SUBCATEGORY_UNSELECTED: {
    customEventSchemaId: KissanEventType.SUBCATEGORY_UNSELECTED,
    customEventSchemaVersion: 1,
    eventType: 'SubcategoryUnselected',
    comment: KissanEventType.SUBCATEGORY_UNSELECTED,
  },
  DROPDOWN_CLICKED: {
    customEventSchemaId: KissanEventType.DROPDOWN_CLICKED,
    customEventSchemaVersion: 1,
    eventType: 'DropdownClicked',
    comment: KissanEventType.DROPDOWN_CLICKED,
  },
  NOTIFICATION_POPUP_OPEN: {
    customEventSchemaId: KissanEventType.NOTIFICATION_POPUP_OPEN,
    customEventSchemaVersion: 1,
    eventType: 'NotificationPopupOpen',
    comment: KissanEventType.NOTIFICATION_POPUP_OPEN,
  },
  NOTIFICATION_POPUP_CLOSE: {
    customEventSchemaId: KissanEventType.NOTIFICATION_POPUP_CLOSE,
    customEventSchemaVersion: 1,
    eventType: 'NotificationPopupClose',
    comment: KissanEventType.NOTIFICATION_POPUP_CLOSE,
  },
  LOCATION_POPUP_OPEN: {
    customEventSchemaId: KissanEventType.LOCATION_POPUP_OPEN,
    customEventSchemaVersion: 1,
    eventType: 'LocationPopupOpen',
    comment: KissanEventType.LOCATION_POPUP_OPEN,
  },
  LOCATION_POPUP_CLOSE: {
    customEventSchemaId: KissanEventType.LOCATION_POPUP_CLOSE,
    customEventSchemaVersion: 1,
    eventType: 'LocationPopupClose',
    comment: KissanEventType.LOCATION_POPUP_CLOSE,
  },
  HOMEPAGE_PULL_TO_REFRESH: {
    customEventSchemaId: KissanEventType.HOMEPAGE_PULL_TO_REFRESH,
    customEventSchemaVersion: 1,
    eventType: 'HomePagePullToRefresh',
    comment: KissanEventType.HOMEPAGE_PULL_TO_REFRESH,
  },
  HOMEPAGE_BANNER_CLICK: {
    customEventSchemaId: KissanEventType.HOMEPAGE_BANNER_CLICK,
    customEventSchemaVersion: 1,
    eventType: 'HomePageBannerClick',
    comment: KissanEventType.HOMEPAGE_BANNER_CLICK,
  },
  PRODUCT_SEARCH_CLICK: {
    customEventSchemaId: KissanEventType.PRODUCT_SEARCH_CLICK,
    customEventSchemaVersion: 1,
    eventType: 'ProductSearchClick',
    comment: KissanEventType.PRODUCT_SEARCH_CLICK,
  },

  RECOMMENDED_PRODUCT_CLICK: {
    customEventSchemaId: KissanEventType.RECOMMENDED_PRODUCT_CLICK,
    customEventSchemaVersion: 1,
    eventType: 'RecommendedProductClick',
    comment: KissanEventType.RECOMMENDED_PRODUCT_CLICK,
  },
  RECOMMENDED_PRODUCT_SCROLL: {
    customEventSchemaId: KissanEventType.RECOMMENDED_PRODUCT_SCROLL,
    customEventSchemaVersion: 1,
    eventType: 'RecommendedProductScroll',
    comment: KissanEventType.RECOMMENDED_PRODUCT_SCROLL,
  },
  SEARCH_TRENDING_VIDEO_CLICK: {
    customEventSchemaId: KissanEventType.SEARCH_TRENDING_VIDEO_CLICK,
    customEventSchemaVersion: 1,
    eventType: 'SearchTrendingVideoClick',
    comment: KissanEventType.SEARCH_TRENDING_VIDEO_CLICK,
  },
  ANSWER_SUBMIT_DIRECT_BOT: {
    customEventSchemaId: KissanEventType.ANSWER_SUBMIT_DIRECT_BOT,
    customEventSchemaVersion: 1,
    eventType: 'AnswerSubmitDirectBot',
    comment: KissanEventType.ANSWER_SUBMIT_DIRECT_BOT,
  },
  ANSWER_SUBMIT_EDITED_BOT: {
    customEventSchemaId: KissanEventType.ANSWER_SUBMIT_EDITED_BOT,
    customEventSchemaVersion: 1,
    eventType: 'AnswerSubmitEditedBot',
    comment: KissanEventType.ANSWER_SUBMIT_EDITED_BOT,
  },

  COURSEDETAIL_LOAD_SUCCESS: {
    customEventSchemaId: KissanEventType.COURSEDETAIL_LOAD_SUCCESS,
    customEventSchemaVersion: 1,
    eventType: 'CourseDetailLoadSucess',
    comment: KissanEventType.COURSEDETAIL_LOAD_SUCCESS,
  },
  PRODUCTDETAIL_LOAD_SUCCESS: {
    customEventSchemaId: KissanEventType.PRODUCTDETAIL_LOAD_SUCCESS,
    customEventSchemaVersion: 1,
    eventType: 'ProductDetailLoadSucess',
    comment: KissanEventType.PRODUCTDETAIL_LOAD_SUCCESS,
  },
  PRODUCTS_BANNER_CLICK: {
    customEventSchemaId: KissanEventType.PRODUCTS_BANNER_CLICK,
    customEventSchemaVersion: 1,
    eventType: 'ProductsBannerClick',
    comment: KissanEventType.PRODUCTS_BANNER_CLICK,
  },

  FAT_FOOTER_CLICK: {
    customEventSchemaId: KissanEventType.FAT_FOOTER_CLICK,
    customEventSchemaVersion: 1,
    eventType: 'FatFooterClick',
    comment: KissanEventType.FAT_FOOTER_CLICK,
  },

  FAT_FOOTER_VIEW: {
    customEventSchemaId: KissanEventType.FAT_FOOTER_VIEW,
    customEventSchemaVersion: 1,
    eventType: 'FatFooterView',
    comment: KissanEventType.FAT_FOOTER_VIEW,
  },
  QNA_ANSWER_VIEWED_MORETHAN_FIVE_SECOND: {
    customEventSchemaId: KissanEventType.QNA_ANSWER_VIEWED_MORETHAN_FIVE_SECOND,
    customEventSchemaVersion: 1,
    eventType: 'QnaAnswerViewedMoreThanFiveSecond',
    feature: KissanEventType.QNA_ANSWER_VIEWED_MORETHAN_FIVE_SECOND,
  },
  HOME_FLOAT_ICON_SEARCH_CLICK: {
    customEventSchemaId: KissanEventType.HOME_FLOAT_ICON_SEARCH_CLICK,
    customEventSchemaVersion: 1,
    eventType: 'HomeFloatIconSearchClick',
    comment: KissanEventType.HOME_FLOAT_ICON_SEARCH_CLICK,
  },

  APP_UPDATE_NORMAL_SUCCESS: {
    customEventSchemaId: KissanEventType.APP_UPDATE_NORMAL_SUCCESS,
    customEventSchemaVersion: 1,
    eventType: 'AppUpdateNormalSuccess',
    feature: KissanEventType.APP_UPDATE_NORMAL_SUCCESS,
  },
  APP_UPDATE_NORMAL_ERROR: {
    customEventSchemaId: KissanEventType.APP_UPDATE_NORMAL_ERROR,
    customEventSchemaVersion: 1,
    eventType: 'AppUpdateNormalError',
    feature: KissanEventType.APP_UPDATE_NORMAL_ERROR,
  },
  APP_UPDATE_FORCE: {
    customEventSchemaId: KissanEventType.APP_UPDATE_FORCE,
    customEventSchemaVersion: 1,
    eventType: 'AppUpdateForce',
    feature: KissanEventType.APP_UPDATE_FORCE,
  },
  AUTOPLAY_VIDEO_FAIL_BEFORE_INTERACTION: {
    customEventSchemaId: KissanEventType.AUTOPLAY_VIDEO_FAIL_BEFORE_INTERACTION,
    customEventSchemaVersion: 1,
    eventType: 'AppUpdateForce',
    feature: KissanEventType.AUTOPLAY_VIDEO_FAIL_BEFORE_INTERACTION,
  },
  AUTOPLAY_VIDEO_FAIL_AFTER_INTERACTION: {
    customEventSchemaId: KissanEventType.AUTOPLAY_VIDEO_FAIL_AFTER_INTERACTION,
    customEventSchemaVersion: 1,
    eventType: 'AppUpdateForce',
    feature: KissanEventType.AUTOPLAY_VIDEO_FAIL_AFTER_INTERACTION,
  },
  PRODUCT_NUDGE_VIEWED_MORETHAN_ONE_SECOND: {
    customEventSchemaId: KissanEventType.PRODUCT_NUDGE_VIEWED_MORETHAN_ONE_SECOND,
    customEventSchemaVersion: 1,
    eventType: 'ProductNudgeViewedMoreThanOneSecond',
    feature: KissanEventType.PRODUCT_NUDGE_VIEWED_MORETHAN_ONE_SECOND,
  },
  AD_SLOT_LOAD_REQUEST: {
    customEventSchemaId: KissanEventType.AD_SLOT_LOAD_REQUEST,
    customEventSchemaVersion: 1,
    eventType: 'AdSlotLoadRequest',
    feature: KissanEventType.AD_SLOT_LOAD_REQUEST,
  },
  WA_AUTOLOGIN_CLICK: {
    customEventSchemaId: KissanEventType.WA_AUTOLOGIN_CLICK,
    customEventSchemaVersion: 1,
    eventType: 'WaAutoLoginClick',
    feature: KissanEventType.WA_AUTOLOGIN_CLICK,
  },
  WA_AUTOLOGIN_REDIRECTED: {
    customEventSchemaId: KissanEventType.WA_AUTOLOGIN_REDIRECTED,
    customEventSchemaVersion: 1,
    eventType: 'WaAutoLoginRedirected',
    feature: KissanEventType.WA_AUTOLOGIN_REDIRECTED,
  },
  CLICK_ON_WRITE_VIDEO_REVIEW: {
    customEventSchemaId: KissanEventType.CLICK_ON_WRITE_VIDEO_REVIEW,
    customEventSchemaVersion: 1,
    eventType: 'ClickOnWriteVideoReview',
    feature: KissanEventType.CLICK_ON_WRITE_VIDEO_REVIEW,
  },
  CLICK_ON_WRITE_REVIEW: {
    customEventSchemaId: KissanEventType.CLICK_ON_WRITE_REVIEW,
    customEventSchemaVersion: 1,
    eventType: 'ClickOnWriteReview',
    feature: KissanEventType.CLICK_ON_WRITE_REVIEW,
  },
  WRITE_REVIEW_BOTTOMSHEET_LOAD_SUCCESS: {
    customEventSchemaId: KissanEventType.WRITE_REVIEW_BOTTOMSHEET_LOAD_SUCCESS,
    customEventSchemaVersion: 1,
    eventType: 'WriteReviewBottomSheetLoadSuccess',
    feature: KissanEventType.WRITE_REVIEW_BOTTOMSHEET_LOAD_SUCCESS,
  },
  PRODUCT_RATED: {
    customEventSchemaId: KissanEventType.PRODUCT_RATED,
    customEventSchemaVersion: 1,
    eventType: 'ProductRated',
    feature: KissanEventType.PRODUCT_RATED,
  },
  PRODUCT_ADD_MEDIA_CLICK: {
    customEventSchemaId: KissanEventType.PRODUCT_ADD_MEDIA_CLICK,
    customEventSchemaVersion: 1,
    eventType: 'ProductAddMediaClick',
    feature: KissanEventType.PRODUCT_ADD_MEDIA_CLICK,
  },
  PRODUCT_UPLOAD_IMAGE: {
    customEventSchemaId: KissanEventType.PRODUCT_UPLOAD_IMAGE,
    customEventSchemaVersion: 1,
    eventType: 'ProductUploadImage',
    feature: KissanEventType.PRODUCT_UPLOAD_IMAGE,
  },
  PRODUCT_IMAGE_UPLOADED: {
    customEventSchemaId: KissanEventType.PRODUCT_IMAGE_UPLOADED,
    customEventSchemaVersion: 1,
    eventType: 'ProductImageUploaded',
    feature: KissanEventType.PRODUCT_IMAGE_UPLOADED,
  },
  PRODUCT_VIDEO_UPLOADED: {
    customEventSchemaId: KissanEventType.PRODUCT_VIDEO_UPLOADED,
    customEventSchemaVersion: 1,
    eventType: 'ProductVideoUploaded',
    feature: KissanEventType.PRODUCT_VIDEO_UPLOADED,
  },
  USER_TYPING_TITLE_REVIEW: {
    customEventSchemaId: KissanEventType.USER_TYPING_TITLE_REVIEW,
    customEventSchemaVersion: 1,
    eventType: 'UserTypingReview',
    feature: KissanEventType.USER_TYPING_TITLE_REVIEW,
  },
  USER_TYPING_DESCRIPTION_REVIEW: {
    customEventSchemaId: KissanEventType.USER_TYPING_DESCRIPTION_REVIEW,
    customEventSchemaVersion: 1,
    eventType: 'UserTypingReview',
    feature: KissanEventType.USER_TYPING_DESCRIPTION_REVIEW,
  },
  REVIEW_SUBMITTED: {
    customEventSchemaId: KissanEventType.REVIEW_SUBMITTED,
    customEventSchemaVersion: 1,
    eventType: 'ReviewSubmitted',
    feature: KissanEventType.REVIEW_SUBMITTED,
  },
  CLICK_ON_REVIEW: {
    customEventSchemaId: KissanEventType.CLICK_ON_REVIEW,
    customEventSchemaVersion: 1,
    eventType: 'ClickOnReview',
    feature: KissanEventType.CLICK_ON_REVIEW,
  },
  VIEWALL_REVIEWS: {
    customEventSchemaId: KissanEventType.VIEWALL_REVIEWS,
    customEventSchemaVersion: 1,
    eventType: 'ViewAllReviews',
    feature: KissanEventType.VIEWALL_REVIEWS,
  },
  VIEWALL_REVIEWS_LOAD_SUCCESS: {
    customEventSchemaId: KissanEventType.VIEWALL_REVIEWS_LOAD_SUCCESS,
    customEventSchemaVersion: 1,
    eventType: 'ViewAllReviewsLoadSuccess',
    feature: KissanEventType.VIEWALL_REVIEWS_LOAD_SUCCESS,
  },
  DATA_VIEWED_MORE_THAN_ONE_SECOND: {
    customEventSchemaId: KissanEventType.DATA_VIEWED_MORE_THAN_ONE_SECOND,
    customEventSchemaVersion: 1,
    eventType: 'ViewAllReviewsLoadSuccess',
    feature: KissanEventType.DATA_VIEWED_MORE_THAN_ONE_SECOND,
  },
  WEB_WIDGET_DETAIL_LOAD: {
    customEventSchemaId: KissanEventType.WEB_WIDGET_DETAIL_LOAD,
    customEventSchemaVersion: 1,
    eventType: 'WebWidgetLoad',
    feature: KissanEventType.WEB_WIDGET_DETAIL_LOAD,
  },
  AUTO_VIDEO_PLAY_PRODUCT_DETAIL: {
    customEventSchemaId: KissanEventType.AUTO_VIDEO_PLAY_PRODUCT_DETAIL,
    customEventSchemaVersion: 1,
    eventType: 'AutoVideoPlayProductDetail',
    feature: KissanEventType.AUTO_VIDEO_PLAY_PRODUCT_DETAIL,
  },
  CALL_ICON_CLICK: {
    customEventSchemaId: KissanEventType.CALL_ICON_CLICK,
    customEventSchemaVersion: 1,
    eventType: 'AutoVideoPlayProductDetail',
    feature: KissanEventType.CALL_ICON_CLICK,
  },
  MY_COURSES_CLICK: {
    customEventSchemaId: KissanEventType.MY_COURSES_CLICK,
    customEventSchemaVersion: 1,
    eventType: 'MyCoursesClick',
    feature: KissanEventType.MY_COURSES_CLICK,
  },
  COMING_SOON_CLICK: {
    customEventSchemaId: KissanEventType.COMING_SOON_CLICK,
    customEventSchemaVersion: 1,
    eventType: 'ComingSoonClick',
    feature: KissanEventType.COMING_SOON_CLICK,
  },
  PDF_VIEW_COURSES_CLICKED: {
    customEventSchemaId: KissanEventType.PDF_VIEW_COURSES_CLICKED,
    customEventSchemaVersion: 1,
    eventType: 'PdfViewCoursesClicked',
    feature: KissanEventType.PDF_VIEW_COURSES_CLICKED,
  },
  PDF_LOADED_SUCCESSFULLY: {
    customEventSchemaId: KissanEventType.PDF_LOADED_SUCCESSFULLY,
    customEventSchemaVersion: 1,
    eventType: 'PdfLoadedSuccessfully',
    feature: KissanEventType.PDF_LOADED_SUCCESSFULLY,
  },
  HOMEPAGE_GAMEZOP_CLICKED: {
    customEventSchemaId: KissanEventType.HOMEPAGE_GAMEZOP_CLICKED,
    customEventSchemaVersion: 1,
    eventType: 'HomePageGamezopClicked',
    feature: KissanEventType.HOMEPAGE_GAMEZOP_CLICKED,
  },
  RATESPAGE_LOAD_SUCCESS: {
    customEventSchemaId: KissanEventType.RATESPAGE_LOAD_SUCCESS,
    customEventSchemaVersion: 1,
    eventType: 'RatesPageLoadSuccess',
    feature: KissanEventType.RATESPAGE_LOAD_SUCCESS,
  },
  RATESPAGE_CTA_CLICK: {
    customEventSchemaId: KissanEventType.RATESPAGE_CTA_CLICK,
    customEventSchemaVersion: 1,
    eventType: 'RatesPageCTAClick',
    feature: KissanEventType.RATESPAGE_CTA_CLICK,
  },
  QNA_BANNER_VIEWED_MORETHAN_ONE_SECOND: {
    customEventSchemaId: KissanEventType.QNA_BANNER_VIEWED_MORETHAN_ONE_SECOND,
    customEventSchemaVersion: 1,
    eventType: 'QnaBannerViewedMorethanOneSecond',
    feature: KissanEventType.QNA_BANNER_VIEWED_MORETHAN_ONE_SECOND,
  },
  AGRINEWSLINK_CLICK: {
    customEventSchemaId: KissanEventType.AGRINEWSLINK_CLICK,
    customEventSchemaVersion: 1,
    eventType: 'AgriNewsLinkClick',
    feature: KissanEventType.AGRINEWSLINK_CLICK,
  },
  AGRINEWS_SEARCH_CLICK: {
    customEventSchemaId: KissanEventType.AGRINEWS_SEARCH_CLICK,
    customEventSchemaVersion: 1,
    eventType: 'AgriNewsSearchClick',
    feature: KissanEventType.AGRINEWS_SEARCH_CLICK,
  },
  AGRINEWS_SEARCH_ITEMS: {
    customEventSchemaId: KissanEventType.AGRINEWS_SEARCH_ITEMS,
    customEventSchemaVersion: 1,
    eventType: 'AgriNewsSearchItems',
    feature: KissanEventType.AGRINEWS_SEARCH_ITEMS,
  },
  AGRINEWS_LOAD_SUCCESS: {
    customEventSchemaId: KissanEventType.AGRINEWS_LOAD_SUCCESS,
    customEventSchemaVersion: 1,
    eventType: 'AgriNewsLoadSuccess',
    feature: KissanEventType.AGRINEWS_LOAD_SUCCESS,
  },
  AGRINEWS_DETAIL_PAGE_LOAD_SUCCESS: {
    customEventSchemaId: KissanEventType.AGRINEWS_DETAIL_PAGE_LOAD_SUCCESS,
    customEventSchemaVersion: 1,
    eventType: 'AgriNewsDetailPageLoadSuccess',
    feature: KissanEventType.AGRINEWS_DETAIL_PAGE_LOAD_SUCCESS,
  },

  AGRINEWS_OPEN_WEB_BROWSER_CLICK: {
    customEventSchemaId: KissanEventType.AGRINEWS_OPEN_WEB_BROWSER_CLICK,
    customEventSchemaVersion: 1,
    eventType: 'AgriNewsOpenWebBrowserClick',
    feature: KissanEventType.AGRINEWS_OPEN_WEB_BROWSER_CLICK,
  },
  DEVOTIONAL_LOAD_SUCCESS: {
    customEventSchemaId: KissanEventType.DEVOTIONAL_LOAD_SUCCESS,
    customEventSchemaVersion: 1,
    eventType: 'DevotionalLoadSuccess',
    feature: KissanEventType.DEVOTIONAL_LOAD_SUCCESS,
  },
  DEVOTIONAL_DETAIL_PAGE_CLICK: {
    customEventSchemaId: KissanEventType.DEVOTIONAL_DETAIL_PAGE_CLICK,
    customEventSchemaVersion: 1,
    eventType: 'DevotionalDetailPageClick',
    feature: KissanEventType.DEVOTIONAL_DETAIL_PAGE_CLICK,
  },
  DEVOTIONAL_SEARCH_CLICK: {
    customEventSchemaId: KissanEventType.DEVOTIONAL_SEARCH_CLICK,
    customEventSchemaVersion: 1,
    eventType: 'DevotionalSearchClick',
    feature: KissanEventType.DEVOTIONAL_SEARCH_CLICK,
  },
  DEVOTIONAL_SEARCH_ITEMS: {
    customEventSchemaId: KissanEventType.DEVOTIONAL_SEARCH_ITEMS,
    customEventSchemaVersion: 1,
    eventType: 'DevotionalSearchItems',
    feature: KissanEventType.DEVOTIONAL_SEARCH_ITEMS,
  },
  DEVOTIONAL_STREAM_LOAD_SUCCESS: {
    customEventSchemaId: KissanEventType.DEVOTIONAL_STREAM_LOAD_SUCCESS,
    customEventSchemaVersion: 1,
    eventType: 'DevotionalStreamLoadSuccess',
    feature: KissanEventType.DEVOTIONAL_STREAM_LOAD_SUCCESS,
  },
  DEVOTIONAL_STREAM_RELATED_VIDEO_CLICKED: {
    customEventSchemaId: KissanEventType.DEVOTIONAL_STREAM_RELATED_VIDEO_CLICKED,
    customEventSchemaVersion: 1,
    eventType: 'DevotionalStreamRelatedVideoClicked',
    feature: KissanEventType.DEVOTIONAL_STREAM_RELATED_VIDEO_CLICKED,
  },
  DEVOTIONAL_SEARCH_SELECT: {
    customEventSchemaId: KissanEventType.DEVOTIONAL_SEARCH_SELECT,
    customEventSchemaVersion: 1,
    eventType: 'DevotionalSearchSelect',
    feature: KissanEventType.DEVOTIONAL_SEARCH_SELECT,
  },
  HOMEPAGE_FEED_IMAGE_CLICKED: {
    customEventSchemaId: KissanEventType.HOMEPAGE_FEED_IMAGE_CLICKED,
    customEventSchemaVersion: 1,
    eventType: 'HomePageFeedImageClicked',
    feature: KissanEventType.HOMEPAGE_FEED_IMAGE_CLICKED,
  },
  AGRINEWS_AUDIO_CLICK: {
    customEventSchemaId: KissanEventType.AGRINEWS_AUDIO_CLICK,
    customEventSchemaVersion: 1,
    eventType: 'AgriNewsAudioClick',
    feature: KissanEventType.AGRINEWS_AUDIO_CLICK,
  },
  AGRINEWS_AUDIO_PLAY: {
    customEventSchemaId: KissanEventType.AGRINEWS_AUDIO_PLAY,
    customEventSchemaVersion: 1,
    eventType: 'AgriNewsAudioPlay',
    feature: KissanEventType.AGRINEWS_AUDIO_PLAY,
  },
  AUTO_PLAY_AUDIO_PLAYONE: {
    customEventSchemaId: KissanEventType.AUTO_PLAY_AUDIO_PLAYONE,
    customEventSchemaVersion: 1,
    eventType: 'AutoPlayAudioPlayone',
    feature: KissanEventType.AUTO_PLAY_AUDIO_PLAYONE,
  },
  AUTO_PLAY_AUDIO_PLAYTWENTY: {
    customEventSchemaId: KissanEventType.AUTO_PLAY_AUDIO_PLAYTWENTY,
    customEventSchemaVersion: 1,
    eventType: 'AutoPlayAudioPlaytwenty',
    feature: KissanEventType.AUTO_PLAY_AUDIO_PLAYTWENTY,
  },
  AUTO_PLAY_AUDIO_PLAYTHIRTY: {
    customEventSchemaId: KissanEventType.AUTO_PLAY_AUDIO_PLAYTHIRTY,
    customEventSchemaVersion: 1,
    eventType: 'AutoPlayAudioPlaythirty',
    feature: KissanEventType.AUTO_PLAY_AUDIO_PLAYTHIRTY,
  },
  AUTO_PLAY_AUDIO_PLAYPROGRESS: {
    customEventSchemaId: KissanEventType.AUTO_PLAY_AUDIO_PLAYPROGRESS,
    customEventSchemaVersion: 1,
    eventType: 'AutoPlayAudioPlayProgress',
    feature: KissanEventType.AUTO_PLAY_AUDIO_PLAYPROGRESS,
  },
  AUDIO_PLAYBACK_COMPLETED: {
    customEventSchemaId: KissanEventType.AUDIO_PLAYBACK_COMPLETED,
    customEventSchemaVersion: 1,
    eventType: 'AutoPlaybackCompleted',
    feature: KissanEventType.AUDIO_PLAYBACK_COMPLETED,
  },
  AGRINEWS_SCROLLED_NEXT: {
    customEventSchemaId: KissanEventType.AGRINEWS_SCROLLED_NEXT,
    customEventSchemaVersion: 1,
    eventType: 'AgrinewsScrolledNext',
    feature: KissanEventType.AGRINEWS_SCROLLED_NEXT,
  },
  AGRINEWS_AUDIO_PAUSE: {
    customEventSchemaId: KissanEventType.AGRINEWS_AUDIO_PAUSE,
    customEventSchemaVersion: 1,
    eventType: 'AgriNewsAudioPause',
    feature: KissanEventType.AGRINEWS_AUDIO_PAUSE,
  },
  DEVOTIONAL_CATEGORY_CLICK: {
    customEventSchemaId: KissanEventType.DEVOTIONAL_CATEGORY_CLICK,
    customEventSchemaVersion: 1,
    eventType: 'DevotionalCategoryClicked',
    feature: KissanEventType.DEVOTIONAL_CATEGORY_CLICK,
  },
  DEVOTIONAL_SUBCATEGORY_CLICK: {
    customEventSchemaId: KissanEventType.DEVOTIONAL_SUBCATEGORY_CLICK,
    customEventSchemaVersion: 1,
    eventType: 'DevotionalSubcategoryClicked',
    feature: KissanEventType.DEVOTIONAL_SUBCATEGORY_CLICK,
  },
  LIVE_CHAT_CLICK: {
    customEventSchemaId: KissanEventType.LIVE_CHAT_CLICK,
    customEventSchemaVersion: 1,
    eventType: 'LiveChatClicked',
    feature: KissanEventType.LIVE_CHAT_CLICK,
  },
  EARN_MORE_COIN_CLICK: {
    customEventSchemaId: KissanEventType.EARN_MORE_COIN_CLICK,
    customEventSchemaVersion: 1,
    eventType: 'EarnMoreCoinClicked',
    feature: KissanEventType.EARN_MORE_COIN_CLICK,
  },

  DEVOTIONAL_PAGE_LOAD_FAILED: {
    customEventSchemaId: KissanEventType.DEVOTIONAL_PAGE_LOAD_FAILED,
    customEventSchemaVersion: 1,
    eventType: 'DevotionalPageLoadFailed',
    feature: KissanEventType.DEVOTIONAL_PAGE_LOAD_FAILED,
  },
  DELIVEUSERS_LOAD_SUCCESS: {
    customEventSchemaId: KissanEventType.DELIVEUSERS_LOAD_SUCCESS,
    customEventSchemaVersion: 1,
    eventType: 'DeliveUsersLoadSuccess',
    feature: KissanEventType.DELIVEUSERS_LOAD_SUCCESS,
  },
  DELIVECHAT_LOAD_SUCCESS: {
    customEventSchemaId: KissanEventType.DELIVECHAT_LOAD_SUCCESS,
    customEventSchemaVersion: 1,
    eventType: 'DeliveChatLoadSuccess',
    feature: KissanEventType.DELIVECHAT_LOAD_SUCCESS,
  },
  CATEGORY_OR_SUBCATEGORY_ACTION_SUCCESS: {
    customEventSchemaId: KissanEventType.CATEGORY_OR_SUBCATEGORY_ACTION_SUCCESS,
    customEventSchemaVersion: 1,
    eventType: 'CategoryOrSubcategoryActionSuccess',
    feature: KissanEventType.CATEGORY_OR_SUBCATEGORY_ACTION_SUCCESS,
  },
  CHAT_TYPE_START: {
    customEventSchemaId: KissanEventType.CHAT_TYPE_START,
    customEventSchemaVersion: 1,
    eventType: 'ChatTypeStart',
    feature: KissanEventType.CHAT_TYPE_START,
  },
  CHAT_TYPE_ENDS: {
    customEventSchemaId: KissanEventType.CHAT_TYPE_ENDS,
    customEventSchemaVersion: 1,
    eventType: 'ChatTypeEnds',
    feature: KissanEventType.CHAT_TYPE_ENDS,
  },
  CHAT_CLICK_SUCCESS: {
    customEventSchemaId: KissanEventType.CHAT_CLICK_SUCCESS,
    customEventSchemaVersion: 1,
    eventType: 'ChatClickSuccess',
    feature: KissanEventType.CHAT_CLICK_SUCCESS,
  },
  DECOIN_LOAD_SUCCESS: {
    customEventSchemaId: KissanEventType.DECOIN_LOAD_SUCCESS,
    customEventSchemaVersion: 1,
    eventType: 'DecoinLoadSuccess',
    feature: KissanEventType.DECOIN_LOAD_SUCCESS,
  },
  DEPAGE_SCROLL: {
    customEventSchemaId: KissanEventType.DEPAGE_SCROLL,
    customEventSchemaVersion: 1,
    eventType: 'DePageScroll',
    feature: KissanEventType.DEPAGE_SCROLL,
  },
  LIVE_CHAT_SCROLL_TOP: {
    customEventSchemaId: KissanEventType.LIVE_CHAT_SCROLL_TOP,
    customEventSchemaVersion: 1,
    eventType: 'LiveChatScrollTop',
    feature: KissanEventType.LIVE_CHAT_SCROLL_TOP,
  },
  LIVE_CHAT_SCROLL_END: {
    customEventSchemaId: KissanEventType.LIVE_CHAT_SCROLL_END,
    customEventSchemaVersion: 1,
    eventType: 'LiveChatScrollEnd',
    feature: KissanEventType.LIVE_CHAT_SCROLL_END,
  },
  DEVOTIONAL_PARTICIPANT_CHAT_JOIN_CLICK: {
    customEventSchemaId: KissanEventType.DEVOTIONAL_PARTICIPANT_CHAT_JOIN_CLICK,
    customEventSchemaVersion: 1,
    eventType: 'DevotionalParticipantChatJoinClick',
    feature: KissanEventType.DEVOTIONAL_PARTICIPANT_CHAT_JOIN_CLICK,
  },
  DEVOTIONAL_MOD_TAB_MINIMIZE: {
    customEventSchemaId: KissanEventType.DEVOTIONAL_MOD_TAB_MINIMIZE,
    customEventSchemaVersion: 1,
    eventType: 'DevotionalModTabMinimize',
    feature: KissanEventType.DEVOTIONAL_MOD_TAB_MINIMIZE,
  },
  DEVOTIONAL_MOD_TAB_EXPAND: {
    customEventSchemaId: KissanEventType.DEVOTIONAL_MOD_TAB_EXPAND,
    customEventSchemaVersion: 1,
    eventType: 'DevotionalModTabExpand',
    feature: KissanEventType.DEVOTIONAL_MOD_TAB_EXPAND,
  },
  NEWS_SCROLLED_NEXT: {
    customEventSchemaId: KissanEventType.NEWS_SCROLLED_NEXT,
    customEventSchemaVersion: 1,
    eventType: 'AgriNewsScrolledNext',
    feature: KissanEventType.NEWS_SCROLLED_NEXT,
  },
  AGRINEWS_AUDIO_TAB_PAUSE: {
    customEventSchemaId: KissanEventType.AGRINEWS_AUDIO_TAB_PAUSE,
    customEventSchemaVersion: 1,
    eventType: 'AgriNewsAudioTabPause',
    feature: KissanEventType.AGRINEWS_AUDIO_TAB_PAUSE,
  },
  DEVOTIONAL_AUDIO_PLAY_ERROR: {
    customEventSchemaId: KissanEventType.DEVOTIONAL_AUDIO_PLAY_ERROR,
    customEventSchemaVersion: 1,
    eventType: 'DevotionalAudioPlayError',
    feature: KissanEventType.DEVOTIONAL_AUDIO_PLAY_ERROR,
  },
  DEVOTIONAL_AUDIO_PLAY_SUCCESS: {
    customEventSchemaId: KissanEventType.DEVOTIONAL_AUDIO_PLAY_SUCCESS,
    customEventSchemaVersion: 1,
    eventType: 'DevotionalAudioPlaySuccess',
    feature: KissanEventType.DEVOTIONAL_AUDIO_PLAY_SUCCESS,
  },

  DEVOTIONAL_ANIMATED_LOOP: {
    customEventSchemaId: KissanEventType.DEVOTIONAL_ANIMATED_LOOP,
    customEventSchemaVersion: 1,
    eventType: 'DevotionalAnimatedLoop',
    feature: KissanEventType.DEVOTIONAL_ANIMATED_LOOP,
  },

  DEVOTIONAL_ANIMATED_END: {
    customEventSchemaId: KissanEventType.DEVOTIONAL_ANIMATED_END,
    customEventSchemaVersion: 1,
    eventType: 'DevotionalAnimatedEnd',
    feature: KissanEventType.DEVOTIONAL_ANIMATED_END,
  },
  DEVOTIONAL_ANIMATED_START: {
    customEventSchemaId: KissanEventType.DEVOTIONAL_ANIMATED_START,
    customEventSchemaVersion: 1,
    eventType: 'DevotionalAnimatedStart',
    feature: KissanEventType.DEVOTIONAL_ANIMATED_START,
  },
  DEVOTIONAL_ANIMATED_ERROR: {
    customEventSchemaId: KissanEventType.DEVOTIONAL_ANIMATED_ERROR,
    customEventSchemaVersion: 1,
    eventType: 'DevotionalAnimatedError',
    feature: KissanEventType.DEVOTIONAL_ANIMATED_ERROR,
  },
  DEVOTIONAL_CATEGORY_CHECKED: {
    customEventSchemaId: KissanEventType.DEVOTIONAL_CATEGORY_CHECKED,
    customEventSchemaVersion: 1,
    eventType: 'DevotionalCategoryChecked',
    feature: KissanEventType.DEVOTIONAL_CATEGORY_CHECKED,
  },

  DEVOTIONAL_CATEGORY_UNCHECKED: {
    customEventSchemaId: KissanEventType.DEVOTIONAL_CATEGORY_UNCHECKED,
    customEventSchemaVersion: 1,
    eventType: 'DevotionalCategoryUnchecked',
    feature: KissanEventType.DEVOTIONAL_CATEGORY_UNCHECKED,
  },
  CHAT_PARTICIPANT_BLOCKED: {
    customEventSchemaId: KissanEventType.CHAT_PARTICIPANT_BLOCKED,
    customEventSchemaVersion: 1,
    eventType: 'ChatParticipantBlocked',
    feature: KissanEventType.CHAT_PARTICIPANT_BLOCKED,
  },
  MODERATOR_LEFT_CHAT: {
    customEventSchemaId: KissanEventType.MODERATOR_LEFT_CHAT,
    customEventSchemaVersion: 1,
    eventType: 'ModeratorLeftChat',
    feature: KissanEventType.MODERATOR_LEFT_CHAT,
  },
  LIVECHAT_USER_DISCONNECTED: {
    customEventSchemaId: KissanEventType.LIVECHAT_USER_DISCONNECTED,
    customEventSchemaVersion: 1,
    eventType: 'LiveChatUserDisconnected',
    feature: KissanEventType.LIVECHAT_USER_DISCONNECTED,
  },
  ITEM_SHARED_SUCCESSFULLY: {
    customEventSchemaId: KissanEventType.ITEM_SHARED_SUCCESSFULLY,
    customEventSchemaVersion: 1,
    eventType: 'ItemSharedSuccessFully',
    feature: KissanEventType.ITEM_SHARED_SUCCESSFULLY,
  },
  ITEM_SHARED_FAILED: {
    customEventSchemaId: KissanEventType.ITEM_SHARED_FAILED,
    customEventSchemaVersion: 1,
    eventType: 'ItemSharedFailed',
    feature: KissanEventType.ITEM_SHARED_FAILED,
  },
  PRODUCT_SHARE_SUCCESS: {
    customEventSchemaId: KissanEventType.PRODUCT_SHARE_SUCCESS,
    customEventSchemaVersion: 1,
    eventType: 'ProductSharedSuccess',
    feature: KissanEventType.PRODUCT_SHARE_SUCCESS,
  },
  PRODUCT_SHARE_FAILED: {
    customEventSchemaId: KissanEventType.PRODUCT_SHARE_FAILED,
    customEventSchemaVersion: 1,
    eventType: 'ProductSharedFailed',
    feature: KissanEventType.PRODUCT_SHARE_FAILED,
  },
  MODERATOR_JOINED_LIVECHAT: {
    customEventSchemaId: KissanEventType.MODERATOR_JOINED_LIVECHAT,
    customEventSchemaVersion: 1,
    eventType: 'ModeratorJoinedLivechat',
    feature: KissanEventType.MODERATOR_JOINED_LIVECHAT,
  },
  PLAYSTORE_DOWNLOAD_CLICK: {
    customEventSchemaId: KissanEventType.PLAYSTORE_DOWNLOAD_CLICK,
    customEventSchemaVersion: 1,
    eventType: 'PlaystoreDownloadClick',
    feature: KissanEventType.PLAYSTORE_DOWNLOAD_CLICK,
  },
    PODCAST_PLAY: {
    customEventSchemaId: KissanEventType.PODCAST_PLAY,
    customEventSchemaVersion: 1,
    eventType: 'PodCastPlay',
    feature: KissanEventType.PODCAST_PLAY,
  },
    PODCAST_PAUSE: {
    customEventSchemaId: KissanEventType.PODCAST_PAUSE,
    customEventSchemaVersion: 1,
    eventType: 'PodCastPause',
    feature: KissanEventType.PODCAST_PAUSE,
  },
   PODCAST_COMPLETED: {
    customEventSchemaId: KissanEventType.PODCAST_COMPLETED,
    customEventSchemaVersion: 1,
    eventType: 'PodCastCompleted',
    feature: KissanEventType.PODCAST_COMPLETED,
  },

  FIRST_OPEN: undefined,
  INSTALL_REFERRER: undefined,
  TRACK_UTM_PARAMETERS_USING_INSTALL_REFER_INTENT: undefined,
  LANGUAGE: undefined,
  A_PAGE_OPENS_WHERE_THE_USER_IS_ASKED_TO_SELECTED_LANGUAGE: undefined,
  USER_CLICKS_ON_THE_PREFERRED_LANGUAGE: undefined,
  LANGUAGE_SELECTED_CORRECTLY: undefined,
  SIGN_IN: undefined,
  SIGN_IN_PROCESS_STARTS: undefined,
  USER_CLICKS_ON_THE_PHONE_NUMBER_BOX: undefined,
  USER_MOVES_TO_OTP_PAGE: undefined,
  TO_VIEW_THE_PRIVACY_POLICY: undefined,
  OTP_REQUEST_WILL_BE_SENT_FROM_THE_USERS_SIDE: undefined,
  RECEIVED_SUCCESSFULLY: undefined,
  USER_ENTERS_SIX_DIGIT_OTP_ENTERED: undefined,
  LOGIN_SUCCESS: undefined,
  WHEN_LOGIN_FAILS_DUE_TO_OTP_ERRORS: undefined,
  USER_CLICKS_ON_RESEND_OTP: undefined,
  OTP_IS_AUTODETECTED_FROM_MESSAGES_AND_FILLED_UP: undefined,
  USER_IS_LANDED_IN_HOMEPAGE_AFTER_THE_SIGNUP: undefined,
  IN_FEED_PAGE_REELS_ARE_PRESENT_IN_HORIZONTAL_ORDER_WHICH_NEEDS_TO_BE_SCROLLED: undefined,
  FEED_REELS: undefined,
  THE_NUMBER_OF_PAGES_REELS_SCROLLED_BY_THE_USER_IS_SHOWN_HORIZONTALLY: undefined,
  THE_NUMBER_OF_PAGES_REELS_SCROLLED_BY_THE_USER_IS_SHOWN_VERTICALLS: undefined,
  IN_FEED_PAGE_REELS_ARE_PRESENT_IN_VERTICAL_ORDER_WHICH_SCROLLED_AND_REACHED_END: undefined,
  VERTICAL_VIDEO_SCROLL_REACHED_FIRST_VIDEO: undefined,
  WHEN_REELS_ARE_PLAYED: undefined,
  WHEN_REELS_ARE_PAUSED: undefined,
  WHEN_REELS_DONOT_PLAY_DUE_TO_SOME_REASON: undefined,
  WHEN_VERTICAL_SCROLL_FOR_THE_VIDEO_IS_DONE: undefined,
  FEED_VIDEO: undefined,
  USER_CAN_SCROLL_THROUGH_THE_DIFFERENT_SECTIONS_PAGES_FEED_DISCOVERY_HOME_ETC_THROUGH_THE_BOTTOM_NAV:
    undefined,
  SCREEN_NAVIGATE: undefined,
  VIDEO_READY_TO_PLAY: undefined,
  VIDEO_IS_PLAYED: undefined,
  VIDEO_IS_PAUSED: undefined,
  RELATED_VIDEO_OR_RECOMMENDATIONS_OF_THE_VIDEO_IS_CLICKED_BY_THE_USER: undefined,
  VIDEO_FAILS_TO_PLAY: undefined,
  ONCE_THE_WHOLE_VIDEO_IS_PLAYED_AND_CLOSED: undefined,
  FEED_ITEM: undefined,
  WHEN_USER_CLICKS_ON_THE_ITEM_ON_FEED_PAGE: undefined,
  WHEN_USER_CLICKS_ON_THE_ICON_LIKE_ON_FEED_PAGE: undefined,
  WHEN_USER_CLICKS_ON_THE_ICON_COMMENT_ON_FEED_PAGE: undefined,
  WHEN_USER_CLICKS_ON_THE_ICON_SHARE_ON_FEED_PAGE: undefined,
  WHEN_USER_CLICKS_ON_THE_ICON_REPORT_ON_FEED_PAGE: undefined,
  WHEN_USER_CLICKS_ON_THE_PROFILE_ICON_IN_HIS_PROFILE: undefined,
  PROFILE: undefined,
  WHEN_THE_NAME_OF_THE_USER_ON_THE_POST_IS_CLICKED_TO_VIEW_HIS_PROFILE: undefined,
  USER_CLICKS_ON_THE_NOTIFICATION_ICON: undefined,
  ALL_PAGES: undefined,
  PAGE_SCROLL_FAILS: undefined,
  WHEN_THE_PAGE_FAILS_TO_SCROLL_OR_LOAD: undefined,
  WHEN_A_USER_CLICKS_ON_BACK_PRESS_WHAT_PAGE_DOES_EACH_OF_IT_LAND_AT: undefined,
  PUSH_NOTIFICATION_FAILURE_BACKEND: undefined,
  WHEN_PUSH_NOTIFICATION_DELIVERY_FAILS_WITH_APP_UNINSTALLED_STATUS: undefined,
  WHEN_USER_CLICKS_ON_THE_ICON_DISLIKE_ON_FEED_PAGE: undefined,
  REELS_SCROLL_VERTICAL: undefined,
  CLICK_ON_POST_BUTTON_ON_TOP_RIGHT: undefined,
  NEXT_PAGE_OPENS_FOR_ADDING_CONTENT: undefined,
  THE_USER_CLICK_ON_POST_AT_END_OF_BOX: undefined,
  THE_USER_CHOOSE_CREATE_POST_OPTION_AT_THE_HOMEPAGE: undefined,
  AUTO_PLAY_VIDEO_IS_PLAYED: undefined,
  AUTO_PLAY_VIDEO_READY_TO_PLAY: undefined,
  AUTO_PLAY_ONCE_THE_WHOLE_VIDEO_IS_PLAYED_AND_CLOSED: undefined,
  FEED_USER_CLICKS_ON_THE_PREFERRED_LANGUAGE: undefined,
  FEED_LANGUAGE_SELECTED_CORRECTLY: undefined,
};
